export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: number; output: number };
  ISODate: { input: string; output: string };
  JSONString: { input: string; output: string };
};

/** Account information for a user */
export type Account = {
  /** The user's billing market. */
  billingMarket?: Maybe<Scalars['String']['output']>;
  /** The user's billing country. */
  billingMarketCountry?: Maybe<Scalars['String']['output']>;
  /** The user's market */
  market?: Maybe<Scalars['String']['output']>;
  /** The user's country */
  marketCountry?: Maybe<Scalars['String']['output']>;
  /** User name for the account */
  username?: Maybe<Scalars['String']['output']>;
  /** UUID of the user */
  uuid: Scalars['ID']['output'];
};

/** Active filter definition */
export type ActiveFilterInput = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for addManualLabelInfo mutation */
export type AddManualLabelInfoInput = {
  /** Carrier */
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** Commercial Invoice - in base64 (optional) */
  commercialInvoiceDocument?: InputMaybe<Scalars['String']['input']>;
  /** Expected Delivery Date */
  deliveryDate?: InputMaybe<Scalars['ISODate']['input']>;
  /** Label Type */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Shipment Items */
  items?: InputMaybe<Array<InputMaybe<ShipmentItemInput>>>;
  /** Label Document - in base64 (optional) */
  shippingLabelDocument?: InputMaybe<Scalars['String']['input']>;
  /** Tracking Number */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the add manual label info mutation */
export type AddManualLabelInfoResponse = {
  /** The message returned by the mutation */
  message?: Maybe<Scalars['String']['output']>;
  /** The result of the mutation */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Contains the details of an address in a simplified/standard form */
export type Address = {
  /** Main line of address */
  address1?: Maybe<Scalars['String']['output']>;
  /** Apt, Unit, Etc */
  address2?: Maybe<Scalars['String']['output']>;
  /** City of address */
  city?: Maybe<Scalars['String']['output']>;
  /** Country Code of address */
  country?: Maybe<Scalars['String']['output']>;
  /** First Name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last Name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone Number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Zip/Postal of address */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Region/State/Province of address */
  region?: Maybe<Scalars['String']['output']>;
};

export type AddressAuditHistoryEntry = {
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Name of the company */
  company?: Maybe<Scalars['String']['output']>;
  /** 2 letter ISO country code */
  country?: Maybe<Scalars['String']['output']>;
  /** When the address was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Zip/Postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Region/State/Province */
  region?: Maybe<Scalars['String']['output']>;
  /** Street name and number */
  street?: Maybe<Scalars['String']['output']>;
  /** Telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** When the change was made */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** The error for an address field */
export type AddressFieldError = {
  /** The key of the address field the error is associated with */
  key?: Maybe<Scalars['String']['output']>;
  /** The error message for the given address field */
  message?: Maybe<Scalars['String']['output']>;
};

/** Additional information associated with an address form field */
export type AddressFieldMetaData = {
  /** The list of selectable options the field has (e.g. US States) */
  fieldOptions?: Maybe<Array<Maybe<AddressFieldOption>>>;
  /** The list of validations the field must adhere to */
  validations?: Maybe<Array<Maybe<AddressFieldValidation>>>;
};

/** A selectable option for an address form field */
export type AddressFieldOption = {
  /** The key for the option (e.g. MI) */
  key?: Maybe<Scalars['String']['output']>;
  /** The display name for the option (e.g. Michigan) */
  name?: Maybe<Scalars['String']['output']>;
};

/** A validation definition for an address form field */
export type AddressFieldValidation = {
  /** A message to be shown to describe the pattern */
  message?: Maybe<Scalars['String']['output']>;
  /** The regular expression pattern */
  pattern?: Maybe<Scalars['String']['output']>;
  /** The pattern matching style to be used when evaluating the 'pattern' */
  patternMatchingStyle?: Maybe<AddressFieldValidationPatternMatchingStyle>;
};

/** A pattern matching style used for form field validation */
export enum AddressFieldValidationPatternMatchingStyle {
  /** Matching style indicating the pattern much match for validation to be successful */
  MUST_MATCH_PATTERN = 'MUST_MATCH_PATTERN',
  /** Matching style indicating the pattern must explicitly not match for validation to be successful */
  MUST_NOT_MATCH_PATTERN = 'MUST_NOT_MATCH_PATTERN',
}

/** The address form definition */
export type AddressForm = {
  /** The rows associated with the address form */
  rows?: Maybe<Array<Maybe<AddressFormRow>>>;
};

/** The address form field */
export type AddressFormField = {
  /** Flag indicating whether the field is required in order to save the address */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The key for the field (e.g. last_name) */
  key?: Maybe<Scalars['String']['output']>;
  /** The label for the field (e.g. City) */
  label?: Maybe<Scalars['String']['output']>;
  /** Additional properties associated with the field */
  meta?: Maybe<AddressFieldMetaData>;
  /** The placeholder for this field (e.g. Detroit) */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** The address form row */
export type AddressFormRow = {
  /** The fields defined for a given row */
  fields?: Maybe<Array<Maybe<AddressFormField>>>;
};

export type AddressInput = {
  /** Country Code of address */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Country name */
  countryName?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The customer's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The customer's locality/city */
  locality?: InputMaybe<Scalars['String']['input']>;
  /** Phone Number Field For Address */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Zip/Postal of address */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Region/State/Province of address */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Main line of address */
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  /** Apt, Unit, Etc */
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

/** The address type */
export enum AddressType {
  BILLING = 'BILLING',
  SHIPPING = 'SHIPPING',
}

export type Adjustment = {
  /** Amount of the price adjustment */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Name of the fee, mapped to pricing's translationKey */
  name?: Maybe<Scalars['String']['output']>;
  /** Fee percentage of the ask amount */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Descriptive text for the adjustment fee */
  text?: Maybe<Scalars['String']['output']>;
};

/** Adyen Payment Provider */
export type AdyenPaymentProvider = PaymentProvider & {
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
};

/** Adyen Client Authorization  */
export type AdyenProviderClientToken = PaymentProviderToken & {
  /** PSP provider client authorization key */
  paymentClientProviderToken?: Maybe<Scalars['String']['output']>;
  /** environment value to initialize PSP SDK */
  providerEnv?: Maybe<Scalars['String']['output']>;
  /** regionUrl to initialize SDK */
  regionUrl?: Maybe<Scalars['String']['output']>;
};

/** Seller profile historical aggregates */
export type Aggregates = {
  /** Historical Monthly Aggregates */
  monthlyAggregations?: Maybe<Array<Maybe<MonthlyAggregate>>>;
  /** Historical Quaterly Aggregates */
  quarterlyAggregations?: Maybe<Array<Maybe<QuarterlyAggregate>>>;
};

/** Information around the page requested for all products */
export type AllProductPageInput = {
  /** Number of items in a page */
  limit: Scalars['Int']['input'];
  /** What page are you selecting */
  page: Scalars['Int']['input'];
};

/** An type used to pass a set of filters into the allProducts query */
export type AllProductsFilters = {
  /** Filters products by vertical */
  vertical?: InputMaybe<AllProductsVerticalFilter>;
};

/** Filters products by vertical */
export type AllProductsVerticalFilter = {
  /** Vertical of the product. */
  is?: InputMaybe<Vertical>;
};

/** Amount */
export type Amount = {
  /** currencyCode */
  currencyCode?: Maybe<CurrencyCode>;
  /** value */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Amount Input */
export type AmountInput = {
  /** currencyCode */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** value */
  value: Scalars['Float']['input'];
};

/** Amount of each variant */
export type AmountVariantInput = {
  /** currencyCode */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** value */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Statistics based off of market events captured over the last year. */
export type AnnualStatistics = {
  /** The highest price observed in the past year for a sale. */
  annualHigh?: Maybe<Scalars['BigInt']['output']>;
  /** The lowest price observed in the past year for a sale. */
  annualLow?: Maybe<Scalars['BigInt']['output']>;
  /** The average price a sale occurred at. */
  averagePrice?: Maybe<Scalars['BigInt']['output']>;
  /** The premium users are paying on average compared to the retail price. */
  pricePremium?: Maybe<Scalars['Float']['output']>;
  /** The high end range the price was sold at over the past year. */
  rangeHigh?: Maybe<Scalars['BigInt']['output']>;
  /** The low end range the price was sold at over the past year. */
  rangeLow?: Maybe<Scalars['BigInt']['output']>;
  /** The number of sales that have occurred in the past year. */
  salesCount?: Maybe<Scalars['Int']['output']>;
  /** The total amount of dollars accumulated from the sales over the past year. */
  totalDollars?: Maybe<Scalars['BigInt']['output']>;
  /** The amount of volatility in price over the past year. */
  volatility?: Maybe<Scalars['Float']['output']>;
};

/** Sort a list in either ascending or descending order */
export enum AscDescOrderInput {
  /** Ascending */
  ASC = 'ASC',
  /** Descending */
  DESC = 'DESC',
}

/** A representation of what a seller is trying to sell or has already sold */
export type Ask = {
  /** The asking price for the product */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The ID of the authentication center the ask should be shipped to */
  authCenter?: Maybe<Scalars['ID']['output']>;
  /** Spread between user's ask and the highest bid in the market. */
  bidAskSpread?: Maybe<Scalars['Int']['output']>;
  /** When the ask was created */
  created?: Maybe<Scalars['ISODate']['output']>;
  /** Current currency that the ask being represented in */
  currentCurrency?: Maybe<CurrencyCode>;
  /** The date that this ask must be shipped by if matched with a bid */
  dateToShipBy?: Maybe<Scalars['ISODate']['output']>;
  /** When the ask expires */
  expires?: Maybe<Scalars['ISODate']['output']>;
  /** The ID of an ask, which is a chainID */
  id: Scalars['String']['output'];
  /** Inventory type for the ask */
  inventoryType?: Maybe<InventoryType>;
  /** The ID of the corresponding listing */
  listingId?: Maybe<Scalars['String']['output']>;
  /** Customer friendly representation of an ask and bid match */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Original currency the ask was placed in */
  originalCurrency?: Maybe<CurrencyCode>;
  /** Payout fields for the current ask */
  payout?: Maybe<Payout>;
  /** The date the seller was payed out for the sale. */
  payoutDate?: Maybe<Scalars['ISODate']['output']>;
  pricingGuidance?: Maybe<PricingGuidance>;
  /** Product variant associated with the ask */
  productVariant?: Maybe<Variant>;
  /** Whether or not the Ask was Quick Shipped (ie counted toward the Quick Ship Bonus). */
  quickShipped?: Maybe<Scalars['Boolean']['output']>;
  /** Associated shipping information */
  shipment?: Maybe<Shipment>;
  /** Associated shippiment UUID */
  shipmentUuid?: Maybe<Scalars['String']['output']>;
  /** A boolean value indicating if the user already requested a shipping extension for the ask */
  shippingExtensionRequested?: Maybe<Scalars['Boolean']['output']>;
  /** Date of sale */
  soldOn?: Maybe<Scalars['String']['output']>;
  /** Current state of the Ask */
  state?: Maybe<Scalars['Int']['output']>;
  /** When the ask was last updated */
  updated?: Maybe<Scalars['ISODate']['output']>;
  /** ID of associated product variant */
  variantID?: Maybe<Scalars['String']['output']>;
};

/** A representation of what a seller is trying to sell or has already sold */
export type AskPricingGuidanceArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
};

/** Additional Context if the Ask is meant to Match */
export enum AskActionContext {
  /** Seller intends Ask to be listed */
  ASK = 'ASK',
  /** Seller intends Ask to match */
  SELL = 'SELL',
}

/** Input for createAsk mutation */
export type AskCreateInput = {
  /** Context if this Ask is expected to match */
  actionContext?: InputMaybe<AskActionContext>;
  /** The asking price for the product */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Chosen currency. Defaults to USD */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** Discount code */
  discountCode?: InputMaybe<Scalars['String']['input']>;
  /** When the ask expires */
  expires?: InputMaybe<Scalars['ISODate']['input']>;
  /** ChainID of Match Candidate if applicable */
  matchCandidateId?: InputMaybe<Scalars['String']['input']>;
  /** Product id */
  skuUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Payload containing the created ask */
export type AskCreatePayload = {
  /** The created ask */
  ask?: Maybe<Ask>;
};

/** If specified will return pending asks that should be shipped earlier or later than specified date. */
export type AskDateToShipFilterInput = {
  /** Later than */
  gt?: InputMaybe<Scalars['ISODate']['input']>;
  /** Later than or equal. */
  gte?: InputMaybe<Scalars['ISODate']['input']>;
  /** Earlier than */
  lt?: InputMaybe<Scalars['ISODate']['input']>;
  /** Earlier than or equal. */
  lte?: InputMaybe<Scalars['ISODate']['input']>;
};

/** Input for deleteAsk mutation */
export type AskDeleteInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Payload containing the single deleted ask */
export type AskDeletePayload = {
  /** The deleted ask */
  ask?: Maybe<Ask>;
};

export type AskInventortyTypeFilterInput = {
  /** Type of inventory. If specified will return asks of a specific inventory. */
  in?: InputMaybe<Array<InputMaybe<InventoryType>>>;
};

export type AskProductIdsFilter = {
  /** IDs of the products. If specified will return asks of a specific products. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filter for returning asks of a specific shipment uuid. */
export type AskShipmentIdsFilter = {
  /** Uuids of the shipments. If specified will return asks of a specific shipment. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AskStatesListFilter = {
  /** List of the states. If specified will return asks of a specific states. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Input for updateAsk mutation */
export type AskUpdateInput = {
  /** Context if this Ask is expected to match */
  actionContext?: InputMaybe<AskActionContext>;
  /** The asking price for the product */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Currency of the price */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** When the ask expires */
  expires?: InputMaybe<Scalars['ISODate']['input']>;
  /** The ID of an ask, which is a chainID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ChainID of Match Candidate if applicable */
  matchCandidateId?: InputMaybe<Scalars['String']['input']>;
};

/** Payload containing the single updated ask */
export type AskUpdatePayload = {
  /** The updated ask */
  ask?: Maybe<Ask>;
};

/** Filter for returning asks of a specific variant id. */
export type AskVariantIdsFilter = {
  /** IDs of the variants. If specified will return asks of a specific variant. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AskVerticalsFilter = {
  /** Verticals of the products. If specified will return asks of a specific verticals. */
  in?: InputMaybe<Array<Vertical>>;
};

/** A connection to an Ask */
export type AsksConnection = {
  /** Edges to a list of products the user is selling or has sold */
  edges?: Maybe<Array<Maybe<AsksEdge>>>;
  /** Information about the current page in the pagination */
  pageInfo?: Maybe<PageInfo>;
};

/** Input for createAsks mutation */
export type AsksCreateInput = {
  /** Asks data to create */
  items?: InputMaybe<Array<InputMaybe<BulkCreateAskInput>>>;
};

/** Payload containing the result of the createAsks mutation */
export type AsksCreatePayload = {
  /** Whether the ask creation was successful */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for deleteAsks mutation */
export type AsksDeleteInput = {
  /** Asks data to delete */
  items?: InputMaybe<Array<InputMaybe<BulkDeleteAskInput>>>;
};

/** Payload containing the bulk deleted ask */
export type AsksDeletePayload = {
  /** The bulk deleted asks */
  result?: Maybe<Scalars['String']['output']>;
};

/** An edge to an Ask */
export type AsksEdge = {
  /** What the user is selling or has sold */
  node?: Maybe<Ask>;
};

/** Filter for expired asks. */
export type AsksExpiredFilter = {
  /** If true, will include only expired asks, false will include only un-expired asks. */
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AsksFiltersInput = {
  /** Filter asks by shipBy attribute. */
  dateToShip?: InputMaybe<AskDateToShipFilterInput>;
  /** Days listed filter. If specified will return asks that matches input of days listed. */
  daysListed?: InputMaybe<NumericIntFilter>;
  /** Filter expired asks. */
  expired?: InputMaybe<AsksExpiredFilter>;
  /** Filter asks for items contained in bulk shipments. */
  includeBulkShipmentItems?: InputMaybe<IncludeBulkShipmentItemsFilter>;
  /** Filter asks by inventory type. */
  inventoryType?: InputMaybe<AskInventortyTypeFilterInput>;
  /** Filter asks with the lowest price. */
  lowestAsk?: InputMaybe<LowestAskFilter>;
  /** Filter asks by product ids */
  productId?: InputMaybe<AskProductIdsFilter>;
  /** Filter asks by shipment uuids */
  shipmentId?: InputMaybe<AskShipmentIdsFilter>;
  /** Spread filter. If specified will return asks that matches input of spread. */
  spread?: InputMaybe<NumericIntFilter>;
  /** Filter asks by states list */
  statesList?: InputMaybe<AskStatesListFilter>;
  /** Filter asks by variant ids */
  variantId?: InputMaybe<AskVariantIdsFilter>;
  /** Filter asks by verticals */
  vertical?: InputMaybe<AskVerticalsFilter>;
};

/** The generalized, coarse-grained state that the ask falls into */
export enum AsksGeneralState {
  /** All possible asks - current, pending and historical */
  ALL = 'ALL',
  /** Current asks are asks that haven't yet been matched or shipped */
  CURRENT = 'CURRENT',
  /** Historical asks are those that happened in the past and aren't current or pending */
  HISTORICAL = 'HISTORICAL',
  /** Pending asks are those that have been matched but haven't been shipped */
  PENDING = 'PENDING',
}

/** Individual ways of sorting a list of asks */
export enum AsksSortInput {
  /** Spread between user's ask and the highest bid in the market. */
  BID_ASK_SPREAD = 'BID_ASK_SPREAD',
  /** Date to ship by */
  DATE_TO_SHIP_BY = 'DATE_TO_SHIP_BY',
  /** When the ask expires */
  EXPIRES = 'EXPIRES',
  /** Highest bid for the user */
  HIGHEST_BID = 'HIGHEST_BID',
  /** Item name */
  ITEM_TITLE = 'ITEM_TITLE',
  /** Date when the ask was listed */
  LISTED_AT = 'LISTED_AT',
  /** Lowest ask for the user */
  LOWEST_ASK = 'LOWEST_ASK',
  /** Date when the ask was matched */
  MATCHED_AT = 'MATCHED_AT',
  /** Ask price */
  PRICE = 'PRICE',
  /** Ask size */
  SIZE = 'SIZE',
  /** State of the ask */
  STATE = 'STATE',
}

/** Input for update mutation */
export type AsksUpdateInput = {
  /** Asks data to update */
  items?: InputMaybe<Array<InputMaybe<BulkUpdateAskInput>>>;
};

/** Payload containing the result of the update mutation */
export type AsksUpdatePayload = {
  /** Whether the ask update was successful */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a authentication (identity) provider information */
export type AuthProvider = {
  /** Email related to authentication provider */
  email?: Maybe<Scalars['String']['output']>;
  /** Authentication provider id */
  id?: Maybe<Scalars['String']['output']>;
  /** Authentication provider type */
  type?: Maybe<Scalars['String']['output']>;
};

/** Badges associated with this product */
export type Badge = {
  /** Badge background color */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The unique badge ID */
  badgeID?: Maybe<Scalars['String']['output']>;
  /** Badge list of contextual key/value pairs */
  context?: Maybe<Array<Maybe<BadgeContext>>>;
  /** Badge icon image */
  icon?: Maybe<ImageInformation>;
  /** Badge subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Badge title */
  title?: Maybe<Scalars['String']['output']>;
  /** Badge tracking event string */
  trackingEvent?: Maybe<Scalars['String']['output']>;
  /** The type of badge. */
  type?: Maybe<BadgeType>;
};

/** Contextual key/value pair(s) */
export type BadgeContext = {
  /** The context object key */
  key?: Maybe<Scalars['String']['output']>;
  /** The context object value */
  value?: Maybe<Scalars['Int']['output']>;
};

/** The types of badges that can be applied to a product. */
export enum BadgeType {
  /** The product is trending/hot/popular. */
  FEATURED = 'FEATURED',
}

/** A single banner */
export type Banner = {
  /**
   * Color of the background to the left
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  backgroundColorLeft?: Maybe<Scalars['String']['output']>;
  /**
   * Color of the background to the right
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  backgroundColorRight?: Maybe<Scalars['String']['output']>;
  /**
   * Link to more left desktop background images
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  desktopBackgroundColorLeft?: Maybe<ImageLink>;
  /**
   * Link to more right desktop background images
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  desktopBackgroundColorRight?: Maybe<ImageLink>;
  /** Desktop image information for the banner */
  desktopImage?: Maybe<ImageInformation>;
  /**
   * Link to more desktop images
   * @deprecated Use desktopImage
   */
  desktopImageUrl?: Maybe<ImageLink>;
  /** Banner Id */
  id?: Maybe<Scalars['String']['output']>;
  /** Link information for the banner */
  link?: Maybe<LinkInformation>;
  /** Mobile image information for the banner */
  mobileImage?: Maybe<ImageInformation>;
  /**
   * Link to more mobile images
   * @deprecated Use mobileImage
   */
  mobileImageUrl?: Maybe<ImageLink>;
  /**
   * Link to more left mobile tiles
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  mobileTileLeft?: Maybe<ImageLink>;
  /**
   * Link to more right mobile images
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  mobileTileRight?: Maybe<ImageLink>;
  /**
   * Page type
   * @deprecated Use link.urlType
   */
  pageType?: Maybe<PageType>;
  /**
   * Right mobile tile image
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  rightMobileTileImage?: Maybe<Scalars['String']['output']>;
  /**
   * Banner title
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * Tracking String
   * @deprecated Use trackingEvent
   */
  trackingAction?: Maybe<Scalars['String']['output']>;
  /** Tracking event information for the banner */
  trackingEvent?: Maybe<Scalars['String']['output']>;
  /**
   * Banner Id
   * @deprecated Use id
   */
  uid?: Maybe<Scalars['String']['output']>;
  /**
   * Link to universal images
   * @deprecated Use link.url
   */
  universalLink?: Maybe<ImageLink>;
  /**
   * Verticals associated with the banner
   * @deprecated No longer supported when fetching a bannerCarousel
   */
  vertical?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A Banner carousel that is composed of banners */
export type BannerCarousel = {
  /** The banners in the banner carousel */
  banners?: Maybe<Array<Maybe<Banner>>>;
  /** The title for the banner carousel */
  title?: Maybe<Scalars['String']['output']>;
};

/** A Banner carousel that is composed of banners */
export type BannerCarouselBannersArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
};

/** Complete banner collage composed of banner collage items */
export type BannerCollage = {
  /** Large image for the banner collage */
  large?: Maybe<BannerCollageItem>;
  /** Small image for the banner collage */
  small?: Maybe<BannerCollageItem>;
  /** The title of the banner collage */
  title?: Maybe<Scalars['String']['output']>;
};

/** Single item to be included in the banner collage */
export type BannerCollageItem = {
  /** The image information for the item */
  image?: Maybe<ImageInformation>;
  /** The url the banner is linking to */
  link?: Maybe<LinkInformation>;
  /** The tracking event label for the item */
  trackingEvent?: Maybe<Scalars['String']['output']>;
};

/** Banner Image Layout */
export type BannerImageLayout = DlpLayout & {
  /** Type of the content */
  contentType?: Maybe<DlpComponentType>;
  /** Banner Image for Desktop */
  desktopImage?: Maybe<ImageFile>;
  /** Flag whether the component is hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Banner Image for Mobile */
  mobileImage?: Maybe<ImageFile>;
  /** Order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** Target Link for the card */
  targetLink?: Maybe<Link>;
  /** Unique title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current component */
  uid?: Maybe<Scalars['String']['output']>;
};

/** Content for the Banner promo flash */
export type BannerPromoFlashContent = PromoFlashContent & {
  /** Color of the background */
  color?: Maybe<Scalars['String']['output']>;
  /** Type of the Promo Flash */
  contentType?: Maybe<PromoFlashType>;
  /** Banner Image for Desktop */
  desktopBannerImage?: Maybe<ImageFile>;
  /** Flag whether to hide this promo flash */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** Banner Image for Mobile */
  mobileBannerImage?: Maybe<ImageFile>;
  /** Unique title of the Promo Flash */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current Promo Flash */
  uid?: Maybe<Scalars['String']['output']>;
  /** Url the promo is targetting */
  url?: Maybe<Scalars['String']['output']>;
};

/** The object for BatchAsks that contains the ask */
export type BatchAsk = {
  /** The ask created */
  ask?: Maybe<Ask>;
};

/** Item returned for GetBatchAsks API */
export type BatchAsks = {
  /** The error thrown when validating the provided input */
  error?: Maybe<Scalars['String']['output']>;
  /** The id of a given task */
  id?: Maybe<Scalars['ID']['output']>;
  /** The object containing the resulting ask */
  result?: Maybe<BatchAsk>;
  /** The status of a given batch */
  status?: Maybe<Scalars['String']['output']>;
};

export type BatchAsksInput = {
  /** The id of the batch to fetch */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** The state of the asks to fetch */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Payload containing the result of the GetBatchAsks query */
export type BatchAsksResult = {
  /** The total number of items in the batch */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether there is another page or not */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** An array of items associated with the batch request */
  items?: Maybe<Array<Maybe<BatchAsks>>>;
  /** The page number of items returned for pagination */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The size of the page for pagination */
  pageSize?: Maybe<Scalars['Int']['output']>;
};

/** Representation of a user's bid */
export type Bid = {
  /** The bidding price for the product */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The checkout type of a custodial bid */
  checkoutType?: Maybe<CheckoutType>;
  /** The currency code of the bid */
  currencyCode?: Maybe<CurrencyCode>;
  /** The date the Bid expires */
  expirationDate?: Maybe<Scalars['ISODate']['output']>;
  /** The ID of an bid, which is a chainID */
  id?: Maybe<Scalars['String']['output']>;
  /** The payment details for the bid */
  payment?: Maybe<BidPayment>;
  /** The pricing details for the bid */
  pricing?: Maybe<BidPricing>;
  /** Product variant associated with the bid */
  productVariant?: Maybe<Variant>;
  /** Current state of the Bid */
  state?: Maybe<Scalars['Int']['output']>;
};

/** Information around the bids and asks for this item */
export type BidAskData = {
  /** Highest bid */
  highestBid?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Highest bid as a float
   * @deprecated Use highestBid instead.
   */
  highestBidFloat?: Maybe<Scalars['Float']['output']>;
  /**
   * Size of the highest bid
   * @deprecated Use highestBidVariant instead.
   */
  highestBidSize?: Maybe<Scalars['String']['output']>;
  /** Highest bid variant */
  highestBidVariant?: Maybe<Variant>;
  /** Time of the last highest bid */
  lastHighestBidTime?: Maybe<Scalars['String']['output']>;
  /** Time of the lowest ask */
  lastLowestAskTime?: Maybe<Scalars['String']['output']>;
  /** Lowest ask */
  lowestAsk?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Amount of the lowest ask as a float
   * @deprecated Use lowestAsk instead.
   */
  lowestAskFloat?: Maybe<Scalars['Float']['output']>;
  /**
   * Size of the lowest ask
   * @deprecated Use lowestAskVariant instead.
   */
  lowestAskSize?: Maybe<Scalars['String']['output']>;
  /** Lowest ask variant */
  lowestAskVariant?: Maybe<Variant>;
  /** Lowest custodial ask */
  lowestCustodialAsk?: Maybe<Scalars['BigInt']['output']>;
  /** Lowest custodial ask variant */
  lowestCustodialAskVariant?: Maybe<Variant>;
  /** Total number of asks */
  numberOfAsks?: Maybe<Scalars['Int']['output']>;
  /** Total number of bids */
  numberOfBids?: Maybe<Scalars['Int']['output']>;
  /** Total number of custodial asks */
  numberOfCustodialAsks?: Maybe<Scalars['Int']['output']>;
};

export type BidCheckoutTypeFilterInput = {
  /** The checkout type. If specified will return bids of a specific checkout type. */
  in?: InputMaybe<Array<CheckoutType>>;
};

export type BidExpiredFilter = {
  /** If true, will include only expired bids, if false will include only un-expired bids. */
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payment details */
export type BidPayment = {
  /** The payment method used for the bid */
  method?: Maybe<BidPaymentMethod>;
};

/** The payment method details */
export type BidPaymentMethod = {
  /** A description of the payment method */
  description?: Maybe<Scalars['String']['output']>;
  /** The payment method name */
  name?: Maybe<Scalars['String']['output']>;
};

/** The pricing details */
export type BidPricing = {
  /** The pricing ledger */
  ledger?: Maybe<BidPricingLedger>;
};

/** The pricing ledger details */
export type BidPricingLedger = {
  /** The list of pricing adjustments for the bid */
  adjustments?: Maybe<Array<Maybe<BidPricingLedgerAdjustment>>>;
  /** The total after all adjustments */
  total?: Maybe<BidPricingLedgerTotal>;
};

/** A pricing ledger adjustment */
export type BidPricingLedgerAdjustment = {
  /** The description of the adjustment */
  name?: Maybe<Scalars['String']['output']>;
  /** The value of the adjustment */
  value?: Maybe<Scalars['Float']['output']>;
};

/** The pricing ledger total */
export type BidPricingLedgerTotal = {
  /** The total value after all adjustments */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Bids product IDs filter */
export type BidProductIdsFilter = {
  /** IDs of the products. If specified will return bids of a specific products. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filter for returning bids of a specific variant id. */
export type BidVariantIdsFilter = {
  /** IDs of the variants. If specified will return bids of a specific variant. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Bids connection */
export type BidsConnection = {
  /** Edges to a list of products the user is selling or has sold */
  edges?: Maybe<Array<Maybe<BidsEdge>>>;
  /** Information about the current page in the pagination */
  pageInfo?: Maybe<PageInfo>;
};

/** An edge to a Bid */
export type BidsEdge = {
  /** What the user is selling or has sold */
  node?: Maybe<Bid>;
};

/** Bids filters input */
export type BidsFiltersInput = {
  /** Filter bids by checkout type */
  checkoutType?: InputMaybe<BidCheckoutTypeFilterInput>;
  /** Filter bids by expired status */
  expired?: InputMaybe<BidExpiredFilter>;
  /** Filter bids by product ids */
  productId?: InputMaybe<BidProductIdsFilter>;
  /** Filter bids by variant ids */
  variantId?: InputMaybe<BidVariantIdsFilter>;
};

/** The generalized, coarse-grained state that the bid falls into */
export enum BidsGeneralState {
  /** Current bids are bids that haven't yet been matched. */
  CURRENT = 'CURRENT',
  /** Historical bids are those that happened in the past and aren't current or pending */
  HISTORICAL = 'HISTORICAL',
  /** Pending bids are those that have been matched but haven't been recieved */
  PENDING = 'PENDING',
}

/** Sort fields for Bids */
export enum BidsSortInput {
  /** Highest bid amount for the user */
  AMOUNT = 'AMOUNT',
  /** Spread between user's ask and the highest bid in the market. */
  BID_ASK_SPREAD = 'BID_ASK_SPREAD',
}

/** A feature flag with a boolean value */
export type BooleanFeatureFlag = FeatureFlag & {
  /** The boolean value of this feature flag */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  /** A key that identifies this feature flag */
  key?: Maybe<Scalars['String']['output']>;
};

/** Boolean "is" filter */
export type BooleanIsFilterInput = {
  /** If true, only items which match this criteria will be returned */
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Braintree Payment Provider */
export type BraintreePaymentProvider = PaymentProvider & {
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** merchantAccountId */
  merchantAccountId?: Maybe<Scalars['String']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
};

/** Braintree Client Authorization  */
export type BraintreeProviderClientToken = PaymentProviderToken & {
  /** PSP provider client authorization key */
  paymentClientProviderToken?: Maybe<Scalars['String']['output']>;
};

/** Breadcrumbs for a given product */
export type Breadcrumbs = {
  /** What level of breadcrumb is this */
  level?: Maybe<Scalars['Int']['output']>;
  /** Is the title for the level */
  name?: Maybe<Scalars['String']['output']>;
  /** Url to link to when clicked */
  url?: Maybe<Scalars['String']['output']>;
};

/** An object containing the data required to power the browse experience. */
export type Browse = {
  /** The product category hierarchy. */
  categories?: Maybe<Array<Maybe<BrowseCategory>>>;
  /** Filters for browse results */
  filters?: Maybe<Array<Maybe<BrowseFilter>>>;
  /** The search query used for this set of results. */
  query?: Maybe<Scalars['String']['output']>;
  /** A connection to a set of Product or Variants as a result of the browse parameters passed. */
  results?: Maybe<BrowseResultConnection>;
  /** The sorting algorithm that was used. */
  sort?: Maybe<BrowseSort>;
  /** The search suggestions. */
  suggestions?: Maybe<RelatedBrowseSuggestions>;
};

/** An individual category in our product catalog hierarchy. */
export type BrowseCategory = {
  /** The amount of results that fall under this category. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The unique id of the category. */
  id?: Maybe<Scalars['String']['output']>;
  /** The name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent of this category; or null if an L1 category. */
  parent?: Maybe<BrowseCategory>;
};

export type BrowseExperimentDynamicFilterInput = {
  /** Describes wether or not to enabled dynamic filter. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrowseExperimentStaticRankingInput = {
  /** Describes wether or not to enabled static ranking. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrowseExperimentsInput = {
  dynamicFilter?: InputMaybe<BrowseExperimentDynamicFilterInput>;
  /** Introduces static ranking on each Algolia document. */
  staticRanking?: InputMaybe<BrowseExperimentStaticRankingInput>;
};

export type BrowseFilter = {
  /** Filter id that passed to the API as parameter name if has selection */
  id?: Maybe<Scalars['String']['output']>;
  /** The display name of the filter. */
  name?: Maybe<Scalars['String']['output']>;
  /** The type of the filter. */
  type?: Maybe<BrowseFilterType>;
};

export type BrowseFilterBoolean = BrowseFilter & {
  /** Filter id that passed to the API as parameter name if has selection */
  id?: Maybe<Scalars['String']['output']>;
  /** The display name of the filter. */
  name?: Maybe<Scalars['String']['output']>;
  /** List Options */
  options?: Maybe<Array<Maybe<BrowseFilterBooleanOption>>>;
  /** The type of the filter. */
  type?: Maybe<BrowseFilterType>;
};

export type BrowseFilterBooleanOption = {
  /** The id of the option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Boolean to determine if the option is selected or not. */
  selected?: Maybe<Scalars['Boolean']['output']>;
  /** Filter value that passed to the API as parameter value if selected */
  value?: Maybe<Scalars['String']['output']>;
};

/** An input type used to communicate information about the selected browse filters. */
export type BrowseFilterInput = {
  /** The unique id of the filter. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** An array of values that were selected for the filter. */
  selectedValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BrowseFilterList = BrowseFilter & {
  /** Filter id that passed to the API as parameter name if has selection */
  id?: Maybe<Scalars['String']['output']>;
  /** Boolean to determine if the filter is multi select or not. */
  multiSelectEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The display name of the filter. */
  name?: Maybe<Scalars['String']['output']>;
  /** List Options */
  options?: Maybe<Array<Maybe<BrowseFilterListOption>>>;
  /** The type of the filter. */
  type?: Maybe<BrowseFilterType>;
};

export type BrowseFilterListOption = {
  /** Number of results that fall under this option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The id of the option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The display name of the option. */
  name?: Maybe<Scalars['String']['output']>;
  /** Boolean to determine if the option is selected or not. */
  selected?: Maybe<Scalars['Boolean']['output']>;
  /** Filter value that passed to the API as parameter value if selected */
  value?: Maybe<Scalars['String']['output']>;
};

export type BrowseFilterTree = BrowseFilter & {
  /** Filter id that passed to the API as parameter name if has selection */
  id?: Maybe<Scalars['String']['output']>;
  /** Boolean to determine if the filter is multi select or not. */
  multiSelectEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The display name of the filter. */
  name?: Maybe<Scalars['String']['output']>;
  /** List Options */
  options?: Maybe<Array<Maybe<BrowseFilterTreeOption>>>;
  /** The type of the filter. */
  type?: Maybe<BrowseFilterType>;
};

export type BrowseFilterTreeOption = {
  /** Indices of children options that fall under this option. */
  children?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Number of results that fall under this option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The id of the option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The tree level for current node */
  level?: Maybe<Scalars['Int']['output']>;
  /** The display name of the option. */
  name?: Maybe<Scalars['String']['output']>;
  /** Boolean to determine if the option is selected or not. */
  selected?: Maybe<Scalars['Boolean']['output']>;
  /** Filter value that passed to the API as parameter value if selected */
  value?: Maybe<Scalars['String']['output']>;
};

/** Browse Filter Types Definitions */
export enum BrowseFilterType {
  /** Represents a filter structure with boolean option */
  BOOL = 'BOOL',
  /** Represents a filter structure with list of values. Most common case */
  LIST = 'LIST',
  /** Represents a filter structure with hierarchy */
  TREE = 'TREE',
}

/** The page information for browse results. */
export type BrowsePageInfo = {
  /** The number of results shown on this page */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The current page. */
  page?: Maybe<Scalars['Int']['output']>;
  /** The total number of pages. */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** The id of the query that was executed */
  queryId?: Maybe<Scalars['String']['output']>;
  /** The index that the query was executed against */
  queryIndex?: Maybe<Scalars['String']['output']>;
  /** The total number of results */
  total?: Maybe<Scalars['Int']['output']>;
};

/** An input type used to communicate information about the page when browsing products. */
export type BrowsePageInput = {
  /** The page to request. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** The limit used when obtaining the page */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** The actual result: either a Product or Variant. */
export type BrowseResult = Product | Variant;

/** The connection to a set of browse results. */
export type BrowseResultConnection = {
  /** Edges connecting to browse results. */
  edges?: Maybe<Array<Maybe<BrowseResultEdge>>>;
  /** The current page information for the browse results. */
  pageInfo?: Maybe<BrowsePageInfo>;
};

/** The edge connecting to the result and it's additional metadata. */
export type BrowseResultEdge = {
  /** The result. */
  node?: Maybe<BrowseResult>;
  /** The Algolia object id for the result. */
  objectId?: Maybe<Scalars['String']['output']>;
};

/** Describes a type of sorting algorithm that can be used when browsing for products. */
export type BrowseSort = {
  /** The description for the sort. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique id of the sort. */
  id?: Maybe<Scalars['String']['output']>;
  /**
   * The unique key for the sort.
   * @deprecated Please migrate to use 'id' instead.
   */
  key?: Maybe<Scalars['String']['output']>;
  /** The name of the sort. */
  name?: Maybe<Scalars['String']['output']>;
  /** The order for the sorting algorithm. */
  order?: Maybe<BrowseSortOrder>;
  /** The urlkey for the ui display */
  seoUrlKey?: Maybe<Scalars['String']['output']>;
  /** The short description for the sort */
  short?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the sort.
   * @deprecated Please migrate to use 'name' instead.
   */
  value?: Maybe<Scalars['String']['output']>;
};

/** An input type used to communicate information about the selected browse sort. */
export type BrowseSortInput = {
  /** The unique if of the sort. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The order for the sorting alogrithm. */
  order?: InputMaybe<BrowseSortOrder>;
};

/** The order to sort results in. */
export enum BrowseSortOrder {
  /** Ascending */
  ASC = 'ASC',
  /** Descending */
  DESC = 'DESC',
}

export type BrowseSuggestion = {
  /** A display title of the suggestion. */
  title?: Maybe<Scalars['String']['output']>;
  /** The URL of the suggestion. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Ask data for createAsks mutation */
export type BulkCreateAskInput = {
  /** The asking price for the product */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Chosen currency. Defaults to USD */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** Date of expiration */
  expires?: InputMaybe<Scalars['String']['input']>;
  /** Number of the same asks for the product and the price */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Variant ID */
  skuUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Ask data for deleteAsks mutation */
export type BulkDeleteAskInput = {
  /** The asking price for the product */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Chosen currency. Defaults to USD */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** Date of expiration */
  expires?: InputMaybe<Scalars['String']['input']>;
  /** The ID of an ask, which is a chainID */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Checking whether a product is eligible for Bulk Shipping */
export type BulkShipmentProductTypeEligibility = {
  /** Type of comparison for property */
  comparisonType?: Maybe<Scalars['String']['output']>;
  /** The property being checked in the product object */
  property?: Maybe<Scalars['String']['output']>;
  /** Acceptable values for above property */
  propertyValues?: Maybe<Array<Scalars['String']['output']>>;
};

/** Information about bulk shipping for the seller */
export type BulkShipping = {
  /** Authentication center IDs where the seller is allowed to bulk ship to */
  bulkShipmentDestinations?: Maybe<Array<Scalars['String']['output']>>;
  /** Types of items that are eligible for Bulk Shipping */
  bulkShippingEligibleProductTypes?: Maybe<
    Array<BulkShippingEligibleProductType>
  >;
  /** Whether the seller is allowed to bulk ship */
  canBulkShip?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the seller is charged for bulk shipping */
  isChargedForBulkShipping?: Maybe<Scalars['Boolean']['output']>;
};

/** Bulk Shipping Eligible Product Type */
export type BulkShippingEligibleProductType = {
  /** Maximum number of items allowed in each Bulk Shipment */
  maxItemsPerBox?: Maybe<Scalars['Int']['output']>;
  /** The type of product */
  productType?: Maybe<Scalars['String']['output']>;
  /** A check to see if the product is eligible for Bulk Shipping */
  productTypeEligibility?: Maybe<Array<BulkShipmentProductTypeEligibility>>;
};

/** Ask data for updateAsks mutation */
export type BulkUpdateAskInput = {
  /** Context if this Ask is expected to match */
  actionContext?: InputMaybe<AskActionContext>;
  /** The asking price for the product */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Chosen currency. Defaults to USD */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** Date of expiration */
  expires?: InputMaybe<Scalars['String']['input']>;
  /** The ID of an ask, which is a chainID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ChainID of Match Candidate if applicable */
  matchCandidateId?: InputMaybe<Scalars['String']['input']>;
};

export type BuyOrder = Order & {
  /** If applicable, the chainId of a bid or ask */
  chainId?: Maybe<Scalars['String']['output']>;
  /** The checkout type of a custodial order */
  checkoutType?: Maybe<OrderCheckoutType>;
  /** The datetime stamp for when the order was created */
  created?: Maybe<Scalars['ISODate']['output']>;
  /** The currency of the order */
  currency?: Maybe<OrderCurrency>;
  /** Information about order fraud review */
  fraud?: Maybe<OrderFraud>;
  /** The history of events on the order */
  history?: Maybe<Array<Maybe<OrderEvent>>>;
  /** The ID of an order */
  id?: Maybe<Scalars['String']['output']>;
  /** The item information associated with the order */
  item?: Maybe<OrderItemInformation>;
  /** The reference to the buy or sell order that is currently matched with this order */
  matchedWith?: Maybe<Order>;
  /** The payment information captured at the time of the order */
  payment?: Maybe<OrderPaymentSnapshot>;
  /** The payment method captured at the time of the order */
  paymentMethod?: Maybe<OrderPaymentMethodSnapshot>;
  /** The payout information */
  payout?: Maybe<OrderPaymentSnapshot>;
  /** Information about the initial pricing, estimated pricing and final pricing (both localized and in USD) */
  pricing?: Maybe<OrderPricing>;
  /** The product information associated with the order */
  product?: Maybe<OrderProductInformation>;
  /** Order payment refunds */
  refunds?: Maybe<Array<Maybe<OrderRefund>>>;
  /** Order return details */
  return?: Maybe<OrderReturn>;
  /** The shipping information associated with the order */
  shipping?: Maybe<OrderShipping>;
  /** Where the item is being sourced from */
  source?: Maybe<OrderSource>;
  /** The sourcing method for the item */
  sourceType?: Maybe<OrderSourceType>;
  /** The list of completed and upcoming states for an order */
  states?: Maybe<Array<Maybe<OrderStateItem>>>;
  /** The status of the order */
  status?: Maybe<Scalars['String']['output']>;
  /** The status code of the order */
  statusCode?: Maybe<Scalars['String']['output']>;
  /** Tax and duty processing */
  taxman?: Maybe<TaxmanResult>;
  /** The type of order */
  type?: Maybe<OrderType>;
  /** The datetime stamp for when the order was updated */
  updated?: Maybe<Scalars['ISODate']['output']>;
  /** The user information captured at the time of the order */
  user?: Maybe<UserSnapshot>;
};

/** Structure to hold policy and profile endpoints */
export type Buyer = {
  /** Member for policy endpoints */
  policy?: Maybe<Policy>;
};

/** The structure for buyer profile current activity details */
export type BuyerActivity = {
  /** The count of purchases made in current quarter */
  purchaseCount?: Maybe<Scalars['Int']['output']>;
  /** The total GMV of purchases made in current quarter */
  purchaseGmv?: Maybe<Scalars['Float']['output']>;
  /** The count of returns made in current quarter */
  returnCount?: Maybe<Scalars['Int']['output']>;
  /** The total GMV of returns made in current quarter */
  returnGmv?: Maybe<Scalars['Float']['output']>;
};

/** The struct to maintain the Buyer Processing Fees for a particular tier. */
export type BuyerProcessingFee = {
  /** The Buyer Processing Fee */
  buyerFee?: Maybe<Scalars['Float']['output']>;
  /** The Buyer Processing Fee Discount */
  buyerFeeDiscount?: Maybe<Scalars['Float']['output']>;
};

/** The struct to maintain the Buyer Shipping Fees for a particular tier. */
export type BuyerShippingFee = {
  /** The country iso2 code */
  country?: Maybe<Country>;
  /** The Buyer Shipping Fee for the country */
  shippingFeeDiscount?: Maybe<Scalars['Float']['output']>;
};

/** The structure to maintain the tier info buyer is attached */
export type BuyerTierInfo = {
  /** The Buyer tier processing fee discount */
  buyerProcessingFeeDiscount?: Maybe<Scalars['Float']['output']>;
  /** The Buyer tier description */
  description?: Maybe<Scalars['String']['output']>;
  /** The Buyer tier level */
  level?: Maybe<Scalars['Int']['output']>;
  /** The Buyer tier minimum purchase count */
  minimumPurchaseCount?: Maybe<Scalars['Int']['output']>;
  /** The Buyer tier minimum purchase gmv */
  minimumPurchaseGmv?: Maybe<Scalars['Float']['output']>;
  /** The Buyer tier name */
  name?: Maybe<Scalars['String']['output']>;
  /** The Buyer tier shipping fee discount */
  shippingFeeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerTierPolicy = {
  /** The Buyer Processing Fee Details */
  buyerProcessingFee?: Maybe<BuyerProcessingFee>;
  /** The Shipping Fee details for a tier */
  buyerShippingFee?: Maybe<Array<Maybe<BuyerShippingFee>>>;
  /** The Buyer tier description */
  description?: Maybe<Scalars['String']['output']>;
  /** The Buyer tier UUID */
  id?: Maybe<Scalars['String']['output']>;
  /** The Buyer tier level */
  level?: Maybe<Scalars['Int']['output']>;
  /** The Minimum Purchase Count */
  minimumPurchaseCount?: Maybe<Scalars['Int']['output']>;
  /** The Minimum Purchase GMV */
  minimumPurchaseGmv?: Maybe<Scalars['Float']['output']>;
  /** The Buyer tier name */
  name?: Maybe<Scalars['String']['output']>;
};

/** The Buyer tier profile */
export type BuyerTierProfile = {
  /** The  Buyer profile's  associated country */
  country?: Maybe<Country>;
  /** The Buyer profile current activity details */
  currentActivity?: Maybe<BuyerActivity>;
  /** The Buyer profile's  associated tier info */
  currentTier?: Maybe<BuyerTierInfo>;
  /** The Buyer profile's current tier associated end date */
  effectiveEndDate?: Maybe<Scalars['ISODate']['output']>;
  /** The Buyer profile's current tier associated start date */
  effectiveStartDate?: Maybe<Scalars['ISODate']['output']>;
  /** The  Buyer profile's  overridden tier info */
  overrideTier?: Maybe<BuyerTierInfo>;
  /** The Buyer profile's  previous tier info */
  previousTier?: Maybe<BuyerTierInfo>;
  /** The Buyer profile's  target tier info */
  targetTier?: Maybe<BuyerTierInfo>;
};

/** Buying connection */
export type BuyingConnection = {
  /** Edges to a list of products the user is bidding on or has purchased */
  edges?: Maybe<Array<Maybe<BuyingEdge>>>;
  /** Information about the current page in the pagination */
  pageInfo?: Maybe<PageInfo>;
};

/** An edge to a Buying result */
export type BuyingEdge = {
  /** Information about the bid or order */
  node?: Maybe<BuyingResult>;
};

/** The generalized, coarse-grained state that the bid falls into */
export enum BuyingGeneralState {
  /** Current bids are bids that haven't yet been matched. */
  CURRENT = 'CURRENT',
  /** Historical bids are those that happened in the past and aren't current or pending */
  HISTORICAL = 'HISTORICAL',
  /** Pending bids are those that have been matched but haven't been received */
  PENDING = 'PENDING',
}

export type BuyingGuidance = {
  /** The Product's average selling price */
  averagePrice?: Maybe<Scalars['BigInt']['output']>;
  /** The price needed to become the highest Bid */
  betterBid?: Maybe<Scalars['BigInt']['output']>;
  /** Price needed to be the highest Bid to more buyers */
  buyFaster?: Maybe<Scalars['BigInt']['output']>;
  /** The price needed to have a competitive Bid */
  goodBid?: Maybe<Scalars['BigInt']['output']>;
  /** The Product's retail price represented in USD */
  retailPrice?: Maybe<Scalars['BigInt']['output']>;
};

/** Buying result */
export type BuyingResult = {
  /** The Bid/Purchase amount */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** The id of the Bid */
  chainId?: Maybe<Scalars['String']['output']>;
  /** The currency code used when bidding or purchasing */
  currencyCode?: Maybe<CurrencyCode>;
  /** The date the Bid expires */
  expirationDate?: Maybe<Scalars['ISODate']['output']>;
  /** The id of the BuyOrder */
  orderId?: Maybe<Scalars['String']['output']>;
  /** The order number of the BuyOrder */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The product the user Bid or Purchased */
  productVariant?: Maybe<Variant>;
  /** The date the product was purchased */
  purchaseDate?: Maybe<Scalars['ISODate']['output']>;
  /** A string representing the current state of the order (e.g. Waiting on Seller to Ship) */
  status?: Maybe<Scalars['String']['output']>;
};

/** Individual ways of sorting a list of bids */
export enum BuyingSortInput {
  /** When the bid expires */
  EXPIRES = 'EXPIRES',
  /** Item name */
  ITEM_TITLE = 'ITEM_TITLE',
  /** Date when the Bid was matched */
  MATCHED_AT = 'MATCHED_AT',
  /** Bid/Order price */
  PRICE = 'PRICE',
  /** State of the Bid/Order */
  STATE = 'STATE',
}

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

/** Card Link Layout */
export type CardLinkLayout = DlpLayout & {
  /** Background color of the card */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Text color on the card */
  color?: Maybe<Scalars['String']['output']>;
  /** Type of the content */
  contentType?: Maybe<DlpComponentType>;
  /** To disable the link on the card */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Header Title text on the card */
  headerTitle?: Maybe<Scalars['String']['output']>;
  /** Flag whether the component is hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the icon on the card */
  iconName?: Maybe<Scalars['String']['output']>;
  /** Order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** Flag whether to show the right arrow beside the text */
  rightArrowVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Subtitle text on the card */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** Target Link for the card */
  targetLink?: Maybe<Link>;
  /** Unique title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current component */
  uid?: Maybe<Scalars['String']['output']>;
};

/** Card Stack Layout */
export type CardStackLayout = DlpLayout & {
  /** List of components under this */
  components?: Maybe<Array<Maybe<CardLinkLayout>>>;
  /** Type of the content */
  contentType?: Maybe<DlpComponentType>;
  /** Flag whether the component is hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** Unique title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current component */
  uid?: Maybe<Scalars['String']['output']>;
};

/** Action values to differentiate between bid and buy_now */
export enum ChargeAction {
  BID = 'BID',
  BUY_NOW = 'BUY_NOW',
}

/** Checkout Action */
export type CheckoutAction = {
  url?: Maybe<Scalars['String']['output']>;
};

/** Type of checkout */
export enum CheckoutActionType {
  /** Buy now */
  BUY_NOW = 'BUY_NOW',
  /** Create ask */
  CREATE_ASK = 'CREATE_ASK',
  /** Create bid */
  CREATE_BID = 'CREATE_BID',
  /** Sell now */
  SELL_NOW = 'SELL_NOW',
  /** Update ask */
  UPDATE_ASK = 'UPDATE_ASK',
  /** Update bid */
  UPDATE_BID = 'UPDATE_BID',
}

/** Describes the checkout type for bids */
export enum CheckoutType {
  /** Express Buy */
  EXPRESS = 'EXPRESS',
  /** Standard Buy */
  STANDARD = 'STANDARD',
}

/** Child Tracking number filter definition */
export type ChildTrackingNumberFilterInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** Citcon Payment Provider */
export type CitconPaymentProvider = PaymentProvider & {
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
};

/** client window informations */
export type ClientBrowserInfoInput = {
  /** acceptHeader for response preference */
  acceptHeader?: InputMaybe<Scalars['String']['input']>;
  /** color depth of the client screen */
  colorDepth?: InputMaybe<Scalars['String']['input']>;
  /** java enabled capured from client */
  javaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** language capured from client */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Height of the client screen */
  screenHeight?: InputMaybe<Scalars['String']['input']>;
  /** width of the client screen */
  screenWidth?: InputMaybe<Scalars['String']['input']>;
  /** time zone off set captured from client */
  timeZoneOffset?: InputMaybe<Scalars['String']['input']>;
  /** user-agent to identify application */
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** Closed filter definition */
export type ClosedFilterInput = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Combination filters */
export type CombinationFilterInput = {
  active?: InputMaybe<ActiveFilterInput>;
  childTrackingNumber?: InputMaybe<ChildTrackingNumberFilterInput>;
  closed?: InputMaybe<ClosedFilterInput>;
  createdAt?: InputMaybe<CreatedAtFilterInput>;
  hub?: InputMaybe<HubFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  slug?: InputMaybe<SlugFilterInput>;
  trackingNumber?: InputMaybe<TrackingNumberFilterInput>;
  updatedAt?: InputMaybe<UpdatedAtFilterInput>;
};

/** Combination order options */
export enum CombinationOrderInput {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** Combination sort options */
export enum CombinationSortInput {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  UPDATED_AT = 'UPDATED_AT',
}

/** Complete Two Step Checkout Input */
export type CompleteTwoStepCheckoutInput = {
  /** provider-specific additional parameters */
  providerAdditionalParameters?: InputMaybe<Scalars['JSONString']['input']>;
  /** PSPs unique identifier for payment */
  providerPaymentId?: InputMaybe<Scalars['String']['input']>;
  /** unique identifier for payment */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** Complete vaulting session Input */
export type CompleteVaultingSessionInput = {
  /** We plan to support multiple token service providers which have different parameters to be sent to the server to complete the vaulting process */
  tokens?: InputMaybe<Array<InputMaybe<ProviderTokensInput>>>;
  /** A unique identifier for vaulting session */
  vaultingSessionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Compliance representations */
export type Compliance = {
  /** Customs regulations */
  customs?: Maybe<Customs>;
  /** Information useful for General Data Protection Regulation decisions */
  gdpr?: Maybe<Gdpr>;
  /** Get a specific regulatory id by regIdUuid */
  getRegulatoryId?: Maybe<RegulatoryId>;
  /** The regulatory ids saved with this user/account */
  regulatoryIds?: Maybe<Array<Maybe<RegulatoryId>>>;
  /** 3Domain Security, version 2 */
  threeDS?: Maybe<ThreeDs>;
};

/** Compliance representations */
export type ComplianceGetRegulatoryIdArgs = {
  regIdUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Compliance representations */
export type ComplianceRegulatoryIdsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
};

export type ConsentType = {
  /** Marketing notifications */
  marketing?: Maybe<Scalars['Boolean']['output']>;
  /** Transactional notifications */
  transactional?: Maybe<Scalars['Boolean']['output']>;
};

export type ConsentTypeInput = {
  /** Marketing notifications */
  marketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Transactional notifications */
  transactional?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An indicator of what is the continent code for a location */
export enum ContinentCode {
  AF = 'AF',
  AN = 'AN',
  AS = 'AS',
  EU = 'EU',
  NA = 'NA',
  OC = 'OC',
  SA = 'SA',
}

export type CountriesFilter = {
  defaultCountryFirst?: InputMaybe<DefaultCountryFirstInput>;
  includeDisabled?: InputMaybe<IncludeDisabledInput>;
  includeGdprDisabled?: InputMaybe<IncludeGdprDisabledInput>;
  includeRegions?: InputMaybe<IncludeRegionsInput>;
  iso2?: InputMaybe<Iso2Input>;
  logisticsGroup?: InputMaybe<LogisticsGroupInput>;
  marketingEnabled?: InputMaybe<MarketingEnabledInput>;
  tradeContext?: InputMaybe<TradeContextInput>;
  vertical?: InputMaybe<ProductCategoryInput>;
};

export type Country = {
  /** Disclaimer State for customs in the country */
  customsDisclaimerState?: Maybe<CustomsDisclaimerState>;
  /** Country Duties Enabled/Disabled */
  ddpEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The Display Country Name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Country GDPR Enabled/Disabled */
  gdprEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The Country UUID */
  id?: Maybe<Scalars['String']['output']>;
  /** The Country ISO2 Code */
  iso2?: Maybe<Scalars['String']['output']>;
  /** The Country ISO3 Code */
  iso3?: Maybe<Scalars['String']['output']>;
  /** Country Marketing Enabled/Disabled */
  marketingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The Country Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Country Phonetics Enabled/Disabled */
  phoneticsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Country Preferred Currency */
  preferredCurrency?: Maybe<Scalars['String']['output']>;
  /** Country Preferred Language */
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  /** A Country's Regions */
  regions?: Maybe<Array<Maybe<Region>>>;
  /** Country Selling Enabled/Disabled */
  sellingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Country has top ranking for display */
  topRanked?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateBatchAskInput = {
  /** The ask price that will be listed on StockX.com */
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  /** The currency that the given amount refers to */
  currency?: InputMaybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expiresAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** How many times should this ask be duplicated. This generally aligns with the inventory that a seller has in stock. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The variant id of the product that this ask is for */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBatchAskInputArgs = {
  /** The ask price that is listed on StockX.com */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** The currency that the given amount refers to */
  currency?: Maybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expiresAt?: Maybe<Scalars['ISODate']['output']>;
  /** The number of times this ask should be duplicated. This generally aligns with the inventory that a seller has in stock. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The variant id of the product that this ask is for */
  variant?: Maybe<Scalars['String']['output']>;
};

export type CreateBatchAskItem = {
  /** A list of errors thrown when validating the provided input */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The id of a given batch */
  id?: Maybe<Scalars['ID']['output']>;
  /** The input used to create the associated tasks */
  input?: Maybe<CreateBatchAskInputArgs>;
  /** The list of created tasks associated with this item */
  tasks?: Maybe<Array<Maybe<CreateBatchAskTask>>>;
};

/** Payload containing the result of the createBatchAsks mutation */
export type CreateBatchAskPayload = {
  /** When the batch completed processing */
  completedAt?: Maybe<Scalars['ISODate']['output']>;
  /** When the batch was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** The id of a given batch */
  id?: Maybe<Scalars['ID']['output']>;
  /** An array of items associated with the batch request */
  items?: Maybe<Array<Maybe<CreateBatchAskItem>>>;
  /** When the batch began processing */
  runningAt?: Maybe<Scalars['ISODate']['output']>;
  /** The status of the given gatch */
  status?: Maybe<CreateBatchAskStatus>;
  /** When the batch was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

export type CreateBatchAskProcessingInput = {
  /** The ask price that is listed on StockX.com */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** The currency that the given amount refers to */
  currency?: Maybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expiresAt?: Maybe<Scalars['ISODate']['output']>;
  /** The variant id of the product that this ask is for */
  variant?: Maybe<Scalars['String']['output']>;
};

/** The status that a batch or one of its corresponding tasks can be in */
export enum CreateBatchAskStatus {
  /** Item is done processing but there are failed tasks */
  COMPLETED = 'COMPLETED',
  /** Item has been created but not yet queued for processing */
  CREATED = 'CREATED',
  /** Item is still being created */
  CREATING = 'CREATING',
  /** Item failed during creation */
  CREATION_FAILED = 'CREATION_FAILED',
  /** Something failed during processing */
  FAILED = 'FAILED',
  /** Item tasks are still processing */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Item has been placed in the processing queue */
  QUEUED = 'QUEUED',
  /** Item is done processing and all tasks are successful */
  SUCCESSFUL = 'SUCCESSFUL',
}

export type CreateBatchAskTask = {
  /** When the task completed processing */
  completedAt?: Maybe<Scalars['ISODate']['output']>;
  /** When the batch was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** List of any errors thrown while this task was processing */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The id of the given task */
  id?: Maybe<Scalars['ID']['output']>;
  /** The input used to process this task */
  input?: Maybe<CreateBatchAskProcessingInput>;
  /** The returned result from the async processor */
  result?: Maybe<CreateBatchAskTaskResult>;
  /** When the task began processing */
  runningAt?: Maybe<Scalars['ISODate']['output']>;
  /** The status of the task */
  status?: Maybe<CreateBatchAskTaskStatus>;
  /** When the batch was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

export type CreateBatchAskTaskResult = {
  /** The actual ask that was created */
  ask?: Maybe<Ask>;
  /** The chainId of the created ask */
  chainId?: Maybe<Scalars['String']['output']>;
};

/** The status of a task during its lifecycle */
export enum CreateBatchAskTaskStatus {
  /** The task has finished its execution and it failed */
  FAILED = 'FAILED',
  /** The task has been queued for the execution */
  QUEUED = 'QUEUED',
  /** The task is being executed and it's still running */
  RUNNING = 'RUNNING',
  /** The task has finished its execution and it was successful */
  SUCCESSFUL = 'SUCCESSFUL',
}

/** The object create batch listing that contains the listing details */
export type CreateBatchListing = {
  /** The listing contains listing details */
  listing?: Maybe<CreateListingBatchItemDetails>;
};

/** Data needed to create a digital product and associate it with its physical product counterpart */
export type CreateDigitalProductInput = {
  /** A description of the product */
  description?: InputMaybe<Scalars['String']['input']>;
  /** GUID passed in by client, stored as a unique index in the event table to ensure idempotency */
  eventNonce?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the media element attached to the product */
  mediaURL?: InputMaybe<Scalars['String']['input']>;
  /** Customer UUID of the owner. This user will own all shares initially. */
  ownerUUID?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the physical product we are associating this digital product to */
  reciprocalSlug?: InputMaybe<Scalars['String']['input']>;
  /** User-friendly identifier for this digital product that will be used to create the entry in the product catalog */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Title of the product */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The type of the values of each variant */
  variantType?: InputMaybe<VariantType>;
  /** The collection of variants under this product */
  variants?: InputMaybe<Array<CreateDigitalProductVariantInput>>;
};

export type CreateDigitalProductOutput = {
  /** The digital product ID */
  productId?: Maybe<Scalars['String']['output']>;
  /** The state machine's request ID that is tracking the creation of the product */
  requestId?: Maybe<Scalars['String']['output']>;
};

/** A description of a variant */
export type CreateDigitalProductVariantInput = {
  /** The unique index of a variant in a product. This should map to the reciprocal physical product's variant's linkId */
  linkId?: InputMaybe<Scalars['String']['input']>;
  /** The value of this variant. Refer to the variant type to understand the semantics e.g. 9.5 & variantType = 'size' means this is a size 9.5 */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateListInput = {
  /** The name of the list. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Describes whether or not the list has notifications enabled. */
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  /** Describes whether or not the list should be able to be viewed by others. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateListResult = {
  /** The list that was created. */
  list?: Maybe<List>;
};

/** Base on current knowledge, each listing is equivalent to an ask, so we use ask in the description to have a better understanding */
export type CreateListingBatchInput = {
  /** Flag used to indicate that the listing should be active or not */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ask price that will be listed on StockX.com */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** The currency that the given amount refers to */
  currency?: InputMaybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expiresAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** The number of times this listing should be duplicated. This generally aligns with the inventory that a seller has in stock. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The variant id of the product that this ask is for */
  variantID?: InputMaybe<Scalars['String']['input']>;
};

/** Item returned for getCreateListingBatchItems API */
export type CreateListingBatchItem = {
  /** Error thrown when validating the provided input */
  error?: Maybe<Scalars['String']['output']>;
  /** The id of a given task */
  id?: Maybe<Scalars['ID']['output']>;
  /** The object contains the resulting listing */
  result?: Maybe<CreateBatchListing>;
  /** The status of a given batch */
  status?: Maybe<CreateListingBatchTaskStatus>;
};

/** The object create listing batch item details that contains the listing */
export type CreateListingBatchItemDetails = {
  /** The ask price that is listed on StockX.com */
  amount?: Maybe<Scalars['String']['output']>;
  /** The id of the ask within listing */
  ask?: Maybe<Ask>;
  /** The currency that the given amount refers to */
  currency?: Maybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expires?: Maybe<Scalars['ISODate']['output']>;
  /** The id of the listing */
  id?: Maybe<Scalars['ID']['output']>;
  /** The variant id of the product that this ask is for */
  variantID?: Maybe<Scalars['String']['output']>;
};

/** Payload containing the result of the getCreateListingBatchItems query */
export type CreateListingBatchItemsPayload = {
  /** An array of items associated with the batch request */
  items?: Maybe<Array<Maybe<CreateListingBatchItem>>>;
};

/** Payload containing the result of the createListingBatch mutation and getCreateListingBatch query */
export type CreateListingBatchPayload = {
  /** When the batch completed processing */
  completedAt?: Maybe<Scalars['ISODate']['output']>;
  /** When the batch was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** The id of a given batch */
  id?: Maybe<Scalars['ID']['output']>;
  /** The status of the given gatch */
  status?: Maybe<CreateListingBatchStatus>;
  /** When the batch was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** The status that a batch */
export enum CreateListingBatchStatus {
  /** All items are processed, no matter single item successful or failed */
  COMPLETED = 'COMPLETED',
  /** Item has been created */
  CREATED = 'CREATED',
  /** Batch has failed during creation */
  CREATION_FAILED = 'CREATION_FAILED',
  /** Something failed during processing */
  FAILED = 'FAILED',
  /** Item tasks are still processing */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Item has been placed on the queue */
  QUEUED = 'QUEUED',
}

/** The status that a batch or one of its corresponding tasks can be in */
export enum CreateListingBatchTaskStatus {
  /** Processing was completed */
  COMPLETED = 'COMPLETED',
  /** Something failed during processing */
  FAILED = 'FAILED',
  /** Item is consumed and is currently in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Item has been placed on the queue */
  QUEUED = 'QUEUED',
}

/** Create MIT authorization */
export type CreateMitAuthorizationInput = {
  /** A unique identifier for charge session */
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * We plan to support multiple token service providers which have different parameters
   * to be sent to the server to complete the authorization process
   */
  tokens?: InputMaybe<Array<InputMaybe<ProviderTokensInput>>>;
};

export type CreateSignedImageUrLsInput = {
  /** The file name for the image. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** GUID passed in by client to ensure there are no collisions based on name in the S3 bucket. */
  nonce?: InputMaybe<Scalars['String']['input']>;
};

/** threeDS Authentication mutation input for charging a payment account */
export type CreateThreeDsAuthenticationInput = {
  /** money session id */
  moneySessionId?: InputMaybe<Scalars['String']['input']>;
  /** token from FE Clients to check 3DS authentication status */
  threeDSToken?: InputMaybe<Scalars['String']['input']>;
};

/** threeDS Authorization mutation input for charging a payment account */
export type CreateThreeDsSessionAuthorizationInput = {
  /** payment provider name - supported PSP names */
  moneyProviderName?: InputMaybe<PaymentServiceProvider>;
  /** money session id */
  moneySessionId?: InputMaybe<Scalars['String']['input']>;
  /** token from FE Clients to check 3DS authorization status */
  threeDsToken?: InputMaybe<Scalars['String']['input']>;
};

/** CreatedAt filter definition */
export type CreatedAtFilterInput = {
  gte?: InputMaybe<Scalars['ISODate']['input']>;
};

/** Credit Card Payment Instrument */
export type CreditCardPaymentInstrument = PaymentInstrument & {
  /** brands */
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** instrumentCategory */
  instrumentCategory?: Maybe<Scalars['String']['output']>;
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
  /** provider */
  provider?: Maybe<PaymentProvider>;
};

/** Mapping between user to its provider credentials */
export type CreditCardUserPaymentAccount = UserPaymentAccount & {
  /** Bin value of the credit card */
  bin?: Maybe<Scalars['String']['output']>;
  /** Code for the credit card visa, mastercard */
  code?: Maybe<Scalars['String']['output']>;
  /** Expiry Month */
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  /** Expiry year */
  expiryYear?: Maybe<Scalars['Int']['output']>;
  /** Payments ID for the provider account */
  id?: Maybe<Scalars['ID']['output']>;
  /** If this is the preferred payment account for the user */
  isPreferred?: Maybe<Scalars['Boolean']['output']>;
  /** Display Label For the Account */
  label?: Maybe<Scalars['String']['output']>;
  /** Payment Provider ID For This Account Braintree Adyen JPMC */
  paymentProviderAccountId?: Maybe<Scalars['String']['output']>;
  /** Payment Provider For This Account Braintree Adyen JPMC */
  provider?: Maybe<PaymentProvider>;
  /** User this card belongs to */
  user?: Maybe<User>;
};

export type CsvUpload = {
  /** Filename of the csv. Used to look up the file in S3 */
  fileName?: Maybe<Scalars['String']['output']>;
  /** True if the values in the csv failed to be inserted in the DB */
  uploadFailed?: Maybe<Scalars['Boolean']['output']>;
  /** True if the values from the csv have already been inserted in the DB */
  uploadIsComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type CsvUploadInput = {
  /** Filename of the csv. Used to look up the file in S3 */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** True if the values in the csv failed to be inserted in the DB */
  uploadFailed?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the values from the csv have already been inserted in the DB */
  uploadIsComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CuratedSearchPage = {
  /** The URL */
  url?: Maybe<Scalars['String']['output']>;
};

/** Currency codes we support at StockX */
export enum CurrencyCode {
  /** Australian Dollar */
  AUD = 'AUD',
  /** Brazilian Real */
  BRL = 'BRL',
  /** Canadian Dollar */
  CAD = 'CAD',
  /** Swiss franc */
  CHF = 'CHF',
  /** Chilean Peso */
  CLP = 'CLP',
  /** Chinese yuan */
  CNY = 'CNY',
  /** Denmark Krone */
  DKK = 'DKK',
  /** Euro */
  EUR = 'EUR',
  /** Pound sterling */
  GBP = 'GBP',
  /** Honk Kong Dollar */
  HKD = 'HKD',
  /** Hungarian Forint */
  HUF = 'HUF',
  /** Indonesian Rupiah */
  IDR = 'IDR',
  /** Israeli Shekel */
  ILS = 'ILS',
  /** Japanese Yen */
  JPY = 'JPY',
  /** South Korean Won */
  KRW = 'KRW',
  /** Kuwaiti Dinar */
  KWD = 'KWD',
  /** Macao Pataca */
  MOP = 'MOP',
  /** Mexican Peso */
  MXN = 'MXN',
  /** Malaysian Ringgit */
  MYR = 'MYR',
  /** Norwegian Krone */
  NOK = 'NOK',
  /** New Zealand Dollar */
  NZD = 'NZD',
  /** Peruvian Nuevo Sol */
  PEN = 'PEN',
  /** Philippine Peso */
  PHP = 'PHP',
  /** Poland Zloty */
  PLN = 'PLN',
  /** Swedish Krona */
  SEK = 'SEK',
  /** Singapore Dollar */
  SGD = 'SGD',
  /** Thai Baht */
  THB = 'THB',
  /** Taiwanese Dollar */
  TWD = 'TWD',
  /** US Dollar */
  USD = 'USD',
  /** Vietnamese Dong */
  VND = 'VND',
}

/** Custom Component Layout */
export type CustomComponentLayout = DlpLayout & {
  /** Component name mapped in the frontend */
  componentName?: Maybe<Scalars['String']['output']>;
  /** List of components under this */
  components?: Maybe<Array<Maybe<CustomComponentLayout>>>;
  /** Type of the content */
  contentType?: Maybe<DlpComponentType>;
  /** Flag whether the component is hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Load after visibility in the viewport */
  loadAfterVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** Any overriding props */
  overrideProps?: Maybe<Scalars['JSONString']['output']>;
  /** Unique title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current component */
  uid?: Maybe<Scalars['String']['output']>;
};

/** Customs regulations */
export type Customs = {
  /** Customs Clearance Indigenous Code. Required by South Korea to import shipments into the country. */
  ccicId?: Maybe<Scalars['String']['output']>;
  /** Qatar Passport or National ID. Required by Qatar to import shipments into the country. */
  qatarId?: Maybe<Scalars['String']['output']>;
};

/** What actions to take about the disclaimer to the user */
export enum CustomsDisclaimerState {
  NONE = 'NONE',
  SHOW_DISCLAIMER = 'SHOW_DISCLAIMER',
  SHOW_DISCLAIMER_AND_REQUIRE_ACK = 'SHOW_DISCLAIMER_AND_REQUIRE_ACK',
}

/** Dead stock information  */
export type DeadStock = {
  /**
   * Average dead stock price
   * @deprecated This data is now availabile under statistics.annual.averagePrice. Please migrate.
   */
  averagePrice?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Dead stock range high
   * @deprecated This data is now availabile under statistics.annual.rangeHigh. Please migrate.
   */
  rangeHigh?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Dead stock range low
   * @deprecated This data is now availabile under statistics.annual.rangeLow. Please migrate.
   */
  rangeLow?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Dead stock sold
   * @deprecated This data is now availabile under statistics.annual.salesCount. Please migrate.
   */
  sold?: Maybe<Scalars['Int']['output']>;
};

/** Should the default country (United States) be first */
export type DefaultCountryFirstInput = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Default Payment Instrument */
export type DefaultPaymentInstrument = PaymentInstrument & {
  /** instrumentCategory */
  instrumentCategory?: Maybe<Scalars['String']['output']>;
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
  /** provider */
  provider?: Maybe<PaymentProvider>;
};

/** Entry determining if an order is delayed and why */
export type Delay = {
  /** Carrier used for order (DHL, UPS, etc) */
  carrierCode?: Maybe<Scalars['String']['output']>;
  /** When was the delay */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** unique key of order delay */
  id?: Maybe<Scalars['String']['output']>;
  /** is the order delayed or not */
  isDelayed?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the order */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Reason for delay (3PL) */
  reason?: Maybe<Scalars['String']['output']>;
  /** Tracking number provided by carrier */
  trackNumber?: Maybe<Scalars['String']['output']>;
  /** Timestamp of last update to the delay */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type DelaysConnection = {
  /** Array of shipment nodes on the graph */
  delays?: Maybe<Array<Maybe<Delay>>>;
  /** Info about the page results (pagination) */
  paging?: Maybe<DelaysPageInfo>;
};

/** Delay order input */
export enum DelaysOrderInput {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** Delay infromation */
export type DelaysPageInfo = {
  /** current url with page number param */
  currentPage?: Maybe<Scalars['String']['output']>;
  /** number of last page */
  lastPage?: Maybe<Scalars['Int']['output']>;
  /** Pagination limit */
  limit?: Maybe<Scalars['Int']['output']>;
  /** next url with page number param */
  nextPage?: Maybe<Scalars['String']['output']>;
  /** Result order */
  order?: Maybe<DelaysOrderInput>;
  /** Pagination page */
  page?: Maybe<Scalars['Int']['output']>;
  /** previous url page number (Example: null) */
  prevPage?: Maybe<Scalars['String']['output']>;
  /** Result sort */
  sort?: Maybe<DelaysSortInput>;
  /** the total number of order delays */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Delay Sort input */
export enum DelaysSortInput {
  CREATEDAT = 'createdAt',
  ORDERID = 'orderId',
}

/** The object delete batch listing that contains the listing details */
export type DeleteBatchListing = {
  /** The listing contains listing details */
  listing?: Maybe<DeleteListingBatchItemDetails>;
};

/** The payload containing the deleted message */
export type DeleteInboxMessagePayload = {
  /** A list of one or more messages that failed to be deleted */
  failed?: Maybe<Array<Maybe<InboxMessageFailed>>>;
  /** A list of one or more messages that were successfully deleted */
  success?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Base on current knowledge, each listing is equivalent to an ask, so we use ask to describe below to have a better understanding */
export type DeleteListingBatchInput = {
  /** Listing id, customer get this when create the listing */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Item returned for getDeleteListingBatchItems API */
export type DeleteListingBatchItem = {
  /** Error thrown when validating the provided input */
  error?: Maybe<Scalars['String']['output']>;
  /** The id of a given task */
  id?: Maybe<Scalars['ID']['output']>;
  /** The object containing the resulting listing */
  result?: Maybe<DeleteBatchListing>;
  /** The status of a given batch */
  status?: Maybe<DeleteListingBatchTaskStatus>;
};

/** The object for DeleteListingBatchItem that contains the listing details */
export type DeleteListingBatchItemDetails = {
  /** The id of the ask within listing */
  ask?: Maybe<Ask>;
  /** Listing id */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Payload containing the result of the getDeleteListingBatchItems query */
export type DeleteListingBatchItemsPayload = {
  /** An array of items associated with the batch request */
  items?: Maybe<Array<Maybe<DeleteListingBatchItem>>>;
};

/** Payload containing the result of the deleteListingBatch mutation and getDeleteListingBatch query */
export type DeleteListingBatchPayload = {
  /** When the batch completed processing */
  completedAt?: Maybe<Scalars['ISODate']['output']>;
  /** When the batch was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** The id of a given batch */
  id?: Maybe<Scalars['ID']['output']>;
  /** The status of the given gatch */
  status?: Maybe<DeleteListingBatchStatus>;
  /** When the batch was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** The status that a delete listing batch */
export enum DeleteListingBatchStatus {
  /** All items are processed, no matter single item successful or failed */
  COMPLETED = 'COMPLETED',
  /** Delete Batch has been created */
  CREATED = 'CREATED',
  /** Batch has failed during creation */
  CREATION_FAILED = 'CREATION_FAILED',
  /** Delete batch failed during processing */
  FAILED = 'FAILED',
  /** Delete batch is still processing */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Items of delete listing batch has been placed on the queue */
  QUEUED = 'QUEUED',
}

/** The status that a delete listing task */
export enum DeleteListingBatchTaskStatus {
  /** Processing was completed */
  COMPLETED = 'COMPLETED',
  /** Something failed during processing */
  FAILED = 'FAILED',
  /** Item is consumed and is currently in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Item has been placed on the queue */
  QUEUED = 'QUEUED',
}

export type DeletionId = {
  /** Root ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Initiated deletion */
  initiated?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveryMethod = {
  /** The delivery date summary for the delivery method. */
  deliveryDateSummary?: Maybe<Scalars['String']['output']>;
  /** The description for the delivery method. */
  description?: Maybe<Scalars['String']['output']>;
  /** The lowest ask amount associated with the delivery method. */
  lowestAsk?: Maybe<Scalars['BigInt']['output']>;
  /** The title describing the delivery method. */
  title?: Maybe<Scalars['String']['output']>;
  /** The delivery method type. */
  type?: Maybe<DeliveryMethodType>;
  /** Data associated with upgrading this delivery method relative to the 'standard' type. */
  upgrade?: Maybe<DeliveryMethodUpgrade>;
};

/** Describes the delivery method type. */
export enum DeliveryMethodType {
  /** Express shipping. */
  EXPRESS = 'EXPRESS',
  /** Standard delivery method. */
  STANDARD = 'STANDARD',
}

/** The object containing details around upgrading the delivery method. */
export type DeliveryMethodUpgrade = {
  /** The cost to upgrade the delivery method relative to the 'standard' type. */
  price?: Maybe<Scalars['Float']['output']>;
};

export type DeliveryOptions = {
  /** The list of delivery methods available for the variant. */
  methods?: Maybe<Array<Maybe<DeliveryMethod>>>;
};

export type DigitalOwnershipPortfolioConnection = {
  /** Array of NFTs owned by user */
  edges?: Maybe<Array<Maybe<OwnershipPortfolioItemEdge>>>;
};

/** A digital product record stored in NFT Management Service */
export type DigitalProduct = {
  /** The media URL that was sent to Salsify/Catalog */
  catalogMediaURL?: Maybe<Scalars['String']['output']>;
  /** The associated catalog product */
  catalogProduct?: Maybe<Product>;
  /** The description of the product sent to Salsify/Catalog and the blockchain */
  description?: Maybe<Scalars['String']['output']>;
  /** The NFT Management Service Product ID */
  id: Scalars['String']['output'];
  /** Whether this product is multi-variant or single-variant */
  multiVariant?: Maybe<Scalars['Boolean']['output']>;
  /** The original (first) owner of the digital product */
  owner?: Maybe<NftOwner>;
  /** The slug of the physical product we are associating this digital product to */
  reciprocalSlug?: Maybe<Scalars['String']['output']>;
  /** User-friendly identifier for this digital product */
  slug?: Maybe<Scalars['String']['output']>;
  /** Title of the product when it was first created */
  title?: Maybe<Scalars['String']['output']>;
  /** Blockchain and edition details specific to each variant */
  variants?: Maybe<Array<Maybe<DigitalProductVariant>>>;
};

/** Digital Product connection */
export type DigitalProductConnection = {
  /** Edges to digital products */
  edges?: Maybe<Array<Maybe<DigitalProductEdge>>>;
  /** Pagination arguments of the edges */
  pageInfo?: Maybe<NfTsPageInfo>;
};

/** Edge wrapper around a digital product */
export type DigitalProductEdge = {
  /** The digital product */
  node?: Maybe<DigitalProduct>;
};

export type DigitalProductVariant = {
  /** Data related to the blockchain. */
  blockchain?: Maybe<NftBlockchain>;
  /** The associated catalog variant */
  catalogVariant?: Maybe<Variant>;
  /** The NFT Management Service Variant ID */
  id: Scalars['String']['output'];
  /** Data managed by StockX's ownership service. */
  quantities?: Maybe<DigitalProductVariantQuantities>;
};

export type DigitalProductVariantQuantities = {
  /** The number of asks created so far for the primary sale. Includes both sold and not yet sold asks. */
  primaryAsksCreated?: Maybe<Scalars['Int']['output']>;
  /** The number of editions that remain available for purchase in the primary sale. */
  primaryEditionsRemaining?: Maybe<Scalars['Int']['output']>;
  /** The number of editions sold as part of the primary sale. */
  primaryEditionsSold?: Maybe<Scalars['Int']['output']>;
  /** The number of editions sold in all of time, including primary and secondary sales. */
  totalEditionsSold?: Maybe<Scalars['Int']['output']>;
};

/** Enum for units used to measure dimensions */
export enum DimensionUnit {
  /** Inches */
  INCHES = 'INCHES',
  /** Unknown Dimension Units */
  UNKNOWN = 'UNKNOWN',
}

export type Discount = {
  /** UUIDs of customers who are eligible to use this discount */
  customerUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** True if value is a dollar amount. False if value is a percentage */
  flat?: Maybe<Scalars['Boolean']['output']>;
  /** UUID that identifies the discount */
  id?: Maybe<Scalars['String']['output']>;
  /** Minimum price of product for this discount to be applied */
  minPrice?: Maybe<Scalars['Float']['output']>;
  /** Human readable name of the discount */
  name?: Maybe<Scalars['String']['output']>;
  /** UUIDs of products this discount can be applided to */
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** UUIDs of SKUs this discount can be applied to */
  skus?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The date the discount was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
  /** Maximum dollar amount that can be discounted is this discount applies a percentage discount */
  upperLimit?: Maybe<Scalars['Float']['output']>;
  /** Context which this discount is eligible for. Can be Buying, Selling or an empty string. An empty string indicated both buying and selling */
  userContext?: Maybe<Scalars['String']['output']>;
  /** Value of the discount. Can represent a dollar amount or percentage depending on the value of flat */
  value?: Maybe<Scalars['Float']['output']>;
  /** Properties of the discount can be different per vertical. The differences are defined in verticalDetails */
  verticalDetails?: Maybe<DiscountVerticalDetails>;
};

export type DiscountCode = {
  /** Date the discount code will become active */
  activatesAt?: Maybe<Scalars['ISODate']['output']>;
  /** The text code used by the user */
  code?: Maybe<Scalars['String']['output']>;
  /** The UUID of the customer this discount is associated with */
  customerUuid?: Maybe<Scalars['String']['output']>;
  /** The UUID of the discount this code is associated with */
  discount?: Maybe<Discount>;
  /** Date the discount code will expire */
  expiresAt?: Maybe<Scalars['ISODate']['output']>;
  /** UUID that identifies the discount code */
  id?: Maybe<Scalars['String']['output']>;
  /** Maximum times this code can be used by all users */
  maxUses?: Maybe<Scalars['Int']['output']>;
  /** Maximum times a user can use this code */
  maxUsesPerUser?: Maybe<Scalars['Int']['output']>;
  /** Indicates that a security check is needed when generating pricing */
  secure?: Maybe<Scalars['Boolean']['output']>;
  /** The date the discount code was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** An edge to a discount code */
export type DiscountCodeEdge = {
  /** A discount code */
  node?: Maybe<DiscountCode>;
};

export type DiscountCodeEditPayloadInput = {
  /** Date the discount code will become active */
  activatesAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** Date the discount code will expire */
  expiresAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** UUID that identifies the discount code */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Maimum times this code can be used by all users */
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum times a user can use this code */
  maxUsesPerUser?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates that a security check is needed when generating pricing */
  secure?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response when trying to expire a discount code */
export type DiscountCodeExpirationResponse = {
  /** Message result from trying to expire a discount code */
  message?: Maybe<Scalars['String']['output']>;
};

/** A connection used for paginating discount code requests */
export type DiscountCodesConnection = {
  /** A list of edges to discount codes */
  edges?: Maybe<Array<Maybe<DiscountCodeEdge>>>;
  /** Information about the current page in the pagination */
  pageInfo?: Maybe<PageInfo>;
};

export type DiscountVerticalDetail = {
  /** True if value is a dollar amount. False if value is a percentage */
  flat?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of times this discount can be used */
  maxUses?: Maybe<Scalars['Float']['output']>;
  /** Minimum price of product for this discount to be applied */
  minPrice?: Maybe<Scalars['Float']['output']>;
  /** Maximum dollar amount that can be discounted is this discount applies a percentage discount */
  upperLimit?: Maybe<Scalars['Float']['output']>;
  /** Value of the discount. Can represent a dollar amount or percentage depending on the value of flat */
  value?: Maybe<Scalars['Float']['output']>;
};

export type DiscountVerticalDetails = {
  /** Discount properties specific to the collectibles vertical */
  collectibles?: Maybe<DiscountVerticalDetail>;
  /** Discount properties specific to the handbags vertical */
  handbags?: Maybe<DiscountVerticalDetail>;
  /** Discount properties specific to the sneakers vertical */
  sneakers?: Maybe<DiscountVerticalDetail>;
  /** Discount properties specific to the streetwear vertical */
  streetwear?: Maybe<DiscountVerticalDetail>;
  /** Discount properties specific to the watches vertical */
  watches?: Maybe<DiscountVerticalDetail>;
};

/** Divider Layout */
export type DividerLayout = DlpLayout & {
  /** Color of the divider */
  color?: Maybe<Scalars['String']['output']>;
  /** Type of the content */
  contentType?: Maybe<DlpComponentType>;
  /** Flag whether the component is hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Margin below the element */
  marginBottom?: Maybe<Scalars['Int']['output']>;
  /** Margin Above the element */
  marginTop?: Maybe<Scalars['Int']['output']>;
  /** Order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** Unique title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current component */
  uid?: Maybe<Scalars['String']['output']>;
};

/** The base enum for the different components on the Dynamic Landing Page */
export enum DlpComponentType {
  /** Represents a Banner Image */
  BANNER_IMAGE = 'BANNER_IMAGE',
  /** Represents a card link */
  CARD_LINK = 'CARD_LINK',
  /** Represents a stack of cards */
  CARD_STACK = 'CARD_STACK',
  /** Represents a custom component */
  CUSTOM_COMPONENT = 'CUSTOM_COMPONENT',
  /** Represents a divider */
  DIVIDER = 'DIVIDER',
}

/** A Base layout for any component */
export type DlpLayout = {
  /** Type of the content */
  contentType?: Maybe<DlpComponentType>;
  /** Flag whether the component is hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** Unique title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current component */
  uid?: Maybe<Scalars['String']['output']>;
};

/** An address with dynamic number and type of fields */
export type DynamicAddress = {
  /** The fields associated with the dynamic address */
  fields?: Maybe<Array<Maybe<DynamicAddressField>>>;
};

/** The dynamic address field */
export type DynamicAddressField = {
  /** The key for the field (e.g. last_name) */
  key?: Maybe<Scalars['String']['output']>;
  /** The value for the field (e.g. Doe) */
  value?: Maybe<Scalars['String']['output']>;
};

/** The input type for a dynamic address field */
export type DynamicAddressFieldInput = {
  /** The key for the field (e.g. last_name) */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The value for the field (e.g. Doe) */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** An input type for an address with dynamic number and type of fields */
export type DynamicAddressInput = {
  /** The fields associated with the dynamic address */
  fields?: InputMaybe<Array<InputMaybe<DynamicAddressFieldInput>>>;
};

/** EU VAT */
export type Euvat = {
  /** VAT id. */
  id?: Maybe<Scalars['String']['output']>;
  /** Whether the VAT id is expired. */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
};

/** Seller's earning period information */
export type EarningPeriod = {
  /** Current seller level */
  currentSellerLevel?: Maybe<Scalars['Int']['output']>;
  /** Days left in earning period */
  daysLeft?: Maybe<Scalars['Int']['output']>;
  /** Next seller level */
  nextSellerLevel?: Maybe<Scalars['Int']['output']>;
  /** Total number of sales in current earning period */
  salesCount?: Maybe<Scalars['Int']['output']>;
  /** Total sales revenue in current earning period */
  salesRevenue?: Maybe<Scalars['Float']['output']>;
  /** Number of sales to reach next level */
  targetSalesCountRemaining?: Maybe<Scalars['Int']['output']>;
  /** Sales revenue to reach next level */
  targetSalesRevenueRemaining?: Maybe<Scalars['Float']['output']>;
};

export type EditSubscriptionNotificationPayloadInput = {
  /** Email subscription status, True/False if it is enabled */
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key of the subscription */
  notificationKey?: InputMaybe<Scalars['String']['input']>;
  /** Push subscription status, True/False if it is enabled */
  pushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Point at which a customer wishes to receive a notification based on percentage difference in price */
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

/** Seller Profile Eligible Services */
export enum EligibleServices {
  /** Seller profile is eligible for custodial */
  CUSTODIAL = 'CUSTODIAL',
}

/** Enhanced Image information */
export type EnhancedImage = {
  /** Total count of images for this product */
  imageCount?: Maybe<Scalars['Int']['output']>;
  /** Host of the image (like stockx-360.imgix.net) */
  imageHost?: Maybe<Scalars['String']['output']>;
  /** Product key for the image */
  imageKey?: Maybe<Scalars['String']['output']>;
  /** Uuid of the product that is in the picture(s) */
  productUuid?: Maybe<Scalars['String']['output']>;
};

/** An experiment variant that a user is enrolled in */
export type ExperimentVariant = {
  /** An unique identifier for this experiment variant */
  id?: Maybe<Scalars['ID']['output']>;
};

/** A flag that modifies the behavior of an app */
export type FeatureFlag = {
  /** A key that identifies this feature flag */
  key?: Maybe<Scalars['String']['output']>;
};

export type FindAllListingOperationsInput = {
  /** The cursor to use as a starting point */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The number of changes to fetch */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The listing id */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FindListingByIdInput = {
  /** The id of the listing */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The type of the Id */
  type?: InputMaybe<ListingsIdType>;
};

export type FindListingOperationByIdInput = {
  /** The id of the listing */
  listingId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the listing operation */
  operationId?: InputMaybe<Scalars['String']['input']>;
};

export type FindRecentListingChangesInput = {
  /** The cursor to use as a starting point */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The number of changes to fetch */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Seller flake penalty */
export type FlakePenalty = {
  /** GMV dollar amount threshold to charge by percentage */
  chargeByPercentThreshold?: Maybe<Scalars['String']['output']>;
  /** Whether or not this seller exempt from penalty */
  exempt?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum dollar amount is charged */
  maxDollarAmount?: Maybe<Scalars['String']['output']>;
  /** Minimum dollar amount is charged */
  minDollarAmount?: Maybe<Scalars['String']['output']>;
  /** Percentage charged if GMV dollar amount over threshold */
  percentageAmount?: Maybe<Scalars['String']['output']>;
};

/** Input for followProducts mutation */
export type FollowProductsInput = {
  /** List of params */
  items?: InputMaybe<Array<InputMaybe<FollowProductsInputDataInput>>>;
};

/** Data for followProducts mutation */
export type FollowProductsInputDataInput = {
  /** Portfolio Item action */
  action?: InputMaybe<Scalars['Int']['input']>;
  /** Portfolio Item amount */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Variant Id */
  variantId?: InputMaybe<Scalars['String']['input']>;
};

/** Portfolio item response */
export type FollowResponse = {
  /** PortfolioItem response object */
  followedItem?: Maybe<Variant>;
};

/** Contains an address and the display string for the address */
export type FormattedAddress = {
  /** The address */
  address?: Maybe<Address>;
  /** The display string representing the address */
  display?: Maybe<Scalars['String']['output']>;
};

/** Contains the raw and parsed shipping address based on the saved dynamic address */
export type FormattedShippingAddress = {
  /** Formatted address using the transliterated data based on the data inputted by the user */
  parsed?: Maybe<FormattedAddress>;
  /** Formatted address using the raw data inputted by the user */
  raw?: Maybe<FormattedAddress>;
};

/** Fill image information for a banner image */
export type FullImageInformation = {
  /** ACL */
  ACL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** What type of content is this image */
  contentType?: Maybe<Scalars['String']['output']>;
  /** When the image was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Who created the image */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Size of the file */
  fileSize?: Maybe<Scalars['String']['output']>;
  /** Name of the file */
  filename?: Maybe<Scalars['String']['output']>;
  /** Is this a directory */
  isDir?: Maybe<Scalars['Boolean']['output']>;
  /** Details around the publishing of this picture */
  publishDetails?: Maybe<PublishDetails>;
  /** Tags associated with the image */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Image title */
  title?: Maybe<Scalars['String']['output']>;
  /** Image Id */
  uid?: Maybe<Scalars['String']['output']>;
  /** The last time the image was updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Who updated the image */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Url to the image */
  url?: Maybe<Scalars['String']['output']>;
  /** Image version */
  version?: Maybe<Scalars['Int']['output']>;
};

export type Gdpr = {
  /** Has the customer ever filed a chargeback */
  hasChargebacks?: Maybe<Scalars['Boolean']['output']>;
  /** Has a closed transaction */
  hasClosedTransactions?: Maybe<Scalars['Boolean']['output']>;
  /** Has an open transaction */
  hasOpenTransactions?: Maybe<Scalars['Boolean']['output']>;
  /** Is the customer actively suspended from buying */
  isSuspendedFromBuying?: Maybe<Scalars['Boolean']['output']>;
  /** Is the customer actively suspended from selling */
  isSuspendedFromSelling?: Maybe<Scalars['Boolean']['output']>;
};

/** GTIN information for a variant. */
export type Gtin = {
  /** The real gtin value */
  identifier?: Maybe<Scalars['String']['output']>;
  /** The type of the gtin. */
  type?: Maybe<Scalars['String']['output']>;
};

/** Gate context */
export type Gate = {
  /** App versions to gate for this context */
  app?: Maybe<GatedVersions>;
  /** Name of the gate */
  name?: Maybe<Scalars['String']['output']>;
  /** OS versions to gate for this context */
  os?: Maybe<GatedVersions>;
};

/** Version information for gating */
export type GatedVersion = {
  /** Minimum supported version for this gate */
  minimum?: Maybe<Scalars['String']['output']>;
  /** Duration of time bewtween nags for telling user to update */
  nagDuration?: Maybe<Scalars['Float']['output']>;
  /** Specific versions to gate */
  others?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Required and deprecated versioning information for gating */
export type GatedVersions = {
  /** Deprecated versions */
  deprecated?: Maybe<GatedVersion>;
  /** Required versions */
  required?: Maybe<GatedVersion>;
};

/** The generic error for the address form */
export type GenericAddressError = {
  /** Error description */
  description?: Maybe<Scalars['String']['output']>;
  /** Error title */
  title?: Maybe<Scalars['String']['output']>;
};

export type GeoIpLocation = {
  /** The radius in kilometers around the specified location where the IP address is likely to be. */
  accuracyRadius?: Maybe<Scalars['Int']['output']>;
  /** The city name for this location. */
  cityName?: Maybe<Scalars['String']['output']>;
  /** The continent code for this location. */
  continentCode?: Maybe<ContinentCode>;
  /** The continent name for this location. */
  continentName?: Maybe<Scalars['String']['output']>;
  /** A two-character ISO 3166-1 country code for the country associated with the location. */
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  /** The country name for this location. */
  countryName?: Maybe<Scalars['String']['output']>;
  /** This determines whether the IP address is used by an anonymizing service. */
  isAnonymousProxy?: Maybe<Scalars['Boolean']['output']>;
  /** This is true if the country associated with the location is a member state of the European Union. It is false otherwise. */
  isInEuropeanUnion?: Maybe<Scalars['Boolean']['output']>;
  /** This checks if is a satellite provider. */
  isSatelliteProvider?: Maybe<Scalars['Boolean']['output']>;
  /** Metro code is a geolocation target code from Google. */
  metroCode?: Maybe<Scalars['Int']['output']>;
  /** A postal code close to the user's location. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /**
   * A string of up to three characters containing the region-portion of the ISO 3166-2 code
   *  for the first level region associated with the IP address.
   */
  subdivision1IsoCode?: Maybe<Scalars['String']['output']>;
  /** The subdivision name for this location. This is the least specific subdivision for the location. */
  subdivision1Name?: Maybe<Scalars['String']['output']>;
  /**
   * A string of up to three characters containing the region-portion of the ISO 3166-2 code
   *  for the second level region associated with the IP address.
   */
  subdivision2IsoCode?: Maybe<Scalars['String']['output']>;
  /** The subdivision name for this location. This is the most specific subdivision for the location. */
  subdivision2Name?: Maybe<Scalars['String']['output']>;
  /** The time zone associated with location */
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type GetCreateBatchAskInput = {
  /** The id of the batch to fetch */
  batchId?: InputMaybe<Scalars['String']['input']>;
};

export type GetCreateListingBatchInput = {
  /** The id of the batch to fetch */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** The state of the asks to fetch */
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GetDeleteListingBatchInput = {
  /** The id of the batch to fetch */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** The state of listings to fetch */
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GetUpdateListingBatchInput = {
  /** The id of the batch to fetch */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** The state of listings to fetch */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Hazardous Material information for a product */
export type HazardousMaterial = {
  /** The lithium ion battery hazardous material bucket the product belongs to. Null if it is not assigned to a bucket */
  lithiumIonBucket?: Maybe<LithiumHazardousBucketType>;
};

/** Implementation of interface for Banner Carousel */
export type HomeBannerCarouselComponent = HomeLayoutComponent & {
  /** The unique id of the banner carousel. */
  carousel?: Maybe<Scalars['String']['output']>;
  /** The order of the component among the other components. */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of the component. */
  type?: Maybe<HomeLayoutComponentType>;
};

/** Implementation of interface for Banner Collage */
export type HomeBannerCollageComponent = HomeLayoutComponent & {
  /** The unique id of the banner collage. */
  collage?: Maybe<Scalars['String']['output']>;
  /** The display type for the banner collage. */
  displayType?: Maybe<HomeBannerCollageDisplayType>;
  /** The order of the component among the other components. */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component. */
  type?: Maybe<HomeLayoutComponentType>;
};

/** Enum for the display order of banner collages */
export enum HomeBannerCollageDisplayType {
  /** Shows the banner collage as [large][small] */
  LEADING_WITH_LARGE = 'LEADING_WITH_LARGE',
  /** Shows the banner collage as [small][large] */
  LEADING_WITH_SMALL = 'LEADING_WITH_SMALL',
}

/** Implementation of interface for the consumer protection component */
export type HomeConsumerProtectionComponent = HomeLayoutComponent & {
  /** The order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component being represented */
  type?: Maybe<HomeLayoutComponentType>;
};

export type HomeCurrentAsksComponent = HomeLayoutComponent & {
  /** The order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component being represented */
  type?: Maybe<HomeLayoutComponentType>;
};

export type HomeCurrentBidsComponent = HomeLayoutComponent & {
  /** The order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component being represented */
  type?: Maybe<HomeLayoutComponentType>;
};

export type HomeLatestNewsComponent = HomeLayoutComponent & {
  /** The order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component being represented */
  type?: Maybe<HomeLayoutComponentType>;
};

/** The interface for different components on the homepage */
export type HomeLayoutComponent = {
  /** The order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component being represented */
  type?: Maybe<HomeLayoutComponentType>;
};

/** The base enum for the different components on the homepage */
export enum HomeLayoutComponentType {
  /** Represents a banner carousel component */
  BANNER_CAROUSEL = 'BANNER_CAROUSEL',
  /** Represents a banner collage component */
  BANNER_COLLAGE = 'BANNER_COLLAGE',
  /** Represents a consumer protection component */
  CONSUMER_PROTECTION = 'CONSUMER_PROTECTION',
  /** Represents a user's current asks component */
  CURRENT_ASKS = 'CURRENT_ASKS',
  /** Represents a user's current bids component */
  CURRENT_BIDS = 'CURRENT_BIDS',
  /** Represents the latest news component */
  LATEST_NEWS = 'LATEST_NEWS',
  /** Represents a product collection component */
  PRODUCT_COLLECTION = 'PRODUCT_COLLECTION',
  /** Represents a shop by component */
  SHOP_BY = 'SHOP_BY',
  /** Represents a tile collection component */
  TILE_COLLECTION = 'TILE_COLLECTION',
  /** Represents a user generated content collecton component */
  USER_GENERATED_CONTENT_COLLECTION = 'USER_GENERATED_CONTENT_COLLECTION',
  /** Represents the value props component */
  VALUE_PROPS = 'VALUE_PROPS',
}

/** Implementation of interface for product collections */
export type HomeProductCollectionComponent = HomeLayoutComponent & {
  /** The unique id of the product collection. */
  collection?: Maybe<Scalars['String']['output']>;
  /** The order of the component among others. */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of products to show in the collection. */
  selectionType?: Maybe<ProductSelectionType>;
  /** The vertical to limit the collection to; treated as all verticals when null. */
  selectionVertical?: Maybe<Vertical>;
  /** The type of component being represented. */
  type?: Maybe<HomeLayoutComponentType>;
};

/** Implementation of interface for the shop by component */
export type HomeShopByComponent = HomeLayoutComponent & {
  /** The order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component being represented */
  type?: Maybe<HomeLayoutComponentType>;
};

/** Implementation of interface for tile collections */
export type HomeTileCollectionComponent = HomeLayoutComponent & {
  /** The unique id of the tile collection */
  collection?: Maybe<Scalars['String']['output']>;
  /** The order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component being represented */
  type?: Maybe<HomeLayoutComponentType>;
};

export type HomeUserGeneratedContentCollectionComponent =
  HomeLayoutComponent & {
    /** The unique id of the tile collection */
    collection?: Maybe<Scalars['String']['output']>;
    /** The order of the component among others */
    order?: Maybe<Scalars['Int']['output']>;
    /** The type of component being represented */
    type?: Maybe<HomeLayoutComponentType>;
  };

export type HomeValuePropsComponent = HomeLayoutComponent & {
  /** The order of the component among others */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of component being represented */
  type?: Maybe<HomeLayoutComponentType>;
  /** The designated variant grouping for the Value Props test. */
  variant?: Maybe<HomeValuePropsVariantType>;
};

/** Enum for the variant type of value props */
export enum HomeValuePropsVariantType {
  /** The first of two possible variant groups */
  VARIANT_ONE = 'VARIANT_ONE',
  /** The second of two possible variant groups */
  VARIANT_TWO = 'VARIANT_TWO',
}

/** Hub filter definition */
export type HubFilterInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** The Hyperwallet vendor representation of the seller */
export type Hyperwallet = {
  /** Hyperwallet customer representation */
  customer?: Maybe<HyperwalletCustomer>;
  /** Hyperwaller Profile Type; (VALUES: INDIVIDUAL OR BUSINESS) */
  profileType?: Maybe<HyperwalletProfileType>;
  /** Hyperwallet provider */
  provider?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet provider status */
  providerStatus?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet status; e.g., ACTIVE */
  status?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet customer tax verification status (For Seller TIN verification) */
  taxVerificationStatus?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet's UUID for the seller */
  uuid?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet customer verification status */
  verificationStatus?: Maybe<Scalars['String']['output']>;
};

/** Hyperwallet address */
export type HyperwalletAddress = {
  /** Hyperwallet country code */
  countryCodeAlpha2?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet extended address */
  extendedAddress?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet locality */
  locality?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet middlename */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet region */
  region?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet street address */
  streetAddress?: Maybe<Scalars['String']['output']>;
};

/** Hyperwallet customer */
export type HyperwalletCustomer = {
  /** Hyperwallet address */
  address?: Maybe<HyperwalletAddress>;
  /** Hyperwallet DOB */
  dob?: Maybe<Scalars['ISODate']['output']>;
  /** Hyperwallet email */
  email?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet government ID */
  governmentId?: Maybe<Scalars['String']['output']>;
  /** hyperwallet government ID type */
  governmentIdType?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet middlename */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet nationality */
  nationality?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Hyperwallet Seller Profile Type */
export enum HyperwalletProfileType {
  /** Seller profile belongs to a Business */
  BUSINESS = 'BUSINESS',
  /** Seller profile belongs to an Individual */
  INDIVIDUAL = 'INDIVIDUAL',
  /** Seller profile is either empty, not defined or null. Safety check only */
  UNDEFINED = 'UNDEFINED',
}

/** Id filter definition */
export type IdFilterInput = {
  is?: InputMaybe<Scalars['Int']['input']>;
};

export type IdParameterInput = {
  /** Country where this regulatory id applies */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The id type (ex: license number, tax id) */
  idType?: InputMaybe<Scalars['String']['input']>;
  /** The regulatory id */
  idValue?: InputMaybe<Scalars['String']['input']>;
};

/** Generic image information */
export type Image = {
  /** Flag to indicate if this image is hidden or not */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Link to the image */
  image?: Maybe<Scalars['String']['output']>;
  /** Order of the images */
  order?: Maybe<Scalars['Int']['output']>;
  /** uuid of the product in the picture */
  productUuid?: Maybe<Scalars['String']['output']>;
};

/** Image File */
export type ImageFile = {
  /** Title of the image file */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current image file */
  uid?: Maybe<Scalars['String']['output']>;
  /** Url of the image file */
  url?: Maybe<Scalars['String']['output']>;
};

/** Image information */
export type ImageInformation = {
  /** The alternative text for the image */
  alt?: Maybe<Scalars['String']['output']>;
  /** The URL to use to obtain the image */
  url?: Maybe<Scalars['String']['output']>;
};

/** Link to an image */
export type ImageLink = {
  /** Reference to the image */
  href?: Maybe<Scalars['String']['output']>;
  /** Image title */
  title?: Maybe<Scalars['String']['output']>;
};

/** A single inbox message for a specific user */
export type InboxMessage = {
  /** The delivered timestamp to the user's inbox */
  deliveredAt?: Maybe<Scalars['ISODate']['output']>;
  /** The expiration date of the inbox message */
  expiresAt?: Maybe<Scalars['ISODate']['output']>;
  /** The unique ID (cursor) of the inbox message */
  id?: Maybe<Scalars['String']['output']>;
  /** The thumbnail picture for the inbox message */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether or not the message has been read */
  isRead?: Maybe<Scalars['Boolean']['output']>;
  /** The link to which the inbox message directs to */
  link?: Maybe<Scalars['String']['output']>;
  /** The type of the inbox message */
  messageType?: Maybe<InboxMessageType>;
  /** The subtitle of the inbox message */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The title of the inbox message */
  title?: Maybe<Scalars['String']['output']>;
};

/** An edge to an inbox message */
export type InboxMessageEdge = {
  /** The actual node for an inbox message */
  node?: Maybe<InboxMessage>;
};

/** The payload containing information about a failed mutation on a specific message */
export type InboxMessageFailed = {
  /** The cursor of the specific inbox message */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The error message associated with the mutation operation */
  message?: Maybe<Scalars['String']['output']>;
};

/** The different types of inbox messages */
export enum InboxMessageType {
  /** Inbox messages that are marketing-related */
  MARKETING = 'MARKETING',
}

/** A connection to the inbox messages */
export type InboxMessagesConnection = {
  /** Edges to a list of inbox messages for a user */
  edges?: Maybe<Array<Maybe<InboxMessageEdge>>>;
  /** Information about the current page of messages */
  pageInfo?: Maybe<PageInfo>;
};

/** The different types of sorting options */
export enum InboxSortInput {
  /** Sort by latest messages */
  ASCENDING = 'ASCENDING',
  /** Sort by earliest messages */
  DESCENDING = 'DESCENDING',
}

/** Filter for determining if items that are included in an existing bulk shipment should be returned to the list of shipments */
export type IncludeBulkShipmentItemsFilter = {
  /** If true, will include items that are part of existing bulk shipments */
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Should disabled countries be included */
export type IncludeDisabledInput = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Should GDPR disabled countries be included */
export type IncludeGdprDisabledInput = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Should regions be included */
export type IncludeRegionsInput = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Describes the inventory type for this listing */
export enum InventoryType {
  /** Item being held by StockX */
  CUSTODIAL = 'CUSTODIAL',
  /** Seller will ship item upon match */
  STANDARD = 'STANDARD',
}

/** Country ISO2 code */
export type Iso2Input = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** A feature flag with a JSON string value */
export type JsonFeatureFlag = FeatureFlag & {
  /** The value of this feature flag as a JSON string */
  jsonValue?: Maybe<Scalars['JSONString']['output']>;
  /** A key that identifies this feature flag */
  key?: Maybe<Scalars['String']['output']>;
};

export type LreAction = {
  /** Action field which is a slug for predefined actions to execute */
  action?: Maybe<Scalars['String']['output']>;
  /** Whether the action is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the action was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Has the action been deleted? */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Action id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Action name */
  name?: Maybe<Scalars['String']['output']>;
  /** Rule id */
  ruleId?: Maybe<Scalars['Int']['output']>;
  /** Date of action last update */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
  /** Action field which will be used by the predefined actions */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input for LREAction mutation */
export type LreActionInput = {
  /** Action field which is a slug for predefined actions to execute */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Whether the action is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Action name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rule Id */
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  /** Action field which will be used by the predefined actions */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LreActionsConnection = {
  /** Array of action nodes on the graph */
  edges?: Maybe<Array<Maybe<LreActionsEdge>>>;
  /** Info about the page results (pagination) */
  pageInfo?: Maybe<LrePageInfo>;
};

export type LreActionsEdge = {
  /** Represents a single action node on the graph */
  node?: Maybe<LreAction>;
};

export type LreCheck = {
  /** Whether the check is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Check field for describing how to compare the source and the value fields */
  comparison?: Maybe<Scalars['String']['output']>;
  /** Condition id */
  conditionId?: Maybe<Scalars['Int']['output']>;
  /** Date when the check was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Has the check been deleted? */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Check id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Check name */
  name?: Maybe<Scalars['String']['output']>;
  /** Check source */
  source?: Maybe<Scalars['String']['output']>;
  /** Date of check last update */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
  /** Check field for defining a comparison value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input for LRECheck mutation */
export type LreCheckInput = {
  /** Whether the check is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Check field for describing how to compare the source and the value fields */
  comparison?: InputMaybe<Scalars['String']['input']>;
  /** Condition Id */
  conditionId?: InputMaybe<Scalars['Int']['input']>;
  /** Check name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Check source */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Check field for defining a comparison value */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LreChecksConnection = {
  /** Array of check nodes on the graph */
  edges?: Maybe<Array<Maybe<LreChecksEdge>>>;
  /** Info about the page results (pagination) */
  pageInfo?: Maybe<LrePageInfo>;
};

export type LreChecksEdge = {
  /** Represents a single check node on the graph */
  node?: Maybe<LreCheck>;
};

export type LreCondition = {
  /** Whether the condition is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Checks list for a Condition */
  checks?: Maybe<Array<Maybe<LreCheck>>>;
  /** Date when the condition was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Has the condition been deleted? */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Condition id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Condition name */
  name?: Maybe<Scalars['String']['output']>;
  /** Rule id */
  ruleId?: Maybe<Scalars['Int']['output']>;
  /** Tree id */
  treeId?: Maybe<Scalars['Int']['output']>;
  /** Date of condition last update */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** Input for LRECondition mutation */
export type LreConditionInput = {
  /** Whether the condition is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Condition name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rule Id */
  ruleId?: InputMaybe<Scalars['Int']['input']>;
};

export type LreConditionsConnection = {
  /** Array of condition nodes on the graph */
  edges?: Maybe<Array<Maybe<LreConditionsEdge>>>;
  /** Info about the page results (pagination) */
  pageInfo?: Maybe<LrePageInfo>;
};

export type LreConditionsEdge = {
  /** Represents a single condition node on the graph */
  node?: Maybe<LreCondition>;
};

/** CreatedAt filter definition */
export type LreCreatedAtFilterInput = {
  gt?: InputMaybe<Scalars['ISODate']['input']>;
};

/** LRE Tree filters */
export type LreFilterInput = {
  createdAt?: InputMaybe<LreCreatedAtFilterInput>;
  id?: InputMaybe<LreIdFilterInput>;
  name?: InputMaybe<LreNameFilterInput>;
  slug?: InputMaybe<LreSlugFilterInput>;
  updatedAt?: InputMaybe<LreUpdatedAtFilterInput>;
};

/** TreeId filter definition */
export type LreIdFilterInput = {
  is?: InputMaybe<Scalars['Int']['input']>;
};

/** Name filter definition */
export type LreNameFilterInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** LRE Tree order options */
export enum LreOrderInput {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** LRE pagination info */
export type LrePageInfo = {
  /** Has next paginated page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a previous page exists */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** Page size of tree results */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Page order of tree results */
  order?: Maybe<Scalars['String']['output']>;
  /** Page number of tree results */
  page?: Maybe<Scalars['Int']['output']>;
  /** Page sort of tree results */
  sort?: Maybe<Scalars['String']['output']>;
  /** Total number of items available */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LreRule = {
  /** Actions list for a rule */
  actions?: Maybe<Array<Maybe<LreAction>>>;
  /** Whether the rule is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Conditions list for a rule */
  conditions?: Maybe<Array<Maybe<LreCondition>>>;
  /** Date when the rule was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Has the rule been deleted? */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Rule id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Rule name */
  name?: Maybe<Scalars['String']['output']>;
  /** Action to be taken when this matches */
  onHit?: Maybe<Scalars['String']['output']>;
  /** Action to be taken when nothing matches */
  onMiss?: Maybe<Scalars['String']['output']>;
  /** Rule field to know what order to run */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Tree id */
  treeId?: Maybe<Scalars['Int']['output']>;
  /** Date of rule last update */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** Input for LRERule mutation */
export type LreRuleInput = {
  /** Whether the rule is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has the rule been deleted? */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Rule name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Action to be taken when this matches */
  onHit?: InputMaybe<Scalars['String']['input']>;
  /** Action to be taken when nothing matches */
  onMiss?: InputMaybe<Scalars['String']['input']>;
  /** Rule field to know what order to run */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Rule name */
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type LreRulesConnection = {
  /** Array of rule nodes on the graph */
  edges?: Maybe<Array<Maybe<LreRulesEdge>>>;
  /** Info about the page results (pagination) */
  pageInfo?: Maybe<LrePageInfo>;
};

export type LreRulesEdge = {
  /** Represents a single rule node on the graph */
  node?: Maybe<LreRule>;
};

/** Slug filter definition */
export type LreSlugFilterInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** LRE Tree sort options */
export enum LreSortInput {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  PRIORITY = 'PRIORITY',
  UPDATED_AT = 'UPDATED_AT',
}

export type LreTree = {
  /** Whether the tree is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Tree field for describing how to compare the source and the value fields */
  comparison?: Maybe<Scalars['String']['output']>;
  /** Date when the tree was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Has the tree been deleted? */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Tree Id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Tree name */
  name?: Maybe<Scalars['String']['output']>;
  /** Action to be taken when this matches */
  onHit?: Maybe<Scalars['String']['output']>;
  /** Action to be taken when nothing matches */
  onMiss?: Maybe<Scalars['String']['output']>;
  /** Tree field to know what order to run */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Rules list for a tree */
  rules?: Maybe<Array<Maybe<LreRule>>>;
  /** Tree slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Tree field for describing the path to find the source value to check against */
  source?: Maybe<Scalars['String']['output']>;
  /** Date of tree last update */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
  /** Tree field for defining a comparison value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input for LRETree mutation */
export type LreTreeInput = {
  /** Whether the tree is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tree field for describing how to compare the source and the value fields */
  comparison?: InputMaybe<Scalars['String']['input']>;
  /** Has the tree been deleted? */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tree name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Action to be taken when this matches */
  onHit?: InputMaybe<Scalars['String']['input']>;
  /** Action to be taken when nothing matches */
  onMiss?: InputMaybe<Scalars['String']['input']>;
  /** Tree field to know what order to run */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Tree slug */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Tree field for describing the path to find the source value to check against */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Tree field for defining a comparison value */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LreTreesConnection = {
  /** Array of tree nodes on the graph */
  edges?: Maybe<Array<Maybe<LreTreesEdge>>>;
  /** Info about the page results (pagination) */
  pageInfo?: Maybe<LrePageInfo>;
};

export type LreTreesEdge = {
  /** Represents a single tree node on the graph */
  node?: Maybe<LreTree>;
};

/** UpdatedAt filter definition */
export type LreUpdatedAtFilterInput = {
  gt?: InputMaybe<Scalars['ISODate']['input']>;
};

/** Statistics around the last sale. */
export type LastSaleStatistics = {
  /** The amount of the last sale. */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** The variant associated with the last sale. */
  associatedVariant?: Maybe<Variant>;
  /** The change in price expressed as a percentage when comparing this sale to the previous sale. */
  changePercentage?: Maybe<Scalars['Float']['output']>;
  /** The change in price when comparing this sale to the previous sale. */
  changeValue?: Maybe<Scalars['BigInt']['output']>;
  /** The date and time the sale occurred at. */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Describes whether or not user's in the provided market would have experienced similar buy-side fees for the sale. */
  sameFees?: Maybe<Scalars['Boolean']['output']>;
};

/** Price level of a given item */
export type Level = {
  /** Amount of level */
  amount?: Maybe<Scalars['String']['output']>;
  /** Count of unique occurrences of this level */
  count?: Maybe<Scalars['Int']['output']>;
  /** Describes whether or not the market associated with this bid/ask is the same as the requested market. */
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  /** Count of my level at this item and price */
  ownCount?: Maybe<Scalars['Int']['output']>;
  /** Variant associated with this bid/ask */
  variant?: Maybe<Variant>;
};

/** Node wrapper around level */
export type LevelNode = {
  /** The level */
  node?: Maybe<Level>;
};

/** Pagination information for levels */
export type LevelPageInfo = {
  /** Count of results being returned */
  count?: Maybe<Scalars['Int']['output']>;
  /** Has next page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Current page */
  page?: Maybe<Scalars['Int']['output']>;
  /** Total number of asks / bids */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Implementation of Link */
export type Link = {
  /** The Destination of the Link */
  destination?: Maybe<LinkDestination>;
  /** Href details of the Link */
  link?: Maybe<LinkHref>;
};

/** Enum for different Link Destinations */
export enum LinkDestination {
  /** Browse Page Url */
  BROWSE = 'BROWSE',
  /** External Url */
  EXTERNAL = 'EXTERNAL',
  /** Product Page Url */
  PRODUCT = 'PRODUCT',
}

/** Implementation of Href of the Link */
export type LinkHref = {
  /** Target Url of the Link */
  href?: Maybe<Scalars['String']['output']>;
  /** Title of the Link */
  title?: Maybe<Scalars['String']['output']>;
};

/** Link information */
export type LinkInformation = {
  /** The title text to use for the link */
  title?: Maybe<Scalars['String']['output']>;
  /** The destination URL */
  url?: Maybe<Scalars['String']['output']>;
  /** The page type for the URL */
  urlType?: Maybe<PageType>;
};

/** A list represents a named collection of variants that a user has favorited. */
export type List = {
  /** Describes whether or not this is the default list */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** The unique id for the list. */
  id?: Maybe<Scalars['String']['output']>;
  /** The items associated with the list. */
  items?: Maybe<ListItemsConnection>;
  /** The name of the list. */
  name?: Maybe<Scalars['String']['output']>;
  /** Describes whether or not the list should have notifications enabled. */
  notify?: Maybe<Scalars['Boolean']['output']>;
  /** The visibility state of the list. */
  public?: Maybe<Scalars['Boolean']['output']>;
};

/** A list represents a named collection of variants that a user has favorited. */
export type ListItemsArgs = {
  page?: InputMaybe<ListItemsPageInput>;
  sort?: InputMaybe<ListItemsSortInput>;
};

/** Connection to a set of pagianted items within a list. */
export type ListItemsConnection = {
  /** The edges to the list items. */
  edges?: Maybe<Array<Maybe<ListItemsEdge>>>;
  /** The page information. */
  pageInfo?: Maybe<ListItemsPageInfo>;
};

/** The edge to the actual variant in the list. */
export type ListItemsEdge = {
  /** The variant that was followed. */
  node?: Maybe<Variant>;
};

/** Input object for list items */
export type ListItemsInput = {
  /** The id of the list */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The product id */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** The variant id */
  variantId?: InputMaybe<Scalars['String']['input']>;
};

/** The pagination information returned when fetching the items within a user's list. */
export type ListItemsPageInfo = {
  /** The index of the page that was requested. */
  index?: Maybe<Scalars['Int']['output']>;
  /** The limit that was used. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The total number of results. */
  total?: Maybe<Scalars['Int']['output']>;
};

/** The pagination information when fetching the items within a user's list. */
export type ListItemsPageInput = {
  /** The index of the page to fetch. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items to fetch per page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Item response object */
export type ListItemsResult = {
  /** Variant response object */
  item?: Maybe<Variant>;
  /** The status of the item. eg.Updated/Partial updated */
  status?: Maybe<UpdateListItemResult>;
};

/** The sorting options available when fetching the items within a user's list. */
export enum ListItemsSort {
  /** Sorts the list items by the created_at time. */
  CREATED_AT = 'CREATED_AT',
  /** Sorts the list items by the updated_at time. */
  UPDATED_AT = 'UPDATED_AT',
}

/** The sorting options available when fetching the items within a user's list. */
export type ListItemsSortInput = {
  /** The sorting algorithm to use. */
  by?: InputMaybe<ListItemsSort>;
  /** The order to sort the results in. */
  order?: InputMaybe<AscDescOrderInput>;
};

/** A representation of a product that user has asks for, and metadata about those asks */
export type ListedProduct = {
  /** Representation of a Product at StockX for a product, the user has listed */
  product?: Maybe<Product>;
  /** Total count of asks of a specific product */
  totalAskCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge to the listed product */
export type ListedProductEdge = {
  /** Product that is listed by user */
  node?: Maybe<ListedProduct>;
};

/** A connection to the listed product */
export type ListedProductsConnection = {
  /** Edges to a unique list of products that user is selling or has sold */
  edges?: Maybe<Array<Maybe<ListedProductEdge>>>;
  /** Information about the current page in the pagination */
  pageInfo?: Maybe<PageInfo>;
};

export type ListedProductsFiltersInput = {
  /** Filter by product ids */
  productId?: InputMaybe<ProductIdsFilter>;
  /** Filter by verticals */
  vertical?: InputMaybe<VerticalsFilter>;
};

/** Individual ways of sorting a list of products */
export enum ListedProductsSortOptions {
  /** Product title */
  TITLE = 'TITLE',
}

export type Listing = {
  /** Flag used to indicate whether or not the listing is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Ask related data, used if the listing is active */
  askData?: Maybe<ListingAskData>;
  /** When the listing was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Flag used to indicate whether or not the listing is deleted */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Flag used to indicate whether or not the listing is expired */
  expired?: Maybe<Scalars['Boolean']['output']>;
  /** Listing id */
  id?: Maybe<Scalars['String']['output']>;
  /** Inactive ask related data, used when the listing is not active */
  inactiveAskData?: Maybe<ListingBaseAskData>;
  /** Inventory type for the listing */
  inventoryType?: Maybe<InventoryType>;
  /** The last recoreded operation associated with this listing */
  lastOperation?: Maybe<ListingOperation>;
  /** Order related data */
  orderData?: Maybe<ListingOrderData>;
  /** Seller supplied metadata to be stored with the listing */
  partnerMetadata?: Maybe<Scalars['String']['output']>;
  /** Pending ask related data, used when there are updates to the ask awaiting asyn confirmation from Grails */
  pendingAskData?: Maybe<ListingBaseAskData>;
  /** Status of the listing */
  status?: Maybe<ListingStatus>;
  /** Describes whether or not the listing is synced */
  syncStatus?: Maybe<ListingSyncStatus>;
  /** Describes the last time the sync status was changed */
  syncStatusUpdatedAt?: Maybe<Scalars['ISODate']['output']>;
  /** When the listing was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
  /** Seller id */
  userId?: Maybe<Scalars['String']['output']>;
};

export type ListingAskData = {
  /** The local price of the listed ask */
  amount?: Maybe<Scalars['String']['output']>;
  /** The actual ask that was created */
  ask?: Maybe<Ask>;
  /** The currency of the ask */
  currency?: Maybe<CurrencyCode>;
  /** The date that the ask is set to expire */
  expiresAt?: Maybe<Scalars['ISODate']['output']>;
  /** Chain id of the ask */
  id?: Maybe<Scalars['String']['output']>;
  /** The sku of the ask */
  productVariant?: Maybe<Variant>;
  /** The state that the ask is in */
  state?: Maybe<Scalars['Int']['output']>;
};

export type ListingAsyncOperationResponse = {
  /** The listing changes associated with this operation */
  changes?: Maybe<ListingOperationChanges>;
  /** When the operation was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Error message */
  error?: Maybe<Scalars['String']['output']>;
  /** What initiated the operation */
  initiatedBy?: Maybe<ListingOperationInitiatedBy>;
  /** The application that this operation was initiated on */
  initiatedVia?: Maybe<Scalars['String']['output']>;
  /** Listing id */
  listingId?: Maybe<Scalars['String']['output']>;
  /** Operation id */
  operationId?: Maybe<Scalars['String']['output']>;
  /** Status of the operation */
  status?: Maybe<ListingOperationStatus>;
  /** Type of operation */
  type?: Maybe<ListingOperationType>;
  /** When the operation was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

export type ListingAsyncPayload = {
  /** The async operation response object */
  data?: Maybe<ListingAsyncOperationResponse>;
};

/** Describes the bare minimum attributes required to create an ask in Grails */
export type ListingBaseAskData = {
  /** The asking price for the product */
  amount?: Maybe<Scalars['String']['output']>;
  /** Current currency that the ask being represented in */
  currentCurrency?: Maybe<CurrencyCode>;
  /** When the ask is meant to expire */
  expires?: Maybe<Scalars['ISODate']['output']>;
  /** Product variant associated with the ask */
  productVariant?: Maybe<Variant>;
};

export type ListingCreateInput = {
  /** Flag used to indicate that the listing should be active or not */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ask price that is listed on StockX.com */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** The currency that the given amount refers to */
  currency?: InputMaybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expiresAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** Arbitrary JSON object string of data to be associated with a listing */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** The variant id of the product that this ask is for */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type ListingDeleteInput = {
  /** The id of the listing to cancel */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Listing filters */
export type ListingFiltersInput = {
  /** Filter results by a list of batch ids */
  batchIds?: InputMaybe<StringInListFilterInput>;
  /** Filter results based on when the item is/was expected to be shipped */
  dateToShip?: InputMaybe<ListingsDateToShipFilterInput>;
  /** Filter results based on the number of days listed on StockX */
  daysListed?: InputMaybe<NumericIntFilter>;
  /** The starting date to search for listings */
  fromDate?: InputMaybe<StringEqualsFilterInput>;
  /** Filter listings based on a list of inventory types */
  inventoryTypes?: InputMaybe<StringInListFilterInput>;
  /** Filter on whether or not the listing is in a bulk shipment */
  isInBulkShipment?: InputMaybe<BooleanIsFilterInput>;
  /** Filter on whether or not the listing is the lowest ask for its given variant */
  isLowestAsk?: InputMaybe<BooleanIsFilterInput>;
  /** Filter listings based on a list of listing statuses */
  listingStatuses?: InputMaybe<StringInListFilterInput>;
  /** The order created starting date to search for listings */
  orderFromDate?: InputMaybe<StringEqualsFilterInput>;
  /** Filter listings based on a list of order statuses */
  orderStatuses?: InputMaybe<StringInListFilterInput>;
  /** The order created ending date to search for listings */
  orderToDate?: InputMaybe<StringEqualsFilterInput>;
  /** Filter results by a list of product ids */
  productIds?: InputMaybe<StringInListFilterInput>;
  /** Filter results by a list of shipment ids */
  shipmentIds?: InputMaybe<StringInListFilterInput>;
  /** Filter results based on the bid/ask spread of the listing */
  spread?: InputMaybe<NumericIntFilter>;
  /** Filter results by a list of ask states */
  statesList?: InputMaybe<NumberInListFilterInput>;
  /** The ending date to search for listings */
  toDate?: InputMaybe<StringEqualsFilterInput>;
  /** Filter results by a list of variant ids */
  variantIds?: InputMaybe<StringInListFilterInput>;
  /** Filter results by a list of product categories */
  verticals?: InputMaybe<StringInListFilterInput>;
};

export type ListingOperation = {
  /** The listing changes associated with this operation */
  changes?: Maybe<ListingOperationChanges>;
  /** When the operation was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Error message */
  error?: Maybe<Scalars['String']['output']>;
  /** Operation id */
  id?: Maybe<Scalars['String']['output']>;
  /** What initiated the operation */
  initiatedBy?: Maybe<ListingOperationInitiatedBy>;
  /** The application that this operation was initiated on */
  initiatedVia?: Maybe<Scalars['String']['output']>;
  /** Listing id */
  listingId?: Maybe<Scalars['String']['output']>;
  /** Status of the operation */
  status?: Maybe<ListingOperationStatus>;
  /** Type of operation */
  type?: Maybe<ListingOperationType>;
  /** When the operation was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

export type ListingOperationChanges = {
  /** Items added to the listing record in the last operation */
  additions?: Maybe<Listing>;
  /** Whether or not changes were detected in the listing from the last operation */
  changesDetected?: Maybe<Scalars['Boolean']['output']>;
  /** Items removed from the listing record in the last operation */
  removals?: Maybe<ListingOperationChangesFieldsRemoved>;
  /** Items updated in the listing record in the last operation */
  updates?: Maybe<Listing>;
};

export type ListingOperationChangesFieldsRemoved = {
  /** Specifies whether or not this field was removed */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  askData?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  createdAt?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  expired?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  id?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  inactiveAskData?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  inventoryType?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  orderData?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  partnerMetadata?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  pendingAskData?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  status?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  syncStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  syncStatusUpdatedAt?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  updatedAt?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether or not this field was removed */
  userId?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a listing operation */
export type ListingOperationConnection = {
  /** Edges to a list of listing operations */
  edges?: Maybe<Array<Maybe<ListingOperationEdge>>>;
  /** Information about the current page in the pagination */
  pageInfo?: Maybe<PageInfo>;
};

/** An edge to a Listing Operation */
export type ListingOperationEdge = {
  /** The requested listing operation */
  node?: Maybe<ListingOperation>;
};

/** Describes what initiated the given operation */
export enum ListingOperationInitiatedBy {
  /** The system initiated this operation */
  SYSTEM = 'SYSTEM',
  /** A user initiated this operation */
  USER = 'USER',
}

export type ListingOperationPayload = {
  /** The listing operation object */
  operation?: Maybe<ListingOperation>;
};

/** Describes the status of the given operation */
export enum ListingOperationStatus {
  /** The operation changes failed to apply */
  FAILED = 'FAILED',
  /** The operation changes are still in progress */
  PENDING = 'PENDING',
  /** The operation changes were applied successfully */
  SUCCEEDED = 'SUCCEEDED',
}

/** Describes the type of the operation */
export enum ListingOperationType {
  /** Operation type used to denote a listing passing from inactive to active */
  ACTIVATE = 'ACTIVATE',
  /** This is a create operation */
  CREATE = 'CREATE',
  /** Operation type used to denote a listing passing from active to inactive */
  DEACTIVATE = 'DEACTIVATE',
  /** This is a delete operation */
  DELETE = 'DELETE',
  /** This is an update operation */
  UPDATE = 'UPDATE',
}

export type ListingOrderData = {
  /** Order id */
  id?: Maybe<Scalars['String']['output']>;
  /** Status of the order */
  status?: Maybe<ListingOrderStatus>;
};

/** Describes the status of the order. When an order exists, this value is derived from the ask state */
export enum ListingOrderStatus {
  /** Authentication Passed */
  AUTHENTICATED = 'AUTHENTICATED',
  /** The authentication step is in progress */
  AUTHENTICATING = 'AUTHENTICATING',
  /** Authentication Failed */
  AUTHFAILED = 'AUTHFAILED',
  /** Order was canceled */
  CANCELED = 'CANCELED',
  /** STATE_ASK_AUTHORIZATION_FAILED */
  CCAUTHORIZATIONFAILED = 'CCAUTHORIZATIONFAILED',
  /** Order completed successfully */
  COMPLETED = 'COMPLETED',
  /** The order has been created */
  CREATED = 'CREATED',
  /** Seller did not ship */
  DIDNOTSHIP = 'DIDNOTSHIP',
  /** Seller has been paid */
  PAYOUTCOMPLETED = 'PAYOUTCOMPLETED',
  /** System failed to pay the seller */
  PAYOUTFAILED = 'PAYOUTFAILED',
  /** Seller is queued to be paid */
  PAYOUTPENDING = 'PAYOUTPENDING',
  /** The ask matched but the order number is still being generated */
  PENDING = 'PENDING',
  /** Stockx has received the item */
  RECEIVED = 'RECEIVED',
  /** STATE_ASK_RETURNED_TO_SENDER */
  RETURNED = 'RETURNED',
  /** The item was shipped to stockx */
  SHIPPED = 'SHIPPED',
  /** STATE_ASK_TEMPORARILY_SUSPENDED */
  SUSPENDED = 'SUSPENDED',
  /** STATE_ASK_FROM_INVENTORY */
  SYSTEMFULFILLED = 'SYSTEMFULFILLED',
  /** Unexpected state number received */
  UNKNOWN = 'UNKNOWN',
}

export type ListingPayload = {
  /** The listing object */
  listing?: Maybe<Listing>;
};

/** Describes the status of the listing. When a corresponding ask exists, this value is derived from the ask state */
export enum ListingStatus {
  /** The listing exists and there is a corresponding ask on stockx */
  ACTIVE = 'ACTIVE',
  /** Authentication Passed */
  AUTHENTICATED = 'AUTHENTICATED',
  /** The authentication step is in progress */
  AUTHENTICATING = 'AUTHENTICATING',
  /** Authentication Failed */
  AUTHFAILED = 'AUTHFAILED',
  /** Item was canceled */
  CANCELED = 'CANCELED',
  /** STATE_ASK_AUTHORIZATION_FAILED */
  CCAUTHORIZATIONFAILED = 'CCAUTHORIZATIONFAILED',
  /** Item shipped to buyer */
  COMPLETED = 'COMPLETED',
  /** STATE_REMOVED */
  DELETED = 'DELETED',
  /** Seller did not ship */
  DIDNOTSHIP = 'DIDNOTSHIP',
  /** The listing expired before it was sold */
  EXPIRED = 'EXPIRED',
  /** There was an async failure while creating the listing */
  FAILED = 'FAILED',
  /** The listing exists but there is no corresponding ask on stockx */
  INACTIVE = 'INACTIVE',
  /** Bid/Ask matched */
  MATCHED = 'MATCHED',
  /** The order has been created */
  ORDERCREATED = 'ORDERCREATED',
  /** Ask matched but no order id has been associated yet */
  ORDERPENDING = 'ORDERPENDING',
  /** Seller has been paid */
  PAYOUTCOMPLETED = 'PAYOUTCOMPLETED',
  /** System failed to pay the seller */
  PAYOUTFAILED = 'PAYOUTFAILED',
  /** Attempting to create the ask on stockx */
  PENDING = 'PENDING',
  /** Stockx has received the item */
  RECEIVED = 'RECEIVED',
  /** STATE_ASK_RETURNED_TO_SENDER */
  RETURNED = 'RETURNED',
  /** The item was shipped to stockx */
  SHIPPED = 'SHIPPED',
  /** STATE_ASK_TEMPORARILY_SUSPENDED */
  SUSPENDED = 'SUSPENDED',
  /** STATE_ASK_FROM_INVENTORY */
  SYSTEMFULFILLED = 'SYSTEMFULFILLED',
  /** Unexpected state number received */
  UNKNOWN = 'UNKNOWN',
}

/** Describes whether or not the listing is synced with grails */
export enum ListingSyncStatus {
  /** Listing changes successfully synced to grails */
  SYNCED = 'SYNCED',
  /** Changes pending */
  UNSYNCED = 'UNSYNCED',
}

/** Describes the way a product is listed for sale on StockX. */
export enum ListingType {
  /** The product is listed as part of a BreakX experience. */
  BREAKX = 'BREAKX',
  /** The product is listed as part of a charity. */
  CHARITY = 'CHARITY',
  /** The product is listed as part of a DropX. */
  DROPX = 'DROPX',
  /** The product is listed as part of a IPO. */
  IPO = 'IPO',
  /** The product is listed as an NFT */
  NFT = 'NFT',
  /** The product is listed as part of a raffle. */
  RAFFLE = 'RAFFLE',
  /** The product is listed as a restock. */
  RESTOCK = 'RESTOCK',
  /** The product is listed using StockX's standard model. */
  STANDARD = 'STANDARD',
}

export type ListingUpdateInput = {
  /** Flag used to indicate that the listing should be active or not */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ask price that is listed on StockX.com */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** The currency that the given amount refers to */
  currency?: InputMaybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expiresAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** The id of the listing to update */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Arbitrary JSON object string of data to be associated with a listing */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a listing */
export type ListingsConnection = {
  /** Edges to a list of listings associated to a user */
  edges?: Maybe<Array<Maybe<ListingsEdge>>>;
  /** Information about the current page in the pagination */
  pageInfo?: Maybe<PageInfo>;
};

/** Will return listings that should be shipped earlier or later than specified date when specified. */
export type ListingsDateToShipFilterInput = {
  /** Later than */
  gt?: InputMaybe<Scalars['ISODate']['input']>;
  /** Later than or equal. */
  gte?: InputMaybe<Scalars['ISODate']['input']>;
  /** Earlier than */
  lt?: InputMaybe<Scalars['ISODate']['input']>;
  /** Earlier than or equal. */
  lte?: InputMaybe<Scalars['ISODate']['input']>;
};

/** An edge to a listing */
export type ListingsEdge = {
  /** Listing node */
  node?: Maybe<Listing>;
};

/** Ids to use to look up a single listing */
export enum ListingsIdType {
  /** The Id of the associated ask */
  CHAIN_ID = 'CHAIN_ID',
  /** The Id of the listing */
  LISTING_ID = 'LISTING_ID',
}

/** Individual ways of sorting a list of listings */
export enum ListingsSortField {
  /** Spread between user's listing and the highest bid in the market. */
  BID_ASK_SPREAD = 'BID_ASK_SPREAD',
  /** Date the listing was created */
  CREATED_AT = 'CREATED_AT',
  /** Date to ship by */
  DATE_TO_SHIP_BY = 'DATE_TO_SHIP_BY',
  /** When the listing expires */
  EXPIRES = 'EXPIRES',
  /** Highest bid for the user */
  HIGHEST_BID = 'HIGHEST_BID',
  /** Product name */
  ITEM_TITLE = 'ITEM_TITLE',
  /** Date when the listing became active */
  LISTED_AT = 'LISTED_AT',
  /** Lowest ask for the user */
  LOWEST_ASK = 'LOWEST_ASK',
  /** Date when the listing matched in the market place */
  MATCHED_AT = 'MATCHED_AT',
  /** Listing price */
  PRICE = 'PRICE',
  /** Size (sorting order) of the underlying product */
  SIZE = 'SIZE',
  /** Ask state for the listing */
  STATE = 'STATE',
}

/** Connection to a set of paginated lists. */
export type ListsConnection = {
  /** The edges to the list items. */
  edges?: Maybe<Array<Maybe<ListsEdge>>>;
  /** The page information. */
  pageInfo?: Maybe<ListsPageInfo>;
};

/** The edge to the actual list. */
export type ListsEdge = {
  /** Optional; only available when grabbing the lists for a specific product. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The user's list. */
  node?: Maybe<List>;
};

/** The pagination information returned when fetching the user's lists. */
export type ListsPageInfo = {
  /** The index of the page that was requested. */
  index?: Maybe<Scalars['Int']['output']>;
  /** The limit that was used. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The total number of results. */
  total?: Maybe<Scalars['Int']['output']>;
};

/** The pagination information when fetching the user's lists. */
export type ListsPageInput = {
  /** The index of the page to fetch. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items to fetch per page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** The sorting options available when fetching the user's lists. */
export enum ListsSort {
  /** Sorts the lists by the created_at time. */
  CREATED_AT = 'CREATED_AT',
  /** Sorts the lists by the updated_at time. */
  UPDATED_AT = 'UPDATED_AT',
}

/** The sorting information when fetching the user's lists. */
export type ListsSortInput = {
  /** The sorting algorithm to use. */
  by?: InputMaybe<ListsSort>;
  /** The order to sort the results in. */
  order?: InputMaybe<AscDescOrderInput>;
};

/** Enum for lithium hazardous bucket types */
export enum LithiumHazardousBucketType {
  /** Flammable */
  FLAMMABLE = 'FLAMMABLE',
  /** Hazardous Level Four */
  FOUR = 'FOUR',
  /** Hazardous Level One */
  ONE = 'ONE',
  /** Hazardous Level Three */
  THREE = 'THREE',
  /** Hazardous Level Two */
  TWO = 'TWO',
  /** Unknown Bucket Type */
  UNKNOWN = 'UNKNOWN',
}

/** Local Payment Instrument */
export type LocalPaymentInstrument = PaymentInstrument & {
  /** countries */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** instrumentCategory */
  instrumentCategory?: Maybe<Scalars['String']['output']>;
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
  /** provider */
  provider?: Maybe<PaymentProvider>;
};

/** Localized Buyer Size Input */
export type LocalizedBuyerSizeInput = {
  /** title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** type */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Business defined shipping group */
export type LogisticsGroupInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for determining if asks have the lowest prices. */
export type LowestAskFilter = {
  /** If true, will include asks that have lowest asks, if false - will include non-lowest asks. */
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** MFA configuration information for a user */
export type Mfa = {
  /** User MFA enrollment status */
  mfaEnrollment?: Maybe<Scalars['Boolean']['output']>;
};

export type Mxrfc = RegulatoryId & {
  /** Country where this regulatory id applies */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** The id type (ex: license number, tax id) */
  idType?: Maybe<Scalars['String']['output']>;
  /** The regulatory id */
  idValue?: Maybe<Scalars['String']['output']>;
  /** Unique primary key for this regulatory id */
  regIdUuid?: Maybe<Scalars['String']['output']>;
  /** User UUID corresponding to this regulatory id */
  userUuid?: Maybe<Scalars['String']['output']>;
};

/** Up to date market information */
export type Market = {
  /** Bid and Ask data for the product */
  bidAskData?: Maybe<BidAskData>;
  /** Currency code that all the market values will be in */
  currencyCode?: Maybe<CurrencyCode>;
  /**
   * Dead stock information
   * @deprecated This data is now availabile under statistics instead. Please migrate.
   */
  deadStock?: Maybe<DeadStock>;
  /** Price levels for asks and bids of a given item */
  priceLevels?: Maybe<PriceLevelConnection>;
  /** The product associated with the market data */
  productUuid?: Maybe<Scalars['String']['output']>;
  /** Obtains a list of all historical sales for the product/variant. */
  sales?: Maybe<SalesConnection>;
  /**
   * Information regarding sales of the product
   * @deprecated This data is now availabile under statistics instead. Please migrate.
   */
  salesInformation?: Maybe<SalesInformation>;
  /** The sku associated with the market data */
  skuUuid?: Maybe<Scalars['String']['output']>;
  /** The current state of bids and asks for products/variants */
  state?: Maybe<MarketState>;
  /** Market statistics for the product/variant. */
  statistics?: Maybe<MarketStatistics>;
};

/** Up to date market information */
export type MarketBidAskDataArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
};

/** Up to date market information */
export type MarketPriceLevelsArgs = {
  enableAIAPrices?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  transactionType?: InputMaybe<TransactionType>;
};

/** Up to date market information */
export type MarketSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
};

/** Up to date market information */
export type MarketStateArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
};

/** Up to date market information */
export type MarketStatisticsArgs = {
  market?: InputMaybe<Scalars['String']['input']>;
};

/** The price information for bids/asks */
export type MarketQuote = {
  /** The amount in the desired currency */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** The variant associated with the quote */
  associatedVariant?: Maybe<Variant>;
  /** The chain id associated with the quote */
  chainId?: Maybe<Scalars['String']['output']>;
  /** The time the quote was updated at */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** The current state of bids and asks for products/variants */
export type MarketState = {
  /** The quote for the highest bid */
  highestBid?: Maybe<MarketQuote>;
  /** The quote for the lowest ask */
  lowestAsk?: Maybe<MarketQuote>;
  /** The quote for the lowest ask of items held in custodial */
  lowestCustodialAsk?: Maybe<MarketQuote>;
  /** The number of asks */
  numberOfAsks?: Maybe<Scalars['Int']['output']>;
  /** The number of bids */
  numberOfBids?: Maybe<Scalars['Int']['output']>;
  /** The number of custodial asks */
  numberOfCustodialAsks?: Maybe<Scalars['Int']['output']>;
};

/** Statistics around market events for a product/variant. */
export type MarketStatistics = {
  /** Statistics based off of market events captured over the last year. */
  annual?: Maybe<AnnualStatistics>;
  /** Statistics based off of market events captured over the last 72 hours. */
  last72Hours?: Maybe<PeriodStatistics>;
  /** Statistics based off of market events captured over the last 90 days. */
  last90Days?: Maybe<PeriodStatistics>;
  /** Statistics around the last sale. */
  lastSale?: Maybe<LastSaleStatistics>;
  /** Statistics based off of market events captured over the 72 hours before the previous 72 hours. */
  previous72Hours?: Maybe<PeriodStatistics>;
};

/** Should marketing disabled countries be included */
export type MarketingEnabledInput = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Additional images for the product */
export type Media = {
  /** An array of image urls that make up the 360 view */
  all360Images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Enhanced image information for a product */
  enhancedImage?: Maybe<EnhancedImage>;
  /** All of the images for the product */
  gallery?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Url of the main image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Images for a product */
  images?: Maybe<Array<Maybe<Image>>>;
  /** Url for a small verizon of the main image */
  smallImageUrl?: Maybe<Scalars['String']['output']>;
  /** Url for the thumb image of the main image */
  thumbUrl?: Maybe<Scalars['String']['output']>;
};

export type MerchantInitiatedTransactionSession = {
  /** id for the session */
  id?: Maybe<Scalars['ID']['output']>;
  /** 3DS eligibility check */
  threeDSMetadata?: Maybe<ThreeDsAction>;
};

export type Message = {
  /** Response status */
  response?: Maybe<Scalars['String']['output']>;
  /** Response status code */
  status?: Maybe<Scalars['String']['output']>;
};

/** Object describing request status and payload */
export type MessageItem = {
  /** Description of why the message was sent */
  reason?: Maybe<Scalars['String']['output']>;
};

/** The key value pair object representing an indiviual meta tag override */
export type MetaOverrideField = {
  /** The name of the meta field to override */
  name?: Maybe<Scalars['String']['output']>;
  /** The new value to apply to the meta field */
  value?: Maybe<Scalars['String']['output']>;
};

/** The container object representing desired meta tag changes for a given pathname */
export type MetaTagsOverride = {
  /** The key value pairs of the meta values */
  fields?: Maybe<Array<Maybe<MetaOverrideField>>>;
  /** The override's unique ID. */
  id?: Maybe<Scalars['String']['output']>;
  /** The pathname / slug for the meta data override */
  slug?: Maybe<Scalars['String']['output']>;
  /** The last modified timestamp for the override */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** Data needed to mint a new NFT. */
export type MintNftInput = {
  /** A description of the NFT, with support for markdown formatting. Sent to the blockchain. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** How many total editions or shares of the asset will there be? */
  editions?: InputMaybe<Scalars['Int']['input']>;
  /** GUID passed in by client, stored as a unique index in the event table to ensure idempotency. */
  eventNonce?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the media element attached to the NFT. */
  mediaURL?: InputMaybe<Scalars['String']['input']>;
  /** True if the edition count of the NFT is allowed to be updated after mint */
  openEditions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer UUID of the owner. This user will own all shares initially. */
  ownerUUID?: InputMaybe<Scalars['String']['input']>;
  /** The primary category of the NFT, which will dictate how the product is created in the product catalog. Possible options include: 'NFTs' and 'Vaulted'. */
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  /** User-friendly identifier for this NFT that will be used to create the entry in the product catalog. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Title of the NFT. Sent to the blockchain. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Content for the Modal promo flash */
export type ModalPromoFlashContent = PromoFlashContent & {
  /** Color of the Close Button */
  closeButtonColor?: Maybe<Scalars['String']['output']>;
  /** Color of the background */
  color?: Maybe<Scalars['String']['output']>;
  /** Type of the Promo Flash */
  contentType?: Maybe<PromoFlashType>;
  /** Modal Image for Desktop */
  desktopModalImage?: Maybe<ImageFile>;
  /** Flag whether to hide this promo flash */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** Modal Image for Mobile */
  mobileModalImage?: Maybe<ImageFile>;
  /** Unique title of the Promo Flash */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current Promo Flash */
  uid?: Maybe<Scalars['String']['output']>;
  /** Url the promo is targetting */
  url?: Maybe<Scalars['String']['output']>;
};

/** An aggregate of order information over a given month */
export type MonthlyAggregate = {
  /** Total amount of items that were shipped within the quick ship booster timeframe */
  fastShipCount?: Maybe<Scalars['Int']['output']>;
  /** The month this data is for */
  month?: Maybe<Scalars['String']['output']>;
  /** Total amount of sales that were successfully shipped to StockX */
  shipCount?: Maybe<Scalars['Int']['output']>;
  /** Calculated rate of shipped items to total transactions */
  shipRate?: Maybe<Scalars['String']['output']>;
  /** Total amount of sales in the month */
  transactionCount?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  /** Add manual label info to a shipment */
  addManualLabelInfo?: Maybe<AddManualLabelInfoResponse>;
  /** Approve a seller promotion */
  approveSellerPromotion?: Maybe<SellerPromotionApprovalResponse>;
  /** Approve a temporary seller fee */
  approveTemporarySellerFee?: Maybe<TemporarySellerFeeApprovalResponse>;
  /** Completes the Two Step Checkout Process For LPMs and APMs */
  completeTwoStepCheckout?: Maybe<Bid>;
  /** Completes the vaulting process */
  completeVaultingSession?: Maybe<UserPaymentAccount>;
  /** Creates an action based on treeId */
  createAction?: Maybe<LreAction>;
  /** Mutation for ask creating */
  createAsk?: Maybe<AskCreatePayload>;
  /** Mutation for bulk ask creating */
  createAsks?: Maybe<AsksCreatePayload>;
  /** Mutation for asynchronously bulk creating asks */
  createBatchAsks?: Maybe<CreateBatchAskPayload>;
  /** Mutation for asynchronously bulk create listings */
  createBatchListings?: Maybe<CreateListingBatchPayload>;
  /** The Buyer policy mutation to create a new policy for the buyer tier program. */
  createBuyerTierPolicy?: Maybe<BuyerTierPolicy>;
  /** A user's tier profile details for buyer role */
  createBuyerTierProfile?: Maybe<BuyerTierProfile>;
  /** Creates a check based on treeId */
  createCheck?: Maybe<LreCheck>;
  /** Creates a condition based on treeId */
  createCondition?: Maybe<LreCondition>;
  /** Create a digital product based off an existing physical product */
  createDigitalProduct?: Maybe<CreateDigitalProductOutput>;
  /** Creates a new regulatory id */
  createIdentificationNumber?: Maybe<RegulatoryId>;
  /** Creates a list that matches the given inputs */
  createList?: Maybe<CreateListResult>;
  /** Mutation for creating a listing */
  createListing?: Maybe<ListingAsyncPayload>;
  createMITAuthorization?: Maybe<MerchantInitiatedTransactionSession>;
  /** Creates and returns provider authorization token required for FE clients */
  createPaymentClientProviderToken?: Maybe<PaymentProviderToken>;
  /** Creates a rule based on treeId */
  createRule?: Maybe<LreRule>;
  /** Create a seller promotion */
  createSellerPromotion?: Maybe<SellerPromotion>;
  /** Creates a bulk shipment using an array of shipment items */
  createShipment?: Maybe<Shipment>;
  /** Based on the fileName passed in, generates a signed HTTP PUT url that can be used to directly upload an image to S3. Also generates a signed HTTP GET url that can be used for future retrieval. Typically, this signed HTTP GET url is passed into the 'mintNFT(input:)' mutation as 'mediaURL'. */
  createSignedImageURLs?: Maybe<SignedImageUrLs>;
  /** Create SMS Linking Code */
  createSmsLinkingCode?: Maybe<SmsLinkingCode>;
  /** Creating an SmsProfile for a customer */
  createSmsProfile?: Maybe<Message>;
  /** Authenticate 3DS against money session for charging a payment account */
  createThreeDSAuthentication?: Maybe<ThreeDsAuthentication>;
  /** Authorizes threeDs against money session for charging a payment account */
  createThreeDsSessionAuthorization?: Maybe<ThreeDsSessionAuthorization>;
  /** Creates a tree */
  createTree?: Maybe<LreTree>;
  /** Deactivate a mother shipment by motherShipmentId */
  deactivateMotherShipment?: Maybe<Shipment>;
  /** Deletes an action based on treeId and ruleId */
  deleteAction?: Maybe<LreAction>;
  /** Mutation for single ask deleting */
  deleteAsk?: Maybe<AskDeletePayload>;
  /** Mutation for bulk ask deleting */
  deleteAsks?: Maybe<AsksDeletePayload>;
  /** Mutation for asynchronously bulk delete listings */
  deleteBatchListings?: Maybe<DeleteListingBatchPayload>;
  /** Deletes a check based on treeId and ruleId */
  deleteCheck?: Maybe<LreCheck>;
  /** Delete a child shipment by shipment uuid */
  deleteChildShipment?: Maybe<ShipmentItem>;
  /** Deletes a condition based on treeId and ruleId */
  deleteCondition?: Maybe<LreCondition>;
  /** Deletes an existing regulatory id */
  deleteIdentificationNumber?: Maybe<RegulatoryId>;
  /** Delete a message or messages */
  deleteInboxMessage?: Maybe<DeleteInboxMessagePayload>;
  /** Mutation for canceling a listing */
  deleteListing?: Maybe<ListingAsyncPayload>;
  /** Deletes a rule based on treeId and ruleId */
  deleteRule?: Maybe<LreRule>;
  /** Delete a seller promotion */
  deleteSellerPromotion?: Maybe<SellerPromotionDeleteResponse>;
  /** Deletes a bulk shipment by shipmentID */
  deleteShipment?: Maybe<Shipment>;
  /** Deleting a SmsProfile */
  deleteSmsProfile?: Maybe<Message>;
  /** Deletes a tree based on treeId */
  deleteTree?: Maybe<LreTree>;
  /** Triggers deletion flow for StockX user account */
  deleteUser?: Maybe<DeletionId>;
  /** The Buyer profile mutation to disable the overridden tier of the profile for a buyer. */
  disableBuyerTierProfileOverrideTier?: Maybe<BuyerTierProfile>;
  dummyDynamicsMutation?: Maybe<Scalars['String']['output']>;
  /** Edit a discount code */
  editDiscountCode?: Maybe<DiscountCode>;
  /** The Buyer profile mutation to enable the overridden tier of the profile for a buyer. */
  enableBuyerTierProfileOverrideTier?: Maybe<BuyerTierProfile>;
  /** Mutation used to expire a discount code */
  expireDiscountCode?: Maybe<DiscountCodeExpirationResponse>;
  /** Finalize a mother shipment by motherShipmentId */
  finalizeMotherShipment?: Maybe<Shipment>;
  /** Follow products mutation */
  followProducts?: Maybe<Array<Maybe<FollowResponse>>>;
  /** updates MIT session with billing address */
  hydrateMITSessionWithBillingAddress?: Maybe<MerchantInitiatedTransactionSession>;
  /** Mark a message or messages as read */
  markInboxMessageRead?: Maybe<UpdateReadStatusPayload>;
  /** Mints a new NFT. */
  mintNFT?: Maybe<Nft>;
  /** Creates a vault redemption order. */
  redeemVaultNFT?: Maybe<Order>;
  /** Regenerates a shipment label using an array of shipment items and a label description */
  regenerateLabel?: Maybe<Shipment>;
  /** Removes a list that matches the given inputs */
  removeList?: Maybe<RemoveListResult>;
  /** Repair a shipment by chainIds */
  repairShipments?: Maybe<RepairShipmentResponse>;
  /** Mutation for requesting shipping extension */
  requestSellerShippingExtension?: Maybe<SellerShippingExtensionRequestResult>;
  /** Save a dynamic address */
  saveAddress?: Maybe<SaveAddressResult>;
  /** Logs frontend data related to buy now checkout attempt */
  sendPlaceOrderAnalytics?: Maybe<PlaceOrderAnalyticsOutput>;
  /** Start a MIT Sesssion */
  startMerchantInitiatedTransactionSession?: Maybe<MerchantInitiatedTransactionSession>;
  /** Starts the Two Step Checkout Process For LPMs and APMs */
  startTwoStepCheckout?: Maybe<StartedTwoStepCheckout>;
  /** Starts a new vaulting session */
  startVaultingSession?: Maybe<VaultingSession>;
  /** Subscribe a customer to a notification */
  subscribeToNotificationEmail?: Maybe<Message>;
  /** Check for 3DS eligibility */
  threeDSEligibility?: Maybe<ThreeDsEligibilityResult>;
  /** UnFinalize a mother shipment by motherShipmentId */
  unFinalizeMotherShipment?: Maybe<Shipment>;
  /** Unfollow products mutation */
  unfollowProducts?: Maybe<Array<Maybe<UnfollowResponse>>>;
  /** Unsubscribe a customer from all notifications */
  unsubscribeFromAllNotificationsEmails?: Maybe<Message>;
  /** Unsubscribe a customer to a notification */
  unsubscribeFromNotificationEmail?: Maybe<Message>;
  /** Updates an action based on treeId and ruleId */
  updateAction?: Maybe<LreAction>;
  /** Mutation for single ask updating */
  updateAsk?: Maybe<AskUpdatePayload>;
  /** Mutation for bulk ask updating */
  updateAsks?: Maybe<AsksUpdatePayload>;
  /** Mutation for asynchronously bulk update listings */
  updateBatchListings?: Maybe<UpdateListingBatchPayload>;
  /** The Buyer policy mutation to update a new policy for the buyer tier program. */
  updateBuyerTierPolicy?: Maybe<BuyerTierPolicy>;
  /** Updates a check based on treeId and ruleId */
  updateCheck?: Maybe<LreCheck>;
  /** Updates a condition based on treeId and ruleId */
  updateCondition?: Maybe<LreCondition>;
  /** Updates an EU VAT ID */
  updateEUVATID?: Maybe<Euvat>;
  /** Updates an existing regulatory id of the same type */
  updateIdentificationNumber?: Maybe<RegulatoryId>;
  /** Updates a list to match the given input. */
  updateList?: Maybe<UpdateListResult>;
  /** Update list items from a specific list */
  updateListItems?: Maybe<UpdateListItemsResult>;
  /** Mutation for updating a listing */
  updateListing?: Maybe<ListingAsyncPayload>;
  /** Update a subscription state */
  updateNotificationSubscription?: Maybe<Message>;
  /** Updates a rule based on treeId and ruleId */
  updateRule?: Maybe<LreRule>;
  /** Edits an existing bulk shipment */
  updateShipment?: Maybe<Shipment>;
  /** Mutation for changing ask state to or from Label Viewed */
  updateShipmentLabelViewedStateForAsks?: Maybe<UpdateShipmentLabelPayload>;
  /** Updates to the SmsProfile from a customer */
  updateSmsProfile?: Maybe<Message>;
  /** Updates a tree based on treeId */
  updateTree?: Maybe<LreTree>;
  /** mutation that updates the user prize to either failed or success */
  userPrizeValidation?: Maybe<UserPrize>;
  /** validate billing address */
  validateBillingAddress?: Maybe<PaymentsInputValidationResponse>;
};

export type MutationAddManualLabelInfoArgs = {
  input?: InputMaybe<AddManualLabelInfoInput>;
};

export type MutationApproveSellerPromotionArgs = {
  sellerPromotionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationApproveTemporarySellerFeeArgs = {
  sellerFeeId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCompleteTwoStepCheckoutArgs = {
  input: CompleteTwoStepCheckoutInput;
};

export type MutationCompleteVaultingSessionArgs = {
  input?: InputMaybe<CompleteVaultingSessionInput>;
};

export type MutationCreateActionArgs = {
  input?: InputMaybe<LreActionInput>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateAskArgs = {
  input?: InputMaybe<AskCreateInput>;
};

export type MutationCreateAsksArgs = {
  input?: InputMaybe<AsksCreateInput>;
};

export type MutationCreateBatchAsksArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateBatchAskInput>>>;
};

export type MutationCreateBatchListingsArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateListingBatchInput>>>;
};

export type MutationCreateBuyerTierPolicyArgs = {
  proposedBuyFee?: InputMaybe<ProposedBuyerFeeInput>;
  proposedPolicy?: InputMaybe<ProposedBuyerTierInput>;
  proposedShippingFee?: InputMaybe<
    Array<InputMaybe<ProposedBuyerShippingDiscountInput>>
  >;
};

export type MutationCreateBuyerTierProfileArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCheckArgs = {
  conditionId?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<LreCheckInput>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateConditionArgs = {
  input?: InputMaybe<LreConditionInput>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateDigitalProductArgs = {
  input?: InputMaybe<CreateDigitalProductInput>;
};

export type MutationCreateIdentificationNumberArgs = {
  idInput?: InputMaybe<IdParameterInput>;
};

export type MutationCreateListArgs = {
  input?: InputMaybe<CreateListInput>;
};

export type MutationCreateListingArgs = {
  input?: InputMaybe<ListingCreateInput>;
};

export type MutationCreateMitAuthorizationArgs = {
  input?: InputMaybe<CreateMitAuthorizationInput>;
};

export type MutationCreatePaymentClientProviderTokenArgs = {
  input?: InputMaybe<PaymentProviderTokenInput>;
};

export type MutationCreateRuleArgs = {
  input?: InputMaybe<LreRuleInput>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateSellerPromotionArgs = {
  sellerPromotion?: InputMaybe<SellerPromotionCreatePayloadInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateShipmentArgs = {
  items: Array<ShipmentItemInput>;
};

export type MutationCreateSignedImageUrLsArgs = {
  input?: InputMaybe<CreateSignedImageUrLsInput>;
};

export type MutationCreateSmsProfileArgs = {
  smsProfile?: InputMaybe<SmsProfileInput>;
};

export type MutationCreateThreeDsAuthenticationArgs = {
  input?: InputMaybe<CreateThreeDsAuthenticationInput>;
};

export type MutationCreateThreeDsSessionAuthorizationArgs = {
  input?: InputMaybe<CreateThreeDsSessionAuthorizationInput>;
};

export type MutationCreateTreeArgs = {
  input?: InputMaybe<LreTreeInput>;
};

export type MutationDeactivateMotherShipmentArgs = {
  motherShipmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationDeleteActionArgs = {
  actionId?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationDeleteAskArgs = {
  input?: InputMaybe<AskDeleteInput>;
};

export type MutationDeleteAsksArgs = {
  input?: InputMaybe<AsksDeleteInput>;
};

export type MutationDeleteBatchListingsArgs = {
  input?: InputMaybe<Array<InputMaybe<DeleteListingBatchInput>>>;
};

export type MutationDeleteCheckArgs = {
  checkId?: InputMaybe<Scalars['Int']['input']>;
  conditionId?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationDeleteChildShipmentArgs = {
  shipmentUuid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteConditionArgs = {
  conditionId?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationDeleteIdentificationNumberArgs = {
  regIdUuid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteInboxMessageArgs = {
  input?: InputMaybe<DeleteInboxMessageInput>;
};

export type MutationDeleteListingArgs = {
  input?: InputMaybe<ListingDeleteInput>;
};

export type MutationDeleteRuleArgs = {
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationDeleteSellerPromotionArgs = {
  sellerPromotionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteShipmentArgs = {
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteSmsProfileArgs = {
  smsProfile?: InputMaybe<SmsProfileInput>;
};

export type MutationDeleteTreeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationDeleteUserArgs = {
  deleteInput?: InputMaybe<UserDeleteInput>;
};

export type MutationDisableBuyerTierProfileOverrideTierArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationEditDiscountCodeArgs = {
  discountCode?: InputMaybe<DiscountCodeEditPayloadInput>;
};

export type MutationEnableBuyerTierProfileOverrideTierArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  overrideArgs?: InputMaybe<OverrideTierInput>;
};

export type MutationExpireDiscountCodeArgs = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationFinalizeMotherShipmentArgs = {
  motherShipmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationFollowProductsArgs = {
  input?: InputMaybe<FollowProductsInput>;
};

export type MutationHydrateMitSessionWithBillingAddressArgs = {
  input?: InputMaybe<AddressInput>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMarkInboxMessageReadArgs = {
  input?: InputMaybe<MarkReadInput>;
};

export type MutationMintNftArgs = {
  input?: InputMaybe<MintNftInput>;
};

export type MutationRedeemVaultNftArgs = {
  input?: InputMaybe<RedeemVaultNftInput>;
};

export type MutationRegenerateLabelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  items: Array<ShipmentItemInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRemoveListArgs = {
  input?: InputMaybe<RemoveListInput>;
};

export type MutationRepairShipmentsArgs = {
  chainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationRequestSellerShippingExtensionArgs = {
  input?: InputMaybe<SellerShippingExtensionRequestInput>;
};

export type MutationSaveAddressArgs = {
  input?: InputMaybe<SaveAddressInput>;
};

export type MutationSendPlaceOrderAnalyticsArgs = {
  placeOrderAnalyticsInput?: InputMaybe<PlaceOrderAnalyticsInput>;
};

export type MutationStartMerchantInitiatedTransactionSessionArgs = {
  input?: InputMaybe<StartMerchantInitiatedTransactionSessionInput>;
};

export type MutationStartTwoStepCheckoutArgs = {
  input: StartTwoStepCheckoutInput;
};

export type MutationStartVaultingSessionArgs = {
  input?: InputMaybe<StartVaultingSessionInput>;
};

export type MutationSubscribeToNotificationEmailArgs = {
  subscribe?: InputMaybe<SubscriptionNotificationPayloadInput>;
};

export type MutationThreeDsEligibilityArgs = {
  input?: InputMaybe<ThreeDsEligibilityInput>;
};

export type MutationUnFinalizeMotherShipmentArgs = {
  motherShipmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUnfollowProductsArgs = {
  input?: InputMaybe<UnfollowProductsInput>;
};

export type MutationUnsubscribeFromAllNotificationsEmailsArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUnsubscribeFromNotificationEmailArgs = {
  unsubscribe?: InputMaybe<SubscriptionNotificationPayloadInput>;
};

export type MutationUpdateActionArgs = {
  actionId?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<LreActionInput>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateAskArgs = {
  input?: InputMaybe<AskUpdateInput>;
};

export type MutationUpdateAsksArgs = {
  input?: InputMaybe<AsksUpdateInput>;
};

export type MutationUpdateBatchListingsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateListingBatchInput>>>;
};

export type MutationUpdateBuyerTierPolicyArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  proposedBuyFee?: InputMaybe<ProposedBuyerFeeInput>;
  proposedPolicy?: InputMaybe<ProposedBuyerTierInput>;
  proposedShippingFee?: InputMaybe<
    Array<InputMaybe<ProposedBuyerShippingDiscountInput>>
  >;
};

export type MutationUpdateCheckArgs = {
  checkId?: InputMaybe<Scalars['Int']['input']>;
  conditionId?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<LreCheckInput>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateConditionArgs = {
  conditionId?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<LreConditionInput>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateEuvatidArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateIdentificationNumberArgs = {
  idInput?: InputMaybe<IdParameterInput>;
  regIdUuid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateListArgs = {
  input?: InputMaybe<UpdateListInput>;
};

export type MutationUpdateListItemsArgs = {
  input?: InputMaybe<UpdateListItemsInput>;
};

export type MutationUpdateListingArgs = {
  input?: InputMaybe<ListingUpdateInput>;
};

export type MutationUpdateNotificationSubscriptionArgs = {
  subscription?: InputMaybe<EditSubscriptionNotificationPayloadInput>;
};

export type MutationUpdateRuleArgs = {
  input?: InputMaybe<LreRuleInput>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateShipmentArgs = {
  items: Array<ShipmentItemInput>;
  shipmentId: Scalars['String']['input'];
};

export type MutationUpdateShipmentLabelViewedStateForAsksArgs = {
  input?: InputMaybe<UpdateShipmentLabelViewedInput>;
};

export type MutationUpdateSmsProfileArgs = {
  smsProfile?: InputMaybe<SmsProfileInput>;
};

export type MutationUpdateTreeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<LreTreeInput>;
};

export type MutationUserPrizeValidationArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserPrizeStateInput>;
};

export type MutationValidateBillingAddressArgs = {
  input?: InputMaybe<ValidateBillingAddressInput>;
};

/** Represents a minted NFT that exists on StockX. */
export type Nft = {
  /** Data related to the blockchain. */
  blockchain?: Maybe<NftBlockchain>;
  /** Unique identifier for the NFT. */
  id?: Maybe<Scalars['String']['output']>;
  /** True if the edition count of the NFT is allowed to be updated after mint */
  openEditions?: Maybe<Scalars['Boolean']['output']>;
  /** Data managed by StockX's ownership service. */
  ownership?: Maybe<NftOwnership>;
  /** Convenience method to return the slug, even if the variant has not been created in Warehaus yet. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The variant attached to the NFT that may be displayed to customers on stockx.com. May be null if the NFT was recently minted until it is created in Warehaus (this is an asynchronous operation). */
  variant?: Maybe<Variant>;
};

/** Represents fields in the blockchain specific to an NFT. */
export type NftBlockchain = {
  /** The number of editions burned. */
  burnedEditions?: Maybe<Scalars['Int']['output']>;
  /** Represents the contract the NFT is part of on the blockchain. */
  contractId?: Maybe<Scalars['String']['output']>;
  /** The number of editions that currently exist. */
  currentEditions?: Maybe<Scalars['Int']['output']>;
  /** The immutable description stored on the blockchain. */
  description?: Maybe<Scalars['String']['output']>;
  /** The immutable media url stored on the blockchain. */
  mediaURL?: Maybe<Scalars['String']['output']>;
  /** Represents whether or not the NFT has been minted to the blockchain */
  minted?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the blockchain on which the NFT was minted. */
  name?: Maybe<Scalars['String']['output']>;
  /** The blockchain network that the NFT was minted on. */
  network?: Maybe<Scalars['String']['output']>;
  /** The number of editions that were originally minted. */
  originallyMintedEditions?: Maybe<Scalars['Int']['output']>;
  /** The immutable title stored on the blockchain. */
  title?: Maybe<Scalars['String']['output']>;
  /** Represents the specific ID of the NFT on the blockchain. */
  tokenId?: Maybe<Scalars['String']['output']>;
};

/** NFTs that have been previously minted. */
export type NftConnection = {
  /** Edges to a list of NFTs that were previously minted. */
  edges?: Maybe<Array<Maybe<NftEdge>>>;
  /** Information about the current page of NFTs. */
  pageInfo?: Maybe<NfTsPageInfo>;
};

/** Edge wrapper around NFT. */
export type NftEdge = {
  /** The NFT. */
  node?: Maybe<Nft>;
};

/** Represents a user who owns an NFT. */
export type NftOwner = {
  /** The current email address for the owner. */
  email?: Maybe<Scalars['String']['output']>;
  /** The current full name of the owner. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The UUID of the owner. */
  uuid?: Maybe<Scalars['ID']['output']>;
};

/** Represents data managed by StockX's ownership service. */
export type NftOwnership = {
  /** The original owner of the NFT before the primary sale concludes. */
  originalOwner?: Maybe<NftOwner>;
  /** The number of asks created so far for the primary sale. Includes both sold and not yet sold asks. */
  primaryAsksCreated?: Maybe<Scalars['Int']['output']>;
  /** The number of editions that remain available for purchase in the primary sale. */
  primaryEditionsRemaining?: Maybe<Scalars['Int']['output']>;
  /** The number of editions sold as part of the primary sale. */
  primaryEditionsSold?: Maybe<Scalars['Int']['output']>;
  /** The number of editions sold in all of time, including primary and secondary sales. */
  totalEditionsSold?: Maybe<Scalars['Int']['output']>;
};

/** A custom pagination type for the nfts query that relies on page and limit inputs. */
export type NfTsPageInfo = {
  /** The number of results per page. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The current page, numbering starts at 0. */
  page?: Maybe<Scalars['Int']['output']>;
  /** The total number of results in the database. */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Blog Posts */
export type News = {
  /** Blog post author */
  author?: Maybe<Scalars['String']['output']>;
  /** Image that represents the blog post */
  featuredImage?: Maybe<Scalars['String']['output']>;
  /** link to the post */
  link?: Maybe<Scalars['String']['output']>;
  /** Date the post was published */
  publishDate?: Maybe<Scalars['ISODate']['output']>;
  /** Title of the blog post */
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationSubscription = {
  /** Short definition of the notification */
  description?: Maybe<Scalars['String']['output']>;
  /** Instruct the front end to display the threshold dropdown to the customer */
  displayThreshold?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the notification as a buying or selling side */
  group?: Maybe<Scalars['String']['output']>;
  /** Key of the notification - Backend usage */
  key?: Maybe<Scalars['String']['output']>;
  /** Name of the notification - Frontend usage */
  name?: Maybe<Scalars['String']['output']>;
  /** SMS Profile associated to a customer */
  smsProfile?: Maybe<SmsProfile>;
  /** Point at which a customer wishes to receive a notification based on percentage difference in price */
  threshold?: Maybe<Scalars['Float']['output']>;
  /** Array of notification mediums and their current state */
  transports?: Maybe<Array<Maybe<NotificationSubscriptionTransport>>>;
};

export type NotificationSubscriptionTransport = {
  /** Current state of the subscription, True/False if it is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Medium (lowercase) - backend usage */
  key?: Maybe<Scalars['String']['output']>;
  /** Medium - Frontend usage */
  name?: Maybe<Scalars['String']['output']>;
};

/** A feature flag with a numeric value */
export type NumberFeatureFlag = FeatureFlag & {
  /** A key that identifies this feature flag */
  key?: Maybe<Scalars['String']['output']>;
  /** The numeric value of this feature flag */
  numberValue?: Maybe<Scalars['Float']['output']>;
};

/** Number "in" filter */
export type NumberInListFilterInput = {
  /** List of numbers to filter on */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type NumericIntFilter = {
  /** Equal */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Lower than */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Lower than or equal */
  lte?: InputMaybe<Scalars['Int']['input']>;
};

/** Onboarding complete page */
export type OnboardingComplete = {
  /** Animation URL */
  animationUrl?: Maybe<Scalars['String']['output']>;
  /** Description of complete page */
  description?: Maybe<Scalars['String']['output']>;
  /** Prize Disclaimer */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Header Image URL */
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  /** Discount code prize */
  prize?: Maybe<Scalars['String']['output']>;
  /** Title of complete page */
  title?: Maybe<Scalars['String']['output']>;
};

/** Onboarding flow for Users */
export type OnboardingFlow = {
  /** Complete Page */
  complete?: Maybe<OnboardingComplete>;
  /** ContentStack Entry ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Array of Quizzes */
  quizzes?: Maybe<Array<Maybe<OnboardingQuiz>>>;
  /** Array of story pages */
  stories?: Maybe<Array<Maybe<OnboardingStory>>>;
};

/** Onboarding Quiz */
export type OnboardingQuiz = {
  /** Array of quiz question answer options */
  answers?: Maybe<Array<Maybe<OnboardingQuizAnswer>>>;
  /** Quiz error */
  error?: Maybe<OnboardingQuizError>;
  /** Quiz question */
  question?: Maybe<Scalars['String']['output']>;
  /** Title of quiz page */
  title?: Maybe<Scalars['String']['output']>;
};

/** Quiz Question Answer Option */
export type OnboardingQuizAnswer = {
  /** Whether or not the answer option is correct */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** Text of the answer option */
  text?: Maybe<Scalars['String']['output']>;
};

/** Quiz Error */
export type OnboardingQuizError = {
  /** Desription of error */
  description?: Maybe<Scalars['String']['output']>;
  /** Title of error */
  title?: Maybe<Scalars['String']['output']>;
};

/** Onboarding story page */
export type OnboardingStory = {
  /** Animation URL */
  animationUrl?: Maybe<Scalars['String']['output']>;
  /** Description of story page */
  description?: Maybe<Scalars['String']['output']>;
  /** Header Image URL */
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  /** Title of story page */
  title?: Maybe<Scalars['String']['output']>;
};

/** The connection between a bid and ask */
export type Order = {
  /** If applicable, the chainId of a bid or ask */
  chainId?: Maybe<Scalars['String']['output']>;
  /** The checkout type of a custodial order */
  checkoutType?: Maybe<OrderCheckoutType>;
  /** The datetime stamp for when the order was created */
  created?: Maybe<Scalars['ISODate']['output']>;
  /** The currency of the order */
  currency?: Maybe<OrderCurrency>;
  /** Information about order fraud review */
  fraud?: Maybe<OrderFraud>;
  /** The history of events on the order */
  history?: Maybe<Array<Maybe<OrderEvent>>>;
  /** The ID of an order */
  id?: Maybe<Scalars['String']['output']>;
  /** The item information associated with the order */
  item?: Maybe<OrderItemInformation>;
  /** The reference to the buy or sell order that is currently matched with this order */
  matchedWith?: Maybe<Order>;
  /** The payment information captured at the time of the order */
  payment?: Maybe<OrderPaymentSnapshot>;
  /** The payment method captured at the time of the order */
  paymentMethod?: Maybe<OrderPaymentMethodSnapshot>;
  /** The payout information */
  payout?: Maybe<OrderPaymentSnapshot>;
  /** Information about the initial pricing, estimated pricing and final pricing (both localized and in USD) */
  pricing?: Maybe<OrderPricing>;
  /** The product information associated with the order */
  product?: Maybe<OrderProductInformation>;
  /** Order return details */
  return?: Maybe<OrderReturn>;
  /** The shipping information associated with the order */
  shipping?: Maybe<OrderShipping>;
  /** Where the item is being sourced from */
  source?: Maybe<OrderSource>;
  /** The sourcing method for the item */
  sourceType?: Maybe<OrderSourceType>;
  /**
   * The list of completed and upcoming states for an order
   * @deprecated This field will only be available on BuyOrder in the future.
   */
  states?: Maybe<Array<Maybe<OrderStateItem>>>;
  /** The status of the order */
  status?: Maybe<Scalars['String']['output']>;
  /** The status code of the order */
  statusCode?: Maybe<Scalars['String']['output']>;
  /** Tax and duty processing */
  taxman?: Maybe<TaxmanResult>;
  /** The type of order */
  type?: Maybe<OrderType>;
  /** The datetime stamp for when the order was updated */
  updated?: Maybe<Scalars['ISODate']['output']>;
  /** The user information captured at the time of the order */
  user?: Maybe<UserSnapshot>;
};

/** The address snapshot for the order */
export type OrderAddressSnapshot = {
  /** Main line of address */
  address1?: Maybe<Scalars['String']['output']>;
  /** Apt, Unit, Etc */
  address2?: Maybe<Scalars['String']['output']>;
  /** City of address */
  city?: Maybe<Scalars['String']['output']>;
  /** Country Code of address */
  country?: Maybe<Scalars['String']['output']>;
  /** The customer's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The customer's last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The customer's phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Region/State/Province of address */
  region?: Maybe<Scalars['String']['output']>;
  /** Zip/Postal of address */
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** The applicable order checkout types */
export enum OrderCheckoutType {
  /** Express Buy */
  EXPRESS = 'EXPRESS',
  /** Standard Fulfillment */
  STANDARD = 'STANDARD',
}

/** The currency of the order */
export type OrderCurrency = {
  /** The currencyCode of the order */
  code?: Maybe<Scalars['String']['output']>;
  /** The exchange rate to USD */
  exchangeRateDecimal?: Maybe<Scalars['String']['output']>;
};

/** The estimated pricing used for fraud check */
export type OrderEstimatedPricing = {
  /** The estimated pricing in USD */
  internal?: Maybe<PricingSnapshot>;
};

/** The events of an order */
export type OrderEvent = {
  /** The type of event that occurred for an order */
  action?: Maybe<Scalars['String']['output']>;
  /** The uuid of the user that performed the action */
  actionBy?: Maybe<Scalars['String']['output']>;
  /** The reason behind the action like a causing event or explanation for returning an order */
  actionReason?: Maybe<Scalars['String']['output']>;
  /** The datetime stamp for when the order was created */
  created?: Maybe<Scalars['ISODate']['output']>;
  /** The currency of the event */
  currency?: Maybe<OrderCurrency>;
  /** The ID of an order */
  id?: Maybe<Scalars['String']['output']>;
  /** The item information associated with the order */
  item?: Maybe<OrderItemInformation>;
  /** If applicable, notes associated with the action */
  note?: Maybe<Scalars['String']['output']>;
  /** The payment information captured at the time of the event */
  payment?: Maybe<OrderPaymentSnapshot>;
  /** The payment method captured at the time of the event */
  paymentMethod?: Maybe<OrderPaymentMethodSnapshot>;
  /** The payout information */
  payout?: Maybe<OrderPaymentSnapshot>;
  /** Information about the initial pricing, estimated pricing and final pricing (both localized and in USD) */
  pricing?: Maybe<OrderPricing>;
  /** The product information associated with the order */
  product?: Maybe<OrderProductInformation>;
  /** The shipping information associated with the order */
  shipping?: Maybe<OrderShipping>;
  /** Where the item is being sourced from */
  source?: Maybe<OrderSource>;
  /** The sourcing method for the item */
  sourceType?: Maybe<OrderSourceType>;
  /** The status of the order at the time of the event */
  status?: Maybe<Scalars['String']['output']>;
  /** The status code of the order at the time of the event */
  statusCode?: Maybe<Scalars['String']['output']>;
  /** The type of order */
  type?: Maybe<OrderType>;
  /** The datetime stamp for when the order was updated */
  updated?: Maybe<Scalars['ISODate']['output']>;
  /** The user information captured at the time of the event */
  user?: Maybe<UserSnapshot>;
};

/** Finalized pricing results from the Pricing service */
export type OrderFinalizedPricing = {
  /** The finalized pricing in USD */
  internal?: Maybe<PricingSnapshot>;
  /** The finalized pricing localized for the customer */
  local?: Maybe<OrderLocalizablePricingSnapshot>;
};

/** Information about order fraud review */
export type OrderFraud = {
  /** The ID of an order */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Details of the order review */
  review?: Maybe<Array<Maybe<OrderFraudReview>>>;
};

/** Details of the order review */
export type OrderFraudReview = {
  /** Order decision fraud review id */
  decisionId?: Maybe<Scalars['String']['output']>;
  /** Fraud review status (approved, declined, not_reviewed, captured) */
  decisionStatus?: Maybe<Scalars['String']['output']>;
  /** Fraud partner type (Riskified, Sift, Forter) */
  partner?: Maybe<Scalars['String']['output']>;
};

/** The initial pricing details at order creation */
export type OrderInitialPricing = {
  /** The total amount displayed to the customer at the time of checkout */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The customer's currency */
  currencyCode?: Maybe<Scalars['String']['output']>;
  /** The discount codes that the customer submitted at checkout */
  discountCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The currency exchange rate at the time of checkout */
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  /** The total amount displayed in the customer's currency at the time of checkout */
  localAmount?: Maybe<Scalars['Float']['output']>;
  /** The tax amount that was displayed to the customer at checkout */
  previousEstimatedTax?: Maybe<Scalars['Float']['output']>;
};

/** The item information associated with the order */
export type OrderItemInformation = {
  /** If applicable, the digital edition id of the NFT in the order (DOS.digitalEditionId) */
  digitalEditionId?: Maybe<Scalars['String']['output']>;
  /** If applicable, the digital edition id of the NFT in the order (DOS.itemId, WH.barcodeUUID) */
  id?: Maybe<Scalars['String']['output']>;
  /** The product variant in the order (physical skuUUID: warehaus.reciprocalSkuUuid) */
  variant?: Maybe<Variant>;
};

/** Order data that is related to the shipment */
export type OrderLabel = {
  /** Shipment address city */
  city?: Maybe<Scalars['String']['output']>;
  /** Order id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Shipment address postcode */
  postcode?: Maybe<Scalars['String']['output']>;
  /** Shipment address region */
  region?: Maybe<Scalars['String']['output']>;
  /** Order state */
  state?: Maybe<OrderState>;
  /** Order status */
  status?: Maybe<OrderStatus>;
  /** Shipment address street */
  street?: Maybe<Scalars['String']['output']>;
  /** Date of orders last update */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** The local pricing snapshot of an order */
export type OrderLocalizablePricingSnapshot = {
  /** The pricing adjustments applied to the order */
  adjustments?: Maybe<Array<Maybe<OrderLocalizablePricingSnapshotAdjustment>>>;
  /** Flag for if the snapshot was estimated */
  estimated?: Maybe<Scalars['Boolean']['output']>;
  /** The subtotal of the order */
  subtotal?: Maybe<Scalars['String']['output']>;
  /** The grand total of the order */
  total?: Maybe<Scalars['String']['output']>;
};

/** The local adjustments that were made to the pricing of the item */
export type OrderLocalizablePricingSnapshotAdjustment = {
  /** The change amount */
  amount?: Maybe<Scalars['String']['output']>;
  /** The adjustment code used */
  code?: Maybe<Scalars['String']['output']>;
  /** If the adjustment does not affect the total */
  excludedFromTotal?: Maybe<Scalars['Boolean']['output']>;
  /** If the adjustment was a flat rate or not */
  flat?: Maybe<Scalars['Boolean']['output']>;
  /** The adjustment group */
  group?: Maybe<Scalars['String']['output']>;
  /** The adjustment group code */
  groupInternal?: Maybe<Scalars['String']['output']>;
  /** If the adjustment should be visible or not to the ui */
  invisible?: Maybe<Scalars['Boolean']['output']>;
  /** The adjustment was associated with the item */
  item?: Maybe<Scalars['Boolean']['output']>;
  /** The max amount of the adjustment */
  maxAmount?: Maybe<Scalars['Float']['output']>;
  /** The min amount of the adjustment */
  minAmount?: Maybe<Scalars['Float']['output']>;
  /** The min amount name of the adjustment */
  minName?: Maybe<Scalars['String']['output']>;
  /** The adjustment name */
  name?: Maybe<Scalars['String']['output']>;
  /** The adjustment change percentage */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** The translation key used for the pricing */
  translationKey?: Maybe<Scalars['String']['output']>;
};

/** The payment method captured at the time of the order */
export type OrderPaymentMethodSnapshot = {
  /** The gateway we used to collect the payment */
  gateway?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the payment method snapshot */
  id?: Maybe<Scalars['String']['output']>;
  /** The type of payment used */
  type?: Maybe<Scalars['String']['output']>;
};

/** The payment information captured at the time of the order */
export type OrderPaymentSnapshot = {
  /** The unique identifier for the payment transaction */
  id?: Maybe<Scalars['String']['output']>;
  /** The transaction id */
  token?: Maybe<Scalars['String']['output']>;
};

/** Information about the initial pricing, estimated pricing and final pricing (both localized and in USD) */
export type OrderPricing = {
  /** The estimated pricing used for fraud check */
  estimated?: Maybe<OrderEstimatedPricing>;
  /** Finalized pricing results from the Pricing service */
  finalized?: Maybe<OrderFinalizedPricing>;
  /** The initial pricing details at order creation */
  initial?: Maybe<OrderInitialPricing>;
};

/** The adjustments that were made to the pricing of the item */
export type OrderPricingAdjustment = {
  /** The change amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The adjustment code used */
  code?: Maybe<Scalars['String']['output']>;
  /** If the adjustment does not affect the total */
  excludedFromTotal?: Maybe<Scalars['Boolean']['output']>;
  /** If the adjustment was a flat rate or not */
  flat?: Maybe<Scalars['Boolean']['output']>;
  /** The adjustment group */
  group?: Maybe<Scalars['String']['output']>;
  /** The adjustment group code */
  groupInternal?: Maybe<Scalars['String']['output']>;
  /** If the adjustment should be visible or not to the ui */
  invisible?: Maybe<Scalars['Boolean']['output']>;
  /** The adjustment was associated with the item */
  item?: Maybe<Scalars['Boolean']['output']>;
  /** The max amount of the adjustment */
  maxAmount?: Maybe<Scalars['Float']['output']>;
  /** The min amount of the adjustment */
  minAmount?: Maybe<Scalars['Float']['output']>;
  /** The min amount name of the adjustment */
  minName?: Maybe<Scalars['String']['output']>;
  /** The adjustment name */
  name?: Maybe<Scalars['String']['output']>;
  /** The adjustment change percentage */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** The translation key used for the pricing */
  translationKey?: Maybe<Scalars['String']['output']>;
};

/** The pricing adjustment flags */
export type OrderPricingFlags = {
  /** All-in pricing flag */
  allIn?: Maybe<Scalars['Boolean']['output']>;
  /** The Delivered Duty Paid Flag */
  ddpEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The tax model used */
  taxModel?: Maybe<Scalars['String']['output']>;
};

/** The product information associated with the order */
export type OrderProductInformation = {
  /** The product variant in the order (digital skuUUID: DOS.skuUUID) */
  variant?: Maybe<Variant>;
};

/** Order payment refund */
export type OrderRefund = {
  /** Actual amount transacted */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Creation time of transaction */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** The refund currency */
  currency?: Maybe<CurrencyCode>;
  /** Error message with the reason of transaction failure */
  error?: Maybe<Scalars['String']['output']>;
  /** Refund transaction identifier */
  id?: Maybe<Scalars['String']['output']>;
  /** Notes associated with the refund */
  note?: Maybe<Scalars['String']['output']>;
  /** Reason of refund */
  reason?: Maybe<Scalars['String']['output']>;
  /** Status of the refund transaction */
  status?: Maybe<Scalars['String']['output']>;
  /** Type of refund, like full or partial refund */
  type?: Maybe<Scalars['String']['output']>;
  /** Update time of transaction */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** Order return details */
export type OrderReturn = {
  /** Return item authentication results */
  authentication?: Maybe<OrderReturnAuthentication>;
  /** Additional return reason when authentication reason is not available */
  reason?: Maybe<Scalars['String']['output']>;
  /** Order return status, like approved or rejected */
  status?: Maybe<Scalars['String']['output']>;
};

/** Return item authentication results */
export type OrderReturnAuthentication = {
  /** The reason for the authentication result */
  reason?: Maybe<Scalars['String']['output']>;
  /** Return approval result from authentication center */
  result?: Maybe<Scalars['String']['output']>;
};

/** The shipping information associated with the order */
export type OrderShipping = {
  /** The return shipment information */
  returnShipment?: Maybe<Shipment>;
  /** The shipment information */
  shipment?: Maybe<Shipment>;
};

/** The source of the item */
export type OrderSource = {
  /** If applicable, the ask associated with the order */
  ask?: Maybe<Ask>;
  /** If applicable, the bid associated with the order */
  bid?: Maybe<Bid>;
};

/** The applicable order source types */
export enum OrderSourceType {
  CUSTODIAL_INTAKE = 'CUSTODIAL_INTAKE',
  CUSTODIAL_OUTBOUND = 'CUSTODIAL_OUTBOUND',
  REDEMPTION = 'REDEMPTION',
}

/** An indicator of what is the state of the order */
export enum OrderState {
  /** Order is canceled */
  CANCELED = 'CANCELED',
  /** Order is closed */
  CLOSED = 'CLOSED',
  /** Order is completed by administrator */
  COMPLETE = 'COMPLETE',
  /** Order is holded */
  HOLDED = 'HOLDED',
  /** Order is just created */
  NEW = 'NEW',
  /** Order is suspended for payment review */
  PAYMENT_REVIEW = 'PAYMENT_REVIEW',
  /** Order payment confirmation is pending */
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  /** Order is being processed */
  PROCESSING = 'PROCESSING',
}

/** An order state item */
export type OrderStateItem = {
  /** The progress of the state item */
  progress?: Maybe<OrderStateItemProgress>;
  /** The status of the state item */
  status?: Maybe<OrderStateItemStatus>;
  /** The subtitle of the state */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The title of the state */
  title?: Maybe<Scalars['String']['output']>;
};

/** The order state progress */
export enum OrderStateItemProgress {
  /** Order state has been completed */
  COMPLETED = 'COMPLETED',
  /** Order state is upcoming */
  UPCOMING = 'UPCOMING',
}

/** Possible states an order can be in */
export enum OrderStateItemStatus {
  /** Order state is considered an error when completed */
  ERROR = 'ERROR',
  /** Order state is considered a success when completed */
  SUCCESS = 'SUCCESS',
  /** Order state is considered a warning when completed */
  WARNING = 'WARNING',
}

/** An indicator of what is the status of the order */
export enum OrderStatus {
  /** Order is canceled */
  CANCELED = 'CANCELED',
  /** Order is complete */
  COMPLETE = 'COMPLETE',
  /** Order is marked as fraud */
  FRAUD = 'FRAUD',
  /** Order is being processed */
  PROCESSING = 'PROCESSING',
  /** Order is rejected */
  REJECTED = 'REJECTED',
  /** Order is being payed */
  SUBMITTED_PAYOUT = 'SUBMITTED_PAYOUT',
  /** Order is marked troubled */
  TROUBLE = 'TROUBLE',
}

/** The applicable order types */
export enum OrderType {
  BUY = 'BUY',
  SELL = 'SELL',
}

/** Input structure for overriding a buyer profile with a new tier */
export type OverrideTierInput = {
  /** The Buyer tier to be set for overriding */
  tierId?: InputMaybe<Scalars['String']['input']>;
  /** The validity of the overridden Buyer tier */
  validity?: InputMaybe<Scalars['ISODate']['input']>;
};

export type OwnershipData = {
  /** Number owned items of the specified product by the user */
  ownedQuantity?: Maybe<Scalars['Int']['output']>;
};

export type OwnershipPortfolioItemEdge = {
  /** Node containing all data relevant to an owned NFT */
  node?: Maybe<OwnershipPortfolioItemNode>;
};

export type OwnershipPortfolioItemNode = {
  /** Datetime of the last transfer (effectively the date aquired) */
  lastTransactionTime?: Maybe<Scalars['ISODate']['output']>;
  /** Portfolio Item corresponding to a unique owned NFT edition */
  portfolioItem?: Maybe<PortfolioItem>;
  /** Variant (SKU) attached to the ownership record */
  variant?: Maybe<Variant>;
};

export type PageInfo = {
  /** A cursor marking the end of the current page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether a next page exists */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a previous page exists */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** A cursor marking start of the current page */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of items available */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Types of banner page types */
export enum PageType {
  /** The URL results in opening a browse page */
  BROWSE = 'BROWSE',
  /** The URL results in opening a external link */
  EXTERNAL = 'EXTERNAL',
  /** The URL results in opening a product page */
  PRODUCT = 'PRODUCT',
}

/** Payment Instrument */
export type PaymentInstrument = {
  instrumentCategory?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<PaymentProvider>;
};

/** Payment Instrument Input  */
export type PaymentInstrumentInput = {
  /** key */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The name for the payment instrument */
  name?: InputMaybe<Scalars['String']['input']>;
  /** providerType */
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

/** Payment Provider */
export type PaymentProvider = {
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Action values for money provider client token creation */
export enum PaymentProviderClientTokenAction {
  BUY = 'BUY',
  SELL = 'SELL',
  THREEDS = 'THREEDS',
  VAULT = 'VAULT',
}

/** Payment Provider */
export type PaymentProviderToken = {
  /** provider token for provider SDK initialization */
  paymentClientProviderToken?: Maybe<Scalars['String']['output']>;
};

/** Input type to create client provider token that used for SDK initialization */
export type PaymentProviderTokenInput = {
  /** action - indicating context where the provider token will be used(like 3DS,vaulting,etc..) */
  action?: InputMaybe<PaymentProviderClientTokenAction>;
  /** countryCode */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** currencyCode */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** PSP provider name for which token is to be created */
  providerName?: InputMaybe<PaymentServiceProvider>;
};

/** Provider Transaction Status */
export enum PaymentProviderTransactionStatus {
  DONE = 'DONE',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
}

/** Supported Providers for Money Session */
export enum PaymentServiceProvider {
  ADYEN = 'ADYEN',
  BRAINTREE = 'BRAINTREE',
}

/** Payment Transaction */
export type PaymentTransaction = {
  /** ID */
  id: Scalars['ID']['output'];
  /** Provider Transaction Status */
  providerStatus?: Maybe<PaymentProviderTransactionStatus>;
};

/** Error Field For Field Validation */
export type PaymentsFieldValidationError = {
  /** error code */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** error description */
  errorDescription?: Maybe<Scalars['String']['output']>;
  /** fieldKey */
  fieldName?: Maybe<Scalars['String']['output']>;
  /**
   * It's possible for the input to have a different value in the field value for ex integer,
   *
   * but we will send back the string value for it
   */
  fieldStringValue?: Maybe<Scalars['String']['output']>;
};

/** generic response for any validation api */
export type PaymentsInputValidationResponse = {
  /** are errors present */
  areErrorsPresent?: Maybe<Scalars['Boolean']['output']>;
  /** errors array */
  errors?: Maybe<Array<Maybe<PaymentsFieldValidationError>>>;
};

/** Payoneer Payment Provider */
export type PayoneerPaymentProvider = PaymentProvider & {
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
};

/** Payout fields for the current ask */
export type Payout = {
  /** Payout breakdown for the ask */
  adjustments?: Maybe<Array<Maybe<Adjustment>>>;
  /** Flag indicating if the computation is estimated or specifitic to a user */
  estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Subtotal amount, representing the ask amount */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** The final price with the adjustment fees substracted */
  total?: Maybe<Scalars['Float']['output']>;
};

export type PaypalPresentmentMessage = {
  /** Message interaction URL */
  clickUrl?: Maybe<Scalars['String']['output']>;
  /** Message impression URL */
  impressionUrl?: Maybe<Scalars['String']['output']>;
  /** Messages Recieved Under Content */
  messages?: Maybe<Array<Maybe<PaypalPresentmentMessageContent>>>;
};

export type PaypalPresentmentMessageContent = {
  /** Disclaimer Message */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Actual message to display */
  message?: Maybe<Scalars['String']['output']>;
  /** Can be one of default or generic */
  type?: Maybe<Scalars['String']['output']>;
};

export type PaypalPresentmentMessagesInput = {
  /** Required The product or cart amount for the message. */
  amount?: InputMaybe<AmountInput>;
  /** Optional Override the default country tied to the merchant account. */
  buyerCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** Optional Specify a specific Pay Later offer. */
  offerType?: InputMaybe<Scalars['String']['input']>;
};

/** Mapping between user to its provider credentials */
export type PaypalUserPaymentAccount = UserPaymentAccount & {
  /** Paypal account email for the user */
  accountEmail?: Maybe<Scalars['String']['output']>;
  /** Payments ID for the provider account */
  id?: Maybe<Scalars['ID']['output']>;
  /** If this is the preferred payment account for the user */
  isPreferred?: Maybe<Scalars['Boolean']['output']>;
  /** Payment Provider ID For This Account Braintree Adyen JPMC */
  paymentProviderAccountId?: Maybe<Scalars['String']['output']>;
  /** Payment Provider For This Account Braintree Adyen JPMC */
  provider?: Maybe<PaymentProvider>;
  /** User this card belongs to */
  user?: Maybe<User>;
};

/** Statistics based off of market events captured for a specific period of time. */
export type PeriodStatistics = {
  /** The average sale price during this period. */
  averagePrice?: Maybe<Scalars['BigInt']['output']>;
  /** The total number of sales that occurred during this period. */
  salesCount?: Maybe<Scalars['Int']['output']>;
};

export type PersonalInformationAuditHistoryEntry = {
  /** User id that made the change */
  changedBy?: Maybe<Scalars['String']['output']>;
  /** Field name of the information that has changed */
  fieldName?: Maybe<Scalars['String']['output']>;
  /** New value */
  newValue?: Maybe<Scalars['String']['output']>;
  /** Original value */
  originalValue?: Maybe<Scalars['String']['output']>;
  /** When the change was made */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

export type PlaceOrderAnalyticsInput = {
  /** All in pricing (yes/no) */
  allInFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of credit card used, if credit card was used */
  cardType?: InputMaybe<Scalars['String']['input']>;
  /** ID of portfolio item */
  chainId?: InputMaybe<Scalars['String']['input']>;
  /** Type of checkout */
  checkoutActionType?: InputMaybe<CheckoutActionType>;
  /** Unique ID for this checkout attempt */
  checkoutTraceId?: InputMaybe<Scalars['String']['input']>;
  /** Promo code if any used */
  discountCode?: InputMaybe<Scalars['String']['input']>;
  /** Duties */
  dutiesFee?: InputMaybe<Scalars['Float']['input']>;
  /** Price of item subtotal */
  itemPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Listing Type */
  listingType?: InputMaybe<Scalars['String']['input']>;
  /** example: USD */
  localCurrency?: InputMaybe<CurrencyCode>;
  /** ID of potential match portfolio item */
  matchCandidateId?: InputMaybe<Scalars['String']['input']>;
  /** Payment method for buy now */
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** Processing fee */
  paymentProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  /** Time when checkoutattempt occured */
  placeOrderTimestamp?: InputMaybe<Scalars['ISODate']['input']>;
  /** Platform that buy now was submitted on */
  platform?: InputMaybe<PlatformType>;
  /** Product type */
  productType?: InputMaybe<Scalars['String']['input']>;
  /** Sales tax */
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  /** Shipping fee */
  shippingFee?: InputMaybe<Scalars['Float']['input']>;
  /** If 3DS authentication was required for this place order attempt */
  threeDSAuthenticationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** If 3DS authentication was shown to the user after place order attempt */
  threeDSAuthenticationShown?: InputMaybe<Scalars['Boolean']['input']>;
  /** Total amount user will be charged in local currency */
  totalAmountLocal?: InputMaybe<Scalars['Float']['input']>;
  /** Total amount user will be charged in USD */
  totalAmountUsd?: InputMaybe<Scalars['Float']['input']>;
  /** Total discount */
  totalDiscount?: InputMaybe<Scalars['Float']['input']>;
  /** Billing country of user */
  userBillingCountry?: InputMaybe<Scalars['String']['input']>;
  /** Shipping country of user */
  userShippingCountry?: InputMaybe<Scalars['String']['input']>;
  /** UUID of user submitting action */
  userUuid?: InputMaybe<Scalars['String']['input']>;
  /** Product SKU UUID */
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceOrderAnalyticsOutput = {
  /** Service call successful */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Platform to gate */
export enum Platform {
  /** Gating information for Android */
  ANDROID = 'ANDROID',
  /** Gating information for iOS */
  IOS = 'IOS',
}

/** Platform type */
export enum PlatformType {
  /** Android */
  ANDROID = 'ANDROID',
  /** Desktop */
  DESKTOP = 'DESKTOP',
  /** iOS */
  IOS = 'IOS',
  /** Mweb */
  MWEB = 'MWEB',
}

/** Endpoints to query the buyer policy service */
export type Policy = {
  /** Fetch all buyer policies */
  all?: Maybe<Array<Maybe<BuyerTierPolicy>>>;
  /** Fetch a single buyer policy */
  single?: Maybe<BuyerTierPolicy>;
};

/** Endpoints to query the buyer policy service */
export type PolicySingleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioItem = {
  /** Item action */
  action?: Maybe<Scalars['Int']['output']>;
  /** actionBy */
  actionBy?: Maybe<Scalars['Int']['output']>;
  /** Item amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Authenticated user */
  authenticatedUser?: Maybe<User>;
  /** Depending on whether item is Bir or Aks, its the lowest bid to your ask or the highest ask to your bid */
  bidAskSpread?: Maybe<Scalars['Float']['output']>;
  /** Can delete item */
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Can edit item */
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Item chain ID */
  chainId: Scalars['String']['output'];
  /** Item condition */
  condition?: Maybe<Scalars['Int']['output']>;
  /** Item country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Item created at date */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Item created at time */
  createdAtTime?: Maybe<Scalars['Int']['output']>;
  /** Item customer ID */
  customerId?: Maybe<Scalars['Int']['output']>;
  /** When item expires */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** When item expires */
  expiresAtTime?: Maybe<Scalars['Int']['output']>;
  /** Link to F.A.Q page */
  faqLink?: Maybe<Scalars['String']['output']>;
  /** Amount lost or gained for item */
  gainLossDollars?: Maybe<Scalars['Float']['output']>;
  /** Percent gained or lost of item */
  gainLossPercentage?: Maybe<Scalars['Float']['output']>;
  /** Authorization hub id */
  hubId?: Maybe<Scalars['String']['output']>;
  /** Item inventorId */
  inventoryId?: Maybe<Scalars['String']['output']>;
  /** Item is part of bulk shipment */
  isPartOfBulkShipment?: Maybe<Scalars['Boolean']['output']>;
  /** Item local amount */
  localAmount?: Maybe<Scalars['Float']['output']>;
  /** Item local currency */
  localCurrency?: Maybe<Scalars['String']['output']>;
  /** Item local excahange rate */
  localExchangeRate?: Maybe<Scalars['Float']['output']>;
  /** Item local total */
  localTotal?: Maybe<Scalars['Float']['output']>;
  /** Market value for item */
  marketValue?: Maybe<Scalars['String']['output']>;
  /** Item matched state */
  matchedState?: Maybe<Scalars['Int']['output']>;
  /** Item matched with */
  matchedWith?: Maybe<Scalars['String']['output']>;
  /** Item matched with date */
  matchedWithDate?: Maybe<Scalars['String']['output']>;
  /** Item merchantId */
  merchantId?: Maybe<Scalars['Int']['output']>;
  /** Item meta data */
  meta?: Maybe<PortfolioItemMeta>;
  /** Item notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Item order number */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Item owner */
  owner?: Maybe<Scalars['String']['output']>;
  /** Item productId */
  productId?: Maybe<Scalars['String']['output']>;
  /** Returns the specific variant (size) of a product, also known as SKU */
  productVariant?: Maybe<Variant>;
  /** Item purchase date */
  purchaseDate?: Maybe<Scalars['String']['output']>;
  /** Item purchase time */
  purchaseDateTime?: Maybe<Scalars['Int']['output']>;
  /** Item purchase price */
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  /** Item refer url */
  referUrl?: Maybe<Scalars['String']['output']>;
  /** Item ship by date */
  shipByDate?: Maybe<Scalars['String']['output']>;
  /** Item skuUuid */
  skuUuid?: Maybe<Scalars['String']['output']>;
  /** Item state */
  state?: Maybe<Scalars['Int']['output']>;
  /** Item status message */
  statusMessage?: Maybe<Scalars['String']['output']>;
  /** Item text */
  text?: Maybe<Scalars['String']['output']>;
  /** Item total */
  total?: Maybe<Scalars['Float']['output']>;
  /** Item tracking */
  tracking?: Maybe<PortfolioItemTracking>;
  /** Item url */
  url?: Maybe<Scalars['String']['output']>;
  /** Item's user full name */
  userFullname?: Maybe<Scalars['String']['output']>;
  /** Item userUuid */
  userUuid?: Maybe<Scalars['String']['output']>;
};

export type PortfolioItemMeta = {
  /** Item dicount code */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** Item merchant SKU */
  merchantSku?: Maybe<Scalars['String']['output']>;
  /** Item size preference */
  sizePreferences?: Maybe<Scalars['String']['output']>;
};

export type PortfolioItemTracking = {
  /** Item delivery date */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** Item delivery date time */
  deliveryDateTime?: Maybe<Scalars['String']['output']>;
  /** Item form url */
  formUrl?: Maybe<Scalars['String']['output']>;
  /** Item label url */
  labelUrl?: Maybe<Scalars['String']['output']>;
  /** Item tracking number */
  number?: Maybe<Scalars['String']['output']>;
  /** Item tracking status */
  status?: Maybe<Scalars['Int']['output']>;
  /** Item track url */
  trackUrl?: Maybe<Scalars['String']['output']>;
};

/** Price levels for asks and bids of a given item */
export type PriceLevelConnection = {
  /** Price levels returned */
  edges?: Maybe<Array<Maybe<LevelNode>>>;
  /** Pagination info returned */
  pageInfo?: Maybe<LevelPageInfo>;
};

/** The structure which holds the pricing query calls */
export type Pricing = {
  /** The query to perform an estimate pricing */
  estimate?: Maybe<PricingResponse>;
  /** The query to perform estimate pricing for redemption */
  redeemEstimate?: Maybe<PricingResponse>;
};

/** The structure which holds the pricing query calls */
export type PricingEstimateArgs = {
  pricingInput?: InputMaybe<PricingFetchInput>;
  pricingRequestParams?: InputMaybe<PricingRequestParamsInput>;
};

/** The structure which holds the pricing query calls */
export type PricingRedeemEstimateArgs = {
  redeemInput?: InputMaybe<RedeemEstimateInput>;
};

/** PricingAdjustment represents each adjustment in the overall pricing, if it is a product/sku, the item bool is true */
export type PricingAdjustment = {
  /** Amount of the price adjustment */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The code of the discount adjustment included */
  code?: Maybe<Scalars['String']['output']>;
  /** Denotes whether it is excluded from the total */
  excludedFromTotal?: Maybe<Scalars['Boolean']['output']>;
  /** Denotes whether it is a flat adjustment */
  flat?: Maybe<Scalars['Boolean']['output']>;
  /** The group name of the adjustment struct */
  group?: Maybe<Scalars['String']['output']>;
  /** The internal group name of the adjustment */
  groupInternal?: Maybe<Scalars['String']['output']>;
  /** Denotes whether it is an invisible adjustment */
  invisible?: Maybe<Scalars['Boolean']['output']>;
  /** Denotes whether it is an item or adjustment */
  item?: Maybe<Scalars['Boolean']['output']>;
  /** The max amount of the adjustment */
  maxAmount?: Maybe<Scalars['Float']['output']>;
  /** The mon amount of the adjustment */
  minAmount?: Maybe<Scalars['Float']['output']>;
  /** The minName for the adjustment */
  minName?: Maybe<Scalars['String']['output']>;
  /** Name of the fee, mapped to pricing's translationKey */
  name?: Maybe<Scalars['String']['output']>;
  /** Fee percentage of the ask amount */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Descriptive text for the adjustment fee */
  text?: Maybe<Scalars['String']['output']>;
  /** Pricing's translationKey */
  translationKey?: Maybe<Scalars['String']['output']>;
};

/** Pricing Input  */
export type PricingFetchInput = {
  /** The VAT Id of the buyer */
  buyerVatId?: InputMaybe<Scalars['String']['input']>;
  /** discountCodes list for the user */
  discountCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The currency code for the user */
  localCurrencyCode?: InputMaybe<CurrencyCode>;
  /** Order Id of the particular transaction */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** The VAT Id of the seller */
  sellerVatId?: InputMaybe<Scalars['String']['input']>;
  /** The details of the shipping address from/to */
  shippingDetails?: InputMaybe<ShippingDetailsInput>;
  /** The details of context of the call to Pricing */
  tradeContextInput?: InputMaybe<TradeContextInput>;
  /** The SKU list for which the pricing needs to be estimated/recorded */
  variants?: InputMaybe<Array<InputMaybe<PricingVariantInput>>>;
  /** The VAT Path of the puchase */
  vatPath?: InputMaybe<Scalars['String']['input']>;
};

/** All the Pricing Guidance Available for a Product Variant */
export type PricingGuidance = {
  /** Pricing Guidance for Buyers */
  buyingGuidance?: Maybe<BuyingGuidance>;
  /** currency guidance is in */
  currencyCode?: Maybe<CurrencyCode>;
  /** Pricing Guidance for Sellers */
  sellingGuidance?: Maybe<SellingGuidance>;
};

/** Pricing Input  */
export type PricingInput = {
  /** discountCodes */
  discountCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The flags used to indicate the type of pricing to be created of a product for a user */
export type PricingRequestParamsInput = {
  /** Denotes whether to combine the adjustments in the price */
  combineAdjustments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Denotes whether to include DDP in the price */
  includeDdp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Denotes whether to include products in the price */
  includeProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Denotes whether to include taxes in the price */
  includeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The structure used to hold the response from pricing of a product for a user */
export type PricingResponse = {
  /** Payout breakdown for the price of the product */
  adjustments?: Maybe<Array<Maybe<PricingAdjustment>>>;
  /** This param contains discount code error if any */
  discountError?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the computation is estimated or specific to a user */
  estimated?: Maybe<Scalars['Boolean']['output']>;
  /** This param contains the pricing flags DDP/AllIn */
  flags?: Maybe<PricingResponseFlags>;
  /** Subtotal amount, representing the ask amount */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** The final price with the adjustment fees subtracted */
  total?: Maybe<Scalars['Float']['output']>;
};

/** The flags used to indicate the type of pricing of a product for a user */
export type PricingResponseFlags = {
  /** Denotes whether it is an All In price */
  allIn?: Maybe<Scalars['Boolean']['output']>;
  /** Denotes which currency to use for calculations */
  currency?: Maybe<Scalars['String']['output']>;
  /** This flag denotes whether DDP is enabled for the user */
  ddpEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Denotes taxmodel applicable for this Pricing calculation */
  taxModel?: Maybe<Scalars['String']['output']>;
};

/** The pricing snapshot of an order */
export type PricingSnapshot = {
  /** The pricing adjustments applied to the order */
  adjustments?: Maybe<Array<Maybe<OrderPricingAdjustment>>>;
  /** Flag for if the snapshot was estimated */
  estimated?: Maybe<Scalars['Boolean']['output']>;
  /** The flags set for the pricing snapshot */
  flags?: Maybe<OrderPricingFlags>;
  /** The price of the product, in USD */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** The price of the product + adjustments, in USD */
  total?: Maybe<Scalars['Float']['output']>;
};

/** Input for Product Variant */
export type PricingVariantInput = {
  /** Amount of the Variant */
  amount?: InputMaybe<AmountVariantInput>;
  /** Origin of the Variant */
  origin?: InputMaybe<TaxAddressInput>;
  /** Quantity of the Variant */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the Variant */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Representation of a Product at StockX */
export type Product = {
  /** Aliases of the product */
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The available size conversion */
  availableSizeConversions?: Maybe<Array<Maybe<SizeConversion>>>;
  /** Badges associated with this product */
  badges?: Maybe<Array<Maybe<Badge>>>;
  /** Products brand */
  brand?: Maybe<Scalars['String']['output']>;
  /** Breadcrumbs for a product */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumbs>>>;
  /** Verticals of the product when browsing */
  browseVerticals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Condition of the product */
  condition?: Maybe<Scalars['String']['output']>;
  /** Content group of the product */
  contentGroup?: Maybe<Scalars['String']['output']>;
  /** What country the product was manufactured in */
  countryOfManufacture?: Maybe<Scalars['String']['output']>;
  /** The default size conversion */
  defaultSizeConversion?: Maybe<SizeConversion>;
  /** Flag to indicate if the item is deleted */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Description of the product */
  description?: Maybe<Scalars['String']['output']>;
  /** Edition Type of the a NFT product */
  editionType?: Maybe<Scalars['String']['output']>;
  /** The state of a favorite item */
  favorite?: Maybe<Scalars['Boolean']['output']>;
  /** Product is followed */
  followed?: Maybe<Scalars['Boolean']['output']>;
  /** Gender of the product */
  gender?: Maybe<Scalars['String']['output']>;
  /** Denotes if the product has a 360 image */
  has360Images?: Maybe<Scalars['Boolean']['output']>;
  /** Hazardous Material information */
  hazardousMaterial?: Maybe<HazardousMaterial>;
  /** Flag to indicate if the item is hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Product's id */
  id: Scalars['String']['output'];
  /** Describes the way the product is listed for sale on StockX. */
  listingType?: Maybe<ListingType>;
  /**
   * Does this product contain a lithium ion battery
   * @deprecated Use lithiumIonBucket to determine hazard level
   */
  lithiumIonBattery?: Maybe<Scalars['Boolean']['output']>;
  /** Locale (us, uk, ...) */
  locale?: Maybe<Scalars['String']['output']>;
  /** Flag to indicate if buying the item is locked */
  lockBuying?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to indicate if the selling the item is locked */
  lockSelling?: Maybe<Scalars['Boolean']['output']>;
  /** Market data for the given product. */
  market?: Maybe<Market>;
  /** Media information around this product. Example: pictures */
  media?: Maybe<Media>;
  /** Merchandising content for the product */
  merchandising?: Maybe<ProductMerchandising>;
  /** Minimum bid for the product */
  minimumBid?: Maybe<Scalars['Int']['output']>;
  /** Flag to indicate if the item will only display on mobile */
  mobileOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The products module */
  model?: Maybe<Scalars['String']['output']>;
  /** Name of the product */
  name?: Maybe<Scalars['String']['output']>;
  /** Primary category of the product */
  primaryCategory?: Maybe<Scalars['String']['output']>;
  /** The product's primary title */
  primaryTitle?: Maybe<Scalars['String']['output']>;
  /** Category of the product */
  productCategory?: Maybe<Scalars['String']['output']>;
  /** The reciprocal digital or physical product. */
  reciprocal?: Maybe<Product>;
  /** Is this product redirected to another product */
  redirected?: Maybe<Scalars['Boolean']['output']>;
  /** Products related by the specified type */
  related?: Maybe<RelatedProductsConnection>;
  /**
   * Flag to indicate if the item is part of a restock
   * @deprecated Use 'listingType' instead.
   */
  restock?: Maybe<Scalars['Boolean']['output']>;
  /** Sales chart data for the product */
  salesChart?: Maybe<SalesChart>;
  /** Tags in Algolia */
  searchTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Secondary Category of the product */
  secondaryCategory?: Maybe<Scalars['String']['output']>;
  /** The product's secondary title */
  secondaryTitle?: Maybe<Scalars['String']['output']>;
  /** The associated SEO configuration to use for a product. */
  seo?: Maybe<ProductSeo>;
  /** Shipping information about a product */
  shipping?: Maybe<Shipping>;
  /** String description for multiple of this product */
  sizeAllDescriptor?: Maybe<Scalars['String']['output']>;
  /** Describes the type of sizes available (ex. Size, Grade, Box & Papers). */
  sizeDescriptor?: Maybe<Scalars['String']['output']>;
  /** Slug of the product */
  slug?: Maybe<Scalars['String']['output']>;
  /** Style id of this product */
  styleId?: Maybe<Scalars['String']['output']>;
  /** Tags associated with this product */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Additional tax information for a product */
  taxInformation?: Maybe<TaxInformation>;
  /** Ticker id string */
  ticker?: Maybe<Scalars['String']['output']>;
  /** Title of the product */
  title?: Maybe<Scalars['String']['output']>;
  /** Gets the most relavant trade policy that dictates the eligibility for a product to be traded */
  tradePolicy?: Maybe<ProductTradePolicy>;
  /** Information about the traits of this product, can be filtered */
  traits: Array<Traits>;
  /** Do bids need to be unique */
  uniqBids?: Maybe<Scalars['Boolean']['output']>;
  /** Key for the url (stockx.io/{{urlKey Here}}) */
  urlKey?: Maybe<Scalars['String']['output']>;
  /** Universal Unique Identifier for this product */
  uuid?: Maybe<Scalars['String']['output']>;
  /** Product variants */
  variants?: Maybe<Array<Maybe<Variant>>>;
};

/** Representation of a Product at StockX */
export type ProductBadgesArgs = {
  market?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Representation of a Product at StockX */
export type ProductMarketArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
};

/** Representation of a Product at StockX */
export type ProductMediaArgs = {
  hiddenOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Representation of a Product at StockX */
export type ProductMinimumBidArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
};

/** Representation of a Product at StockX */
export type ProductRelatedArgs = {
  input?: InputMaybe<RelatedProductsInput>;
};

/** Representation of a Product at StockX */
export type ProductSalesChartArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  intervals?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** Representation of a Product at StockX */
export type ProductTradePolicyArgs = {
  context?: InputMaybe<TradePolicyContext>;
  destinationCountryCode?: InputMaybe<Scalars['String']['input']>;
  destinationRegion?: InputMaybe<Scalars['String']['input']>;
  originCountryCode?: InputMaybe<Scalars['String']['input']>;
  originRegion?: InputMaybe<Scalars['String']['input']>;
};

/** Representation of a Product at StockX */
export type ProductTraitsArgs = {
  filterTypes?: InputMaybe<Array<TraitType>>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Vertical */
export type ProductCategoryInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** Type representing a collection of products. */
export type ProductCollection = {
  /** The type of footnotes to show for the product tiles */
  footnotesType?: Maybe<ProductCollectionFootnotesType>;
  /** The help message associated with the collection */
  helpMessage?: Maybe<Scalars['String']['output']>;
  /** The unique id of the product collection */
  id?: Maybe<Scalars['String']['output']>;
  /** The price information to show for the product tiles */
  priceType?: Maybe<ProductCollectionPriceType>;
  /** Obtains the products to display for the product collection */
  products?: Maybe<ProductsConnection>;
  /** Obtains the results to display for the product collection */
  results?: Maybe<ProductCollectionResultsConnection>;
  /** The link information for the see all CTA */
  seeAllCTA?: Maybe<LinkInformation>;
  /** The type of tile to show for the product */
  tileType?: Maybe<ProductCollectionTileType>;
  /** The title of the collection */
  title?: Maybe<Scalars['String']['output']>;
  /** The tracking event for the collection */
  trackingEvent?: Maybe<Scalars['String']['output']>;
};

/** Type representing a collection of products. */
export type ProductCollectionProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Type representing a collection of products. */
export type ProductCollectionResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Describes the footnotes to show for a tile within a product collection. */
export enum ProductCollectionFootnotesType {
  /** Show the Hidden Gem static footnote text on the product tile */
  HIDDEN_GEM = 'HIDDEN_GEM',
  /** Show the last sale footnotes on the product tile */
  LAST_SALE = 'LAST_SALE',
  /** Show the number of items sold footnotes on the product tile */
  NUMBER_SOLD = 'NUMBER_SOLD',
}

/** Describes the pricing to show for a tile within a product collection. */
export enum ProductCollectionPriceType {
  /** Show the highest bid on the product tile */
  HIGHEST_BID = 'HIGHEST_BID',
  /** Show the lowest ask on the product tile */
  LOWEST_ASK = 'LOWEST_ASK',
  /** Show the lowest ask value on the product tile next to the 90 day average sale value with a strikethrough */
  LOWEST_ASK_WITH_STRIKETHROUGH = 'LOWEST_ASK_WITH_STRIKETHROUGH',
}

export type ProductCollectionResultsConnection = {
  /** The edges to the results */
  edges?: Maybe<Array<Maybe<ProductCollectionResultsNode>>>;
  /** The pagination information */
  pageInfo?: Maybe<ProductCollectionResultsPageInfo>;
};

/** The actual result: either a Product or Variant. */
export type ProductCollectionResultsItem = Product | Variant;

export type ProductCollectionResultsNode = {
  /** Describes whether or not the result was sponsored */
  isAd?: Maybe<Scalars['Boolean']['output']>;
  /** The connection to the actual product or variant. */
  node?: Maybe<ProductCollectionResultsItem>;
};

export type ProductCollectionResultsPageInfo = {
  /** The total number of items in the results. */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Describes the style of a tile within a product collection. */
export enum ProductCollectionTileType {
  /** Renders each product as a calendar tile */
  CALENDAR_TILE = 'CALENDAR_TILE',
  /** Renders each product as a normal tile */
  NORMAL_TILE = 'NORMAL_TILE',
}

export type ProductIdsFilter = {
  /** IDs of the products. If specified will return asks of a specific products. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The merchandising material for the product */
export type ProductMerchandising = {
  /** The body to display. */
  body?: Maybe<Scalars['String']['output']>;
  /** The image to display for the content. */
  image?: Maybe<ImageInformation>;
  /** The URL to navigate to when interacting with the content. */
  link?: Maybe<LinkInformation>;
  /** The subtitle for the content. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The title for the content. */
  title?: Maybe<Scalars['String']['output']>;
  /** The tracking event to use for analytics purposes. */
  trackingEvent?: Maybe<Scalars['String']['output']>;
};

/** A link to a Product that holds information around the connection to a product */
export type ProductNode = {
  /** A single product */
  node?: Maybe<Product>;
};

/** Details of the Policy */
export type ProductPolicyLane = {
  /** The Country ISO2 the trade is headed to (Auth Center or Buyer). Null for any */
  destinationCountry?: Maybe<Scalars['String']['output']>;
  /** The Region the trade is headed to (Auth Center or Buyer). Null for any */
  destinationRegion?: Maybe<Scalars['String']['output']>;
  /** The Country ISO2 the trade would start in (Seller, or Auth Center). Null for any */
  originCountry?: Maybe<Scalars['String']['output']>;
  /** The Region the trade would start in (Seller, or Auth Center). Null for any */
  originRegion?: Maybe<Scalars['String']['output']>;
  /** Whether this policy allows the trade to be executed */
  tradeEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Information on which Policy is Applied for the given Product */
export type ProductPolicyTrait = {
  /** The Lithium Ion Bucket Classification */
  productLithiumIonBucket?: Maybe<LithiumHazardousBucketType>;
};

/** Type containing all of the SEO data for a product */
export type ProductSeo = {
  /** The meta tags to use for the product */
  meta?: Maybe<Array<Maybe<MetaOverrideField>>>;
};

/** List of the types of selects one can do to product */
export enum ProductSelectionType {
  /** A set of products that are below their retail price */
  BELOW_RETAIL = 'BELOW_RETAIL',
  /** Featured products */
  FEATURED = 'FEATURED',
  /** Popular products */
  MOST_POPULAR = 'MOST_POPULAR',
  /** Most popular products in a region */
  MOST_POPULAR_IN_REGION = 'MOST_POPULAR_IN_REGION',
  /** Products that will release soon */
  NEW_RELEASES = 'NEW_RELEASES',
  /** Products that are recently viewed for the current user */
  RECENTLY_VIEWED = 'RECENTLY_VIEWED',
  /** Products with recent asks */
  RECENT_ASKS = 'RECENT_ASKS',
  /** Products with recent bids */
  RECENT_BIDS = 'RECENT_BIDS',
  /** Products that are recommended for the current user */
  RECOMMENDED_FOR_YOU = 'RECOMMENDED_FOR_YOU',
  /** Related to a user's most recently viewed products */
  RELATED_TO_RECENTLY_VIEWED = 'RELATED_TO_RECENTLY_VIEWED',
  /** Products that are trending deals */
  TRENDING_DEALS = 'TRENDING_DEALS',
}

/** Trade Policy used to Determine trade restrictions for a given product */
export type ProductTradePolicy = {
  /**
   * Enforcement details of a policy
   * @deprecated Use 'tradeEnabled' for source of truth.
   */
  policyLane?: Maybe<ProductPolicyLane>;
  /** Information on the Policy itself */
  policyTrait?: Maybe<ProductPolicyTrait>;
  /** Trade Blocking Reason */
  reason?: Maybe<ProductTradePolicyBlockedReason>;
  /** Trade is enabled */
  tradeEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Details of the Trade Policy Blocked Reason */
export type ProductTradePolicyBlockedReason = {
  /** The description for Trade Policy Blocking */
  description?: Maybe<Scalars['String']['output']>;
  /** The Trade Policy Blocking Image */
  iconImageUrl?: Maybe<Scalars['String']['output']>;
  /** The title for Trade Policy Blocking */
  title?: Maybe<Scalars['String']['output']>;
};

/** Connection to a product */
export type ProductsConnection = {
  /** An array of product nodes */
  edges?: Maybe<Array<Maybe<ProductNode>>>;
  /** Pagination information */
  pageInfo?: Maybe<ProductsPageInfo>;
};

/** Pagination information */
export type ProductsPageInfo = {
  /** Total number of product nodes */
  total?: Maybe<Scalars['Int']['output']>;
};

/** PromoFlash */
export type PromoFlash = {
  /** Content for the current promo flash */
  content?: Maybe<PromoFlashContent>;
  /** Eligible countries */
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** End Date of the Promo */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Flag whether to hide this promo flash */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Start Date of the Promo */
  startDate?: Maybe<Scalars['String']['output']>;
};

/** A Base PromoFlash content */
export type PromoFlashContent = {
  /** Type of the Promo Flash */
  contentType?: Maybe<PromoFlashType>;
  /** Flag whether to hide this promo flash */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Unique title of the Promo Flash */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the current Promo Flash */
  uid?: Maybe<Scalars['String']['output']>;
};

/** List of all the PromoFlash Groups */
export type PromoFlashGroup = {
  /** Flag whether to hide all the promos */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of all promo flashes to display */
  promos?: Maybe<Array<Maybe<PromoFlash>>>;
  /** Unique title of the promo layout */
  title?: Maybe<Scalars['String']['output']>;
  /** Id of the Layout */
  uid?: Maybe<Scalars['String']['output']>;
};

/** The base enum for the different Promo Flashes */
export enum PromoFlashType {
  /** Represents a Banner */
  BANNER_PROMO_FLASH = 'BANNER_PROMO_FLASH',
  /** Represents a Modal */
  MODAL_PROMO_FLASH = 'MODAL_PROMO_FLASH',
}

/** Input structure for creating a buyer tier with new buy fee discount */
export type ProposedBuyerFeeInput = {
  /** The Buyer Fee Proposed */
  buyerFee?: InputMaybe<Scalars['Float']['input']>;
  /** The Buyer Fee Discount Proposed */
  buyerFeeDiscount?: InputMaybe<Scalars['Float']['input']>;
};

/** Input structure for creating a buyer tier with new shipping fee discount */
export type ProposedBuyerShippingDiscountInput = {
  /** The Buyer Shipping Fee Proposed Country ISO2 Code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The proposed  Buyer Shipping Fee Discount for a country */
  shippingFeeDiscount?: InputMaybe<Scalars['Float']['input']>;
};

/** Input structure for creating a buyer tier */
export type ProposedBuyerTierInput = {
  /** The Buyer tier description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The Buyer tier level */
  level?: InputMaybe<Scalars['Int']['input']>;
  /** The Minimum Purchase Count */
  minimumPurchaseCount?: InputMaybe<Scalars['Int']['input']>;
  /** The Minimum Purchase GMV */
  minimumPurchaseGmv?: InputMaybe<Scalars['Float']['input']>;
  /** The Buyer tier name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Provider tokens Input */
export type ProviderTokensInput = {
  /** key */
  key?: InputMaybe<Scalars['String']['input']>;
  /** value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** QR Code Action */
export type QrCodeAction = CheckoutAction & {
  /** ttl */
  ttl?: Maybe<Scalars['Int']['output']>;
  /** url */
  url?: Maybe<Scalars['String']['output']>;
};

/** An aggregate of sales count and revenue over a given quarter */
export type QuarterlyAggregate = {
  /** The quarter this data is for */
  quarter?: Maybe<Scalars['String']['output']>;
  /** Number of sales that occured in the given quarter */
  salesCount?: Maybe<Scalars['Int']['output']>;
  /** Total Revenue (in USD) earend in the given quarter */
  salesRevenue?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  /** Returns an array of actions scoped to the actors jwt */
  LREActions?: Maybe<LreActionsConnection>;
  /** Returns an array of checks scoped to the actors jwt */
  LREChecks?: Maybe<LreChecksConnection>;
  /** Returns an array of conditions scoped to the actors jwt */
  LREConditions?: Maybe<LreConditionsConnection>;
  /** Returns an array of predefined actions */
  LREPredefinedActions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns an array of predefined operators */
  LREPredefinedOperators?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns an array of rules scoped to the actors jwt */
  LRERules?: Maybe<LreRulesConnection>;
  /** Returns an array of trees scoped to the actors jwt */
  LRETrees?: Maybe<LreTreesConnection>;
  /** Get a single MetaTagsOverride for a given slug including leading slash ex '/jordan-1'  */
  MetaTagsOverride?: Maybe<MetaTagsOverride>;
  /** Get all MetaTagsOverrides */
  MetaTagsOverrides?: Maybe<Array<Maybe<MetaTagsOverride>>>;
  /** Get A/B test variants for the authenticated user or an anonymous user (using the deviceId) from LaunchDarkly. */
  abTestVariants?: Maybe<Array<Maybe<ExperimentVariant>>>;
  /** Query to get the address form definition for the given country and address type */
  addressForm?: Maybe<AddressForm>;
  /** Query to get the user's saved addresses */
  addresses?: Maybe<UserAddresses>;
  /** A representation of all countries StockX operates in, with several optional filters */
  allCountries?: Maybe<Array<Maybe<Country>>>;
  /** Obtains a set of products that match the given type and filters. */
  allProducts?: Maybe<ProductsConnection>;
  /** Obtains the banner carousel with the given collection */
  bannerCarousel?: Maybe<BannerCarousel>;
  /** Obtains the banner collage with the given campaign */
  bannerCollage?: Maybe<BannerCollage>;
  /**
   * Banners for the home page.
   * @deprecated Use bannerCarousel going forward
   */
  banners?: Maybe<Array<Maybe<Banner>>>;
  /** Obtains a set of results, either products or variants, based upon the given inputs. */
  browse?: Maybe<Browse>;
  /** The list of available sorts to use while browsing for products. */
  browseSorts?: Maybe<Array<Maybe<BrowseSort>>>;
  /** Returns a list of browse suggestions given a query. */
  browseSuggestions?: Maybe<Array<Maybe<BrowseSuggestion>>>;
  /** Member for policy endpoints */
  buyer?: Maybe<Buyer>;
  /** Returns a list of curated search pages. */
  curatedSearchPages?: Maybe<Array<Maybe<CuratedSearchPage>>>;
  /** Gets a specific digital product */
  digitalProduct?: Maybe<DigitalProduct>;
  digitalProducts?: Maybe<DigitalProductConnection>;
  /** A list of discount codes */
  discountCodes?: Maybe<DiscountCodesConnection>;
  /** Return dynamic landing page layout data */
  dynamicLandingPage?: Maybe<Array<Maybe<DlpLayout>>>;
  /** Get experiment variants for the authenticated user and given deviceId from LaunchDarkly. */
  experimentVariants?: Maybe<Array<Maybe<ExperimentVariant>>>;
  /** Get feature flags for the authenticated user and given deviceId from LaunchDarkly. */
  featureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  /** Returns location information */
  geoIPLocation?: Maybe<GeoIpLocation>;
  /** Query to get the operations associated with a listing */
  getAllListingOperations?: Maybe<ListingOperationConnection>;
  /** Query to get asks from a batch */
  getBatchAsks?: Maybe<BatchAsksResult>;
  /** Query to get a single CreateAskBatch */
  getCreateBatchAsk?: Maybe<CreateBatchAskPayload>;
  /** Query to find a listing by id */
  getListingById?: Maybe<ListingPayload>;
  /** Query to get a single CreateListingBatch */
  getListingCreateBatch?: Maybe<CreateListingBatchPayload>;
  /** Query to get listings from a batch */
  getListingCreateBatchItems?: Maybe<CreateListingBatchItemsPayload>;
  /** Query to get a single DeleteListingBatch */
  getListingDeleteBatch?: Maybe<DeleteListingBatchPayload>;
  /** Query to get delete listings from a batch */
  getListingDeleteBatchItems?: Maybe<DeleteListingBatchItemsPayload>;
  /** Query to find a listing operation by id */
  getListingOperationById?: Maybe<ListingOperationPayload>;
  getListingUpdateBatch?: Maybe<UpdateListingBatchPayload>;
  getListingUpdateBatchItems?: Maybe<UpdateListingBatchItemsPayload>;
  /** A list of subscriptions, via signed in customer */
  getNotificationSubscriptions?: Maybe<Array<Maybe<NotificationSubscription>>>;
  /** Query to get the most recent changes for listing */
  getRecentListingChanges?: Maybe<ListingOperationConnection>;
  /** The SmsProfile associated to a customer, via signed in customer */
  getSmsProfile?: Maybe<SmsProfile>;
  /** Return a nice message */
  helloAnalytics?: Maybe<Scalars['String']['output']>;
  /** Return a nice message */
  helloDiscountCodes?: Maybe<Scalars['String']['output']>;
  /** Obtains the components to show on a user's home page */
  homeLayout?: Maybe<Array<Maybe<HomeLayoutComponent>>>;
  /**
   * An inspector is a representation of a user for someone other
   * than that user. Often, the user is picked out not by a stable identifier,
   * like a UUID, but with a less stable identifier, like an email.
   */
  inspector?: Maybe<User>;
  /** Obtains a list for the given unique identifier. */
  list?: Maybe<List>;
  /** Obtains all of the lists that should be shown in the add to lists dropdown. */
  listOptions?: Maybe<ListsConnection>;
  /** Obtains all of the lists created by the user. */
  lists?: Maybe<ListsConnection>;
  /** Return a nice message */
  news?: Maybe<Array<Maybe<News>>>;
  /** Gets a list of minted NFT objects. */
  nfts?: Maybe<NftConnection>;
  onboardingFlow?: Maybe<OnboardingFlow>;
  /** Fetch order by id */
  order?: Maybe<Order>;
  /** Get a list of orders for a given type */
  orders?: Maybe<Array<Maybe<Order>>>;
  /** Gets all the payment instruments available for the countries, CurrencyCode, and specified InstrumentCategories */
  paymentInstruments?: Maybe<Array<Maybe<PaymentInstrument>>>;
  /** Gets a Transaction By Id */
  paymentTransaction: PaymentTransaction;
  /** Get presentment messages for Paypal BNPL */
  paypalPresentmentMessages?: Maybe<PaypalPresentmentMessage>;
  /** The object which contains the pricing query calls */
  pricing?: Maybe<Pricing>;
  /** A StockX product */
  product?: Maybe<Product>;
  /** Obtains a product collection for the given id. */
  productCollection?: Maybe<ProductCollection>;
  /** A set of skus */
  products?: Maybe<Array<Maybe<Product>>>;
  /** Return a promo flash data */
  promoFlash?: Maybe<PromoFlashGroup>;
  /** Return all promo flashes data */
  promoFlashes?: Maybe<Array<Maybe<PromoFlashGroup>>>;
  /** A list of seller promotions */
  sellerPromotions?: Maybe<Array<Maybe<SellerPromotion>>>;
  /** Returns a single shipment based on tracking number, displayId, or uuid */
  shipment?: Maybe<Shipment>;
  /** Returns a list of all shipment carriers */
  shipmentCarriers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns a list of all shipments based on referenceId (formerly known as chainId), referenceType, and (optionally) description */
  shipmentHistory?: Maybe<Array<Maybe<Shipment>>>;
  /** Returns a list of all shipment label types */
  shipmentLabelTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns an array of shipments scoped to the actors jwt */
  shipments?: Maybe<ShipmentsConnection>;
  /** Array of information to display in the ticker section of the site */
  tickers?: Maybe<Array<Maybe<Ticker>>>;
  /** Obtains all tiles within the given collection. */
  tileCollection?: Maybe<TileCollection>;
  /** A representation of all top ranked countries StockX operates in, with several optional filters */
  topCountries?: Maybe<Array<Maybe<Country>>>;
  /** Member for buyer profile endpoints */
  user?: Maybe<User>;
  /** Obtains all entries within the instagram collection */
  userGeneratedContentCollection?: Maybe<UserGeneratedContentCollection>;
  /** Obtains the entry for a given id. */
  userGeneratedContentEntry?: Maybe<UserGeneratedContentEntry>;
  /** A product variant (sku) i.e.. size, color, etc... */
  variant?: Maybe<Variant>;
  /** Get A Vaulting Session By ID */
  vaultingSession?: Maybe<VaultingSession>;
  /** Version gating information for given platform */
  versionCheck?: Maybe<Array<Maybe<Gate>>>;
  /** The viewer represents a logged-in user */
  viewer?: Maybe<User>;
};

export type QueryLreActionsArgs = {
  filters?: InputMaybe<LreFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<LreOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LreSortInput>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLreChecksArgs = {
  conditionId?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<LreFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<LreOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LreSortInput>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLreConditionsArgs = {
  filters?: InputMaybe<LreFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<LreOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LreSortInput>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLreRulesArgs = {
  filters?: InputMaybe<LreFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<LreOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LreSortInput>;
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLreTreesArgs = {
  filters?: InputMaybe<LreFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<LreOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<LreSortInput>;
};

export type QueryMetaTagsOverrideArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAbTestVariantsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAddressFormArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressType>;
};

export type QueryAllCountriesArgs = {
  filter?: InputMaybe<CountriesFilter>;
};

export type QueryAllProductsArgs = {
  filters?: InputMaybe<AllProductsFilters>;
  page?: InputMaybe<AllProductPageInput>;
  type: ProductSelectionType;
};

export type QueryBannerCarouselArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBannerCollageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBannersArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  vertical?: InputMaybe<Vertical>;
};

export type QueryBrowseArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  experiments?: InputMaybe<BrowseExperimentsInput>;
  filters?: InputMaybe<Array<InputMaybe<BrowseFilterInput>>>;
  filtersVersion?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<BrowsePageInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BrowseSortInput>;
};

export type QueryBrowseSuggestionsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCuratedSearchPagesArgs = {
  limit?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDigitalProductArgs = {
  productId: Scalars['String']['input'];
};

export type QueryDigitalProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDiscountCodesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDynamicLandingPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExperimentVariantsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeatureFlagsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGeoIpLocationArgs = {
  ip?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAllListingOperationsArgs = {
  input?: InputMaybe<FindAllListingOperationsInput>;
};

export type QueryGetBatchAsksArgs = {
  input?: InputMaybe<BatchAsksInput>;
};

export type QueryGetCreateBatchAskArgs = {
  input?: InputMaybe<GetCreateBatchAskInput>;
};

export type QueryGetListingByIdArgs = {
  input?: InputMaybe<FindListingByIdInput>;
};

export type QueryGetListingCreateBatchArgs = {
  input?: InputMaybe<GetCreateListingBatchInput>;
};

export type QueryGetListingCreateBatchItemsArgs = {
  input?: InputMaybe<GetCreateListingBatchInput>;
};

export type QueryGetListingDeleteBatchArgs = {
  input?: InputMaybe<GetDeleteListingBatchInput>;
};

export type QueryGetListingDeleteBatchItemsArgs = {
  input?: InputMaybe<GetDeleteListingBatchInput>;
};

export type QueryGetListingOperationByIdArgs = {
  input?: InputMaybe<FindListingOperationByIdInput>;
};

export type QueryGetListingUpdateBatchArgs = {
  input?: InputMaybe<GetUpdateListingBatchInput>;
};

export type QueryGetListingUpdateBatchItemsArgs = {
  input?: InputMaybe<GetUpdateListingBatchInput>;
};

export type QueryGetRecentListingChangesArgs = {
  input?: InputMaybe<FindRecentListingChangesInput>;
};

export type QueryHomeLayoutArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<Vertical>;
};

export type QueryInspectorArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListOptionsArgs = {
  page?: InputMaybe<ListsPageInput>;
  productId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ListsSortInput>;
};

export type QueryListsArgs = {
  page?: InputMaybe<ListsPageInput>;
  sort?: InputMaybe<ListsSortInput>;
};

export type QueryNewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<Vertical>;
};

export type QueryNftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOnboardingFlowArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrderArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrdersArgs = {
  orderSourceType?: InputMaybe<OrderSourceType>;
};

export type QueryPaymentInstrumentsArgs = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyCode?: InputMaybe<CurrencyCode>;
  instrumentCategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryPaymentTransactionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPaypalPresentmentMessagesArgs = {
  input?: InputMaybe<PaypalPresentmentMessagesInput>;
};

export type QueryProductArgs = {
  id: Scalars['String']['input'];
};

export type QueryProductCollectionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductsArgs = {
  ids: Array<Scalars['String']['input']>;
};

export type QueryPromoFlashArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySellerPromotionsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryShipmentArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  commercialInvoiceDownloadUrl?: InputMaybe<Scalars['Boolean']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  motherShipmentId?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryShipmentHistoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryShipmentsArgs = {
  combination?: InputMaybe<ShipmentCombinationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ShipmentOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ShipmentSortInput>;
};

export type QueryTickersArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
  vertical?: InputMaybe<Vertical>;
};

export type QueryTileCollectionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTopCountriesArgs = {
  filter?: InputMaybe<CountriesFilter>;
};

export type QueryUserGeneratedContentCollectionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserGeneratedContentEntryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVariantArgs = {
  gtin?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVaultingSessionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryVersionCheckArgs = {
  platform?: InputMaybe<Platform>;
};

/** Item Object that describes the cost and type of shipment used */
export type RateItem = {
  /** The carrier used for this shipment i.e. DHL, UPS, etc */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Cost of the shipment */
  cost?: Maybe<Scalars['String']['output']>;
  /** Type of shipping service used i.e. UPS WORLDWIDE EXPEDITED, UPS GROUND, UPS 2-DAY AIR, etc. */
  service?: Maybe<Scalars['String']['output']>;
};

/** The seller's rate per vertical */
export type RatesByVertical = {
  /** rate for collectibles */
  collectibles?: Maybe<Scalars['Float']['output']>;
  /** rate for handbags */
  handbags?: Maybe<Scalars['Float']['output']>;
  /** rate for sneakers */
  sneakers?: Maybe<Scalars['Float']['output']>;
  /** rate for streetwear */
  streetwear?: Maybe<Scalars['Float']['output']>;
  /** rate for watches */
  watches?: Maybe<Scalars['Float']['output']>;
};

/** Redeem Input */
export type RedeemEstimateInput = {
  /** The VAT Id of the buyer */
  buyerVatId?: InputMaybe<Scalars['String']['input']>;
  /** discountCodes list for the user */
  discountCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The currency code for the user */
  localCurrencyCode?: InputMaybe<CurrencyCode>;
  /** Order Id of the particular transaction */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** The VAT Id of the seller */
  sellerVatId?: InputMaybe<Scalars['String']['input']>;
  /** The details of the shipping address from/to */
  shippingDetails?: InputMaybe<ShippingDetailsInput>;
  /** The details of context of the call to Pricing */
  tradeContextInput?: InputMaybe<TradeContextInput>;
  /** The SKU list for which the pricing needs to be estimated  */
  variants?: InputMaybe<Array<InputMaybe<RedeemVariantInput>>>;
  /** The VAT Path of the puchase */
  vatPath?: InputMaybe<Scalars['String']['input']>;
};

/** Input for Redeem Variant */
export type RedeemVariantInput = {
  /** Parent Chain Id */
  chainId?: InputMaybe<Scalars['String']['input']>;
  /** Quantity of the Variant */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the Variant */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create a vault nft redemption order. */
export type RedeemVaultNftInput = {
  /** The payment session id */
  paymentSessionId?: InputMaybe<Scalars['String']['input']>;
  /** The pricing snapshot for the redemption order */
  pricing?: InputMaybe<RedemptionPricingSnapshotInput>;
  /** The chain id of the bid that acquired the Vault NFT */
  sourceChainId?: InputMaybe<Scalars['String']['input']>;
  /** The userUUID for the redeemer */
  userUUID?: InputMaybe<Scalars['String']['input']>;
};

/** The pricing adjustment for the redemption order */
export type RedemptionPricingAdjustmentInput = {
  /** The change amount */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** The adjustment code used */
  code?: InputMaybe<Scalars['String']['input']>;
  /** If the adjustment does not affect the total */
  excludedFromTotal?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the adjustment was a flat rate or not */
  flat?: InputMaybe<Scalars['Boolean']['input']>;
  /** The adjustment group */
  group?: InputMaybe<Scalars['String']['input']>;
  /** The adjustment group code */
  groupInternal?: InputMaybe<Scalars['String']['input']>;
  /** If the adjustment should be visible or not to the ui */
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** The adjustment was associated with the item */
  item?: InputMaybe<Scalars['Boolean']['input']>;
  /** The max amount of the adjustment */
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The min amount of the adjustment */
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The min amount name of the adjustment */
  minName?: InputMaybe<Scalars['String']['input']>;
  /** The adjustment change percentage */
  percentage?: InputMaybe<Scalars['Float']['input']>;
  /** The adjustment name */
  text?: InputMaybe<Scalars['String']['input']>;
  /** The translation key used for the pricing */
  translationKey?: InputMaybe<Scalars['String']['input']>;
};

/** The pricing adjustment flags */
export type RedemptionPricingFlagsInput = {
  /** All-in pricing flag */
  allIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Delivered Duty Paid Flag */
  ddpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The tax model used */
  taxModel?: InputMaybe<Scalars['String']['input']>;
};

/** The pricing snapshot for the redemption order */
export type RedemptionPricingSnapshotInput = {
  /** The pricing adjustments applied to the order */
  adjustments?: InputMaybe<Array<InputMaybe<RedemptionPricingAdjustmentInput>>>;
  /** The currency of the order */
  currency?: InputMaybe<CurrencyCode>;
  /** Flag for if the snapshot was estimated */
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The flags set for the pricing snapshot */
  flags?: InputMaybe<RedemptionPricingFlagsInput>;
  /** The subtotal of the order */
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  /** The total of the order */
  total?: InputMaybe<Scalars['Float']['input']>;
};

/** Redirect Action */
export type RedirectAction = CheckoutAction & {
  /** url */
  url?: Maybe<Scalars['String']['output']>;
};

export type Region = {
  /** The Region Code */
  code?: Maybe<Scalars['String']['output']>;
  /** The Region's Country UUID */
  countryId?: Maybe<Scalars['String']['output']>;
  /** The Region UUID */
  id?: Maybe<Scalars['String']['output']>;
  /** The Region Name */
  name?: Maybe<Scalars['String']['output']>;
  /** The Region Sorting Order */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type RegulatoryId = {
  /** Country where this regulatory id applies */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** The id type (ex: license number, tax id) */
  idType?: Maybe<Scalars['String']['output']>;
  /** The regulatory id */
  idValue?: Maybe<Scalars['String']['output']>;
  /** Unique primary key for this regulatory id */
  regIdUuid?: Maybe<Scalars['String']['output']>;
  /** User UUID corresponding to this regulatory id */
  userUuid?: Maybe<Scalars['String']['output']>;
};

export type RelatedBrowseSuggestions = {
  /** A boolean to determine if given search page is curated or not. */
  isCuratedPage?: Maybe<Scalars['Boolean']['output']>;
  /** Supported locales. */
  locales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Related search and browse pages */
  relatedPages?: Maybe<Array<Maybe<BrowseSuggestion>>>;
};

/** A connection to the related products */
export type RelatedProductsConnection = {
  /** The related product nodes */
  edges?: Maybe<Array<Maybe<ProductNode>>>;
  /** Pagination information */
  pageInfo?: Maybe<ProductsPageInfo>;
};

/** Input determining type of related products to serve */
export type RelatedProductsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<RelatedProductsType>;
};

/** How products may be related */
export enum RelatedProductsType {
  /** Recommended from other verticals exclusively */
  CROSS_SELL = 'CROSS_SELL',
  /** Recently viewed products */
  RECENTLY_VIEWED = 'RECENTLY_VIEWED',
  /** Related as determined by similarity measures such as tf-idf, image similiarity, etc. */
  RELATED = 'RELATED',
}

export type RemoveListInput = {
  /** The unique id of the list to remove. */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveListResult = {
  /** The list that was removed. */
  list?: Maybe<List>;
};

/** The result of the repairShipments mutation */
export type RepairShipmentResponse = {
  /** Not repaired shipments */
  notRepaired?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Repaired shipments */
  repaired?: Maybe<Array<Maybe<RepairedDetails>>>;
};

/** The result of the repaired shipments */
export type RepairedDetails = {
  /** Shipment chainId */
  chainId?: Maybe<Scalars['String']['output']>;
  /** Shipment uuids */
  shipmentUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** An anonymous snapshot of an Order called a Sale. */
export type Sale = {
  /** The amount the sale occurred at. */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** The variant associated with the sale. */
  associatedVariant?: Maybe<Variant>;
  /** The date and time the sale occurred at. */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Describes whether or not the user would have had a similar fee structure to the buyer that made the purchase. */
  sameFees?: Maybe<Scalars['Boolean']['output']>;
};

/** The product's sales chart */
export type SalesChart = {
  /** Series of points to show on the chart */
  series?: Maybe<Array<Maybe<SalesChartPoint>>>;
};

/** A specific point on a product's sales chart */
export type SalesChartPoint = {
  /** The X-yalue for the point; a ISO date being represented. */
  xValue?: Maybe<Scalars['ISODate']['output']>;
  /** The Y-value for the point; a concurrency converted amount the averages all sales on that date occurred at. */
  yValue?: Maybe<Scalars['Int']['output']>;
};

/** Connection to the historical list of sales. */
export type SalesConnection = {
  /** The list of edges for the connection. */
  edges?: Maybe<Array<Maybe<SalesEdge>>>;
  /** The page information for the connection. */
  pageInfo?: Maybe<SalesPageInfo>;
};

/** Edge exposing the actual sale and information specific to this access pattern. */
export type SalesEdge = {
  /** The cursor to this specific sale in the paginated list. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The actual sale. */
  node?: Maybe<Sale>;
};

/** Information around the sales of this item */
export type SalesInformation = {
  /**
   * Annual high amount
   * @deprecated This data is now availabile under statistics.annual.annualHigh. Please migrate.
   */
  annualHigh?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Annual low amount
   * @deprecated This data is now availabile under statistics.annual.annualLow. Please migrate.
   */
  annualLow?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Percentage change
   * @deprecated This data is now availabile under statistics.lastSale.changePercentage. Please migrate.
   */
  changePercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * Change value
   * @deprecated This data is now availabile under statistics.lastSale.changeValue. Please migrate.
   */
  changeValue?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Price of the last sale
   * @deprecated This data is now availabile under statistics.lastSale.amount. Please migrate.
   */
  lastSale?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Date of the last sale
   * @deprecated This data is now availabile under statistics.lastSale.createdAt. Please migrate.
   */
  lastSaleDate?: Maybe<Scalars['String']['output']>;
  /**
   * Price premium
   * @deprecated This data is now availabile under statistics.annual.pricePremium. Please migrate.
   */
  pricePremium?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of sales in the last 3 days (72 hours)
   * @deprecated This data is now availabile under statistics.last72Hours.salescount. Please migrate.
   */
  salesLast72Hours?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of sales in the last period
   * @deprecated This data is now availabile under statistics.previous72Hours.salesCount. Please migrate.
   */
  salesLastPeriod?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of sales this period
   * @deprecated This data is now availabile under statistics.last72Hours.salesCount. Please migrate.
   */
  salesThisPeriod?: Maybe<Scalars['Int']['output']>;
  /**
   * How volatile the object is
   * @deprecated This data is now availabile under statistics.annual.volatility. Please migrate.
   */
  volatility?: Maybe<Scalars['Float']['output']>;
};

/** Pagination information for the sales connection. */
export type SalesPageInfo = {
  /** The cursor that points to the first edge in the result set. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of sales included in this page. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The cursor that points to the first edge in the result set. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of sales. */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Errors from saving a dynamic address */
export type SaveAddressError = {
  /** List of errors associated with an address field */
  fieldErrors?: Maybe<Array<Maybe<AddressFieldError>>>;
  /** Generic (top level) error */
  genericError?: Maybe<GenericAddressError>;
};

/** Input for the saveAddress mutation */
export type SaveAddressInput = {
  /** The dynamic address to be saved */
  address?: InputMaybe<DynamicAddressInput>;
  /** Token that represents the address wished to be saved. If addressToken if present, the 'address' input will be ignored in favor of the encoded address data within this token. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Token to force the DynamicAddressInput to be saved without validation */
  forceOverrideToken?: InputMaybe<Scalars['String']['input']>;
};

/** Metadata associated with the save address mutation input */
export type SaveAddressInputMetadata = {
  /** Token to override shipping address validation */
  forceOverrideToken?: Maybe<Scalars['String']['output']>;
  /**
   * Whether or not the shipping address representation of the input is able to be used as an override
   * @deprecated Use forceOverrideToken instead. This Boolean will no not have an effect
   */
  isOverridable?: Maybe<Scalars['Boolean']['output']>;
  /** The shipping address representation of the input */
  shipping?: Maybe<ShippingAddress>;
};

/** Metadata associated the input and response of the save address mutation */
export type SaveAddressMetadata = {
  /** The inputted address that was requested to be saved */
  input?: Maybe<SaveAddressInputMetadata>;
};

/** The result of the saveAddress mutation */
export type SaveAddressResult = {
  /** Address errors after saving */
  errors?: Maybe<SaveAddressError>;
  /** Metadata associated the input and response of the save address mutation */
  meta?: Maybe<SaveAddressMetadata>;
  /** The saved shipping address */
  shipping?: Maybe<ShippingAddress>;
  /** The list of shipping address suggestions */
  suggestions?: Maybe<Array<Maybe<ShippingAddress>>>;
};

export type SellOrder = Order & {
  /** If applicable, the chainId of a bid or ask */
  chainId?: Maybe<Scalars['String']['output']>;
  /** The checkout type of a custodial order */
  checkoutType?: Maybe<OrderCheckoutType>;
  /** The datetime stamp for when the order was created */
  created?: Maybe<Scalars['ISODate']['output']>;
  /** The currency of the order */
  currency?: Maybe<OrderCurrency>;
  /** Information about order fraud review */
  fraud?: Maybe<OrderFraud>;
  /** The history of events on the order */
  history?: Maybe<Array<Maybe<OrderEvent>>>;
  /** The ID of an order */
  id?: Maybe<Scalars['String']['output']>;
  /** The item information associated with the order */
  item?: Maybe<OrderItemInformation>;
  /** The reference to the buy or sell order that is currently matched with this order */
  matchedWith?: Maybe<Order>;
  /** The payment information captured at the time of the order */
  payment?: Maybe<OrderPaymentSnapshot>;
  /** The payment method captured at the time of the order */
  paymentMethod?: Maybe<OrderPaymentMethodSnapshot>;
  /** The payout information */
  payout?: Maybe<OrderPaymentSnapshot>;
  /** Information about the initial pricing, estimated pricing and final pricing (both localized and in USD) */
  pricing?: Maybe<OrderPricing>;
  /** The product information associated with the order */
  product?: Maybe<OrderProductInformation>;
  /** Order return details */
  return?: Maybe<OrderReturn>;
  /** The shipping information associated with the order */
  shipping?: Maybe<OrderShipping>;
  /** Where the item is being sourced from */
  source?: Maybe<OrderSource>;
  /** The sourcing method for the item */
  sourceType?: Maybe<OrderSourceType>;
  /** The list of completed and upcoming states for an order */
  states?: Maybe<Array<Maybe<OrderStateItem>>>;
  /** The status of the order */
  status?: Maybe<Scalars['String']['output']>;
  /** The status code of the order */
  statusCode?: Maybe<Scalars['String']['output']>;
  /** Tax and duty processing */
  taxman?: Maybe<TaxmanResult>;
  /** The type of order */
  type?: Maybe<OrderType>;
  /** The datetime stamp for when the order was updated */
  updated?: Maybe<Scalars['ISODate']['output']>;
  /** The user information captured at the time of the order */
  user?: Maybe<UserSnapshot>;
};

/** Representation of the user as a seller */
export type Seller = {
  /** Information about bulk shipping for the seller */
  bulkShipping?: Maybe<BulkShipping>;
  /** Hyperwallet's representation of a seller */
  hyperwallet?: Maybe<Hyperwallet>;
  /** The seller's profile (level, transaction fee, and high level statistics) */
  profile?: Maybe<SellerProfile>;
  /** The rates applied to the seller */
  rates?: Maybe<SellerRates>;
  /** General information and statistics about the seller */
  statistics?: Maybe<SellerStatistics>;
  /** Tax-related information */
  taxes?: Maybe<SellerTaxes>;
  /** The seller's tiers */
  tiers?: Maybe<SellerTiers>;
};

/** Representation of the user as a seller */
export type SellerBulkShippingArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  vertical?: InputMaybe<Vertical>;
};

/** Representation of the user as a seller */
export type SellerHyperwalletArgs = {
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Seller boosters */
export type SellerBoosters = {
  /** Shipping speed information */
  shippingSpeed?: Maybe<ShippingSpeed>;
  /** Success rate information */
  successRate?: Maybe<SuccessRate>;
  /** Success rate Penalty */
  successRatePenalty?: Maybe<SuccessRatePenalty>;
};

/** Seller fees */
export type SellerFee = {
  /** The base seller fee before discounts */
  baseSellerFee?: Maybe<Scalars['Float']['output']>;
  /** The total adjusted seller fee after discounts */
  totalAdjustedSellerFee?: Maybe<Scalars['Float']['output']>;
  /** The total discount offered by boosters */
  totalBoosterDiscount?: Maybe<Scalars['Float']['output']>;
};

/** Seller penalties */
export type SellerPenalties = {
  /** Flake penalty */
  flake?: Maybe<FlakePenalty>;
};

/** The seller's profile (level, transaction fee, and high level statistics) */
export type SellerProfile = {
  /** Aggregate Data from previous months and quarters */
  aggregates?: Maybe<Aggregates>;
  /** Seller boosters */
  boosters?: Maybe<SellerBoosters>;
  /** The number of lifetime sales the seller has fulfilled */
  completedSales?: Maybe<Scalars['Int']['output']>;
  /** The seller's current level */
  currentLevel?: Maybe<Scalars['Int']['output']>;
  /** The date that the salesToRetainCurrentLevel are required by */
  currentLevelSalesRequiredBy?: Maybe<Scalars['ISODate']['output']>;
  /** The number of sales required to retain the current level (i.e. salesCompletedOverTheYear + salesToRetainCurrentLevel) */
  currentLevelSalesThreshold?: Maybe<Scalars['Int']['output']>;
  /** Seller earning period information */
  earningPeriod?: Maybe<EarningPeriod>;
  /** Eligible services the profile may use */
  eligibleServices?: Maybe<Array<Maybe<EligibleServices>>>;
  /** Whether or not the seller is overwritten to their current level */
  levelIsOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** The next level the seller can acheive, if there is one */
  nextLevel?: Maybe<Scalars['Int']['output']>;
  /** The date that the salesToReachNextLevel are required by */
  nextLevelSalesRequiredBy?: Maybe<Scalars['ISODate']['output']>;
  /** The number of sales required to start the next level (i.e. salesCompletedOverTheYear + salesToReachNextLevel) */
  nextLevelSalesThreshold?: Maybe<Scalars['Int']['output']>;
  /** Seller Penalties applied to this seller */
  penalties?: Maybe<SellerPenalties>;
  /** The number of sales the user has made over the last year. Used to determine their seller level. */
  salesCompletedOverTheYear?: Maybe<Scalars['Int']['output']>;
  /**
   * The date that the salesToReachNextLevel are required by
   * @deprecated Use nextLevelSalesRequiredBy.
   */
  salesRequiredBy?: Maybe<Scalars['ISODate']['output']>;
  /** The number of sales required for the seller to reach the next level */
  salesToReachNextLevel?: Maybe<Scalars['Int']['output']>;
  /** The number of sales required for the seller to retain their current level */
  salesToRetainCurrentLevel?: Maybe<Scalars['Int']['output']>;
  /** Seller fee information */
  sellerFee?: Maybe<SellerFee>;
  /** The percent of the sale StockX takes as a commission */
  transactionFee?: Maybe<Scalars['Float']['output']>;
};

export type SellerPromotion = {
  /** The date a the promotion was approved */
  approvedAt?: Maybe<Scalars['ISODate']['output']>;
  /** The UUID of the business user who last approved the promotion */
  approvedBy?: Maybe<Scalars['String']['output']>;
  /** The date a the promotion was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** The UUID of the business user who created the promotion */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The date a the promotion was deleted */
  deletedAt?: Maybe<Scalars['ISODate']['output']>;
  /** The UUID of the business user who last delete the promotion */
  deletedBy?: Maybe<Scalars['String']['output']>;
  /** Details of how and when the promotion is applied */
  details?: Maybe<SellerPromotionDetails>;
  /** Requirements that need to be met to be eligible for the promotion */
  eligibilityRequirements?: Maybe<SellerPromotionEligibilityRequirements>;
  /** The Promotions UUID */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Response when trying to approve a seller promotion */
export type SellerPromotionApprovalResponse = {
  /** Message result from trying to approve a seller promotion */
  message?: Maybe<Scalars['String']['output']>;
  /** Status code returned when trying to approve a seller promotion */
  status?: Maybe<Scalars['Float']['output']>;
};

export type SellerPromotionCreatePayloadInput = {
  /** Details of how and when the promotion is applied */
  details?: InputMaybe<SellerPromotionDetailsInput>;
  /** Requirements that need to be met to be eligible for the promotion */
  eligibilityRequirements?: InputMaybe<SellerPromotionEligibilityRequirementsInput>;
};

/** Response when trying to delete a seller promotion */
export type SellerPromotionDeleteResponse = {
  /** Message result from trying to delete a seller promotion */
  message?: Maybe<Scalars['String']['output']>;
  /** Status code returned when trying to delete a seller promotion */
  status?: Maybe<Scalars['Float']['output']>;
};

/** Details of how and when the promotion is applied */
export type SellerPromotionDetails = {
  /** Date the promotion will become active if approved */
  activatesAt?: Maybe<Scalars['ISODate']['output']>;
  /** Code used by business to identify the promotion */
  code?: Maybe<Scalars['String']['output']>;
  /** Date the promotion will expire */
  expiresAt?: Maybe<Scalars['ISODate']['output']>;
  /** The minimum price a product most cost to be eligible for a promotion */
  minPrice?: Maybe<Scalars['Float']['output']>;
  /** Name used by business to identify the promotion */
  name?: Maybe<Scalars['String']['output']>;
  /** Type and value of the promotion */
  value?: Maybe<SellerPromotionValue>;
};

/** Details of how and when the promotion is applied */
export type SellerPromotionDetailsInput = {
  /** Date the promotion will become active if approved */
  activatesAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** Code used by business to identify the promotion */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Date the promotion will expire */
  expiresAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** The minimum price a product most cost to be eligible for a promotion */
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Name used by business to identify the promotion */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Type and value of the promotion */
  value?: InputMaybe<SellerPromotionValueInput>;
};

/** A customer/sku combination must match 'all' specified requirements to be eligible for the seller promotion */
export type SellerPromotionEligibilityRequirements = {
  /** A list of Alpha2 country codes the promotion applies to */
  countryIso2Codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of customer audiences the promotion applies to */
  customerAudiences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The location of a CSV file with the promotion’s customer UUID requirements */
  customers?: Maybe<CsvUpload>;
  /** The location of a CSV file with the promotion’s customer allow list UUID requirements */
  customersAllowList?: Maybe<CsvUpload>;
  /** The location of a CSV file with the promotion’s customer deny list UUID requirements */
  customersDenyList?: Maybe<CsvUpload>;
  /** The location of a CSV file with the promotion’s product UUID requirements */
  products?: Maybe<CsvUpload>;
  /** The location of a CSV file with the promotion’s sku UUID requirements */
  skus?: Maybe<CsvUpload>;
  /** A list of seller tier UUIDs the promotion applies to */
  tiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of verticals the promotion applies to */
  verticals?: Maybe<Array<Maybe<Vertical>>>;
};

/** A customer/sku combination must match 'all' specified requirements to be eligible for the seller promotion */
export type SellerPromotionEligibilityRequirementsInput = {
  /** A list of Alpha2 country codes the promotion applies to */
  countryIso2Codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of customer audiences the promotion applies to */
  customerAudiences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The location of a CSV file with the promotion’s customer UUID requirements */
  customers?: InputMaybe<CsvUploadInput>;
  /** The location of a CSV file with the promotion’s customer allow list UUID requirements */
  customersAllowList?: InputMaybe<CsvUploadInput>;
  /** The location of a CSV file with the promotion’s customer deny list UUID requirements */
  customersDenyList?: InputMaybe<CsvUploadInput>;
  /** The location of a CSV file with the promotion’s product UUID requirements */
  products?: InputMaybe<CsvUploadInput>;
  /** The location of a CSV file with the promotion’s sku UUID requirements */
  skus?: InputMaybe<CsvUploadInput>;
  /** A list of seller tier UUIDs the promotion applies to */
  tiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of verticals the promotion applies to */
  verticals?: InputMaybe<Array<InputMaybe<Vertical>>>;
};

export type SellerPromotionValue = {
  /** FlatRate | RateDiscount | ReplacementRate */
  type?: Maybe<SellerPromotionValueType>;
  /** The value of the promotion. See PromotionValueType for description of application */
  value?: Maybe<Scalars['Float']['output']>;
};

export type SellerPromotionValueInput = {
  /** FlatRate | RateDiscount | ReplacementRate */
  type?: InputMaybe<SellerPromotionValueType>;
  /** The value of the promotion. See PromotionValueType for description of application */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** types of seller promotions */
export enum SellerPromotionValueType {
  /** A dollar value to be applied as a transaction fee. A value of 5 would translate to a seller fee of $5. */
  FLAT_RATE = 'FLAT_RATE',
  /** A percentage discount to be applied to the base rate. A value of .7 applied to a base rate of 10% would translate to a 3% seller fee. */
  RATE_DISCOUNT = 'RATE_DISCOUNT',
  /** A rate to replace the base rate. .08 would translate to an 8% seller fee */
  REPLACEMENT_RATE = 'REPLACEMENT_RATE',
}

/** Includes rates by vertical, but also shipping rates */
export type SellerRates = {
  /** Rates by vertical */
  byVertical?: Maybe<RatesByVertical>;
  /** Shipping rate charged per country */
  shipping?: Maybe<ShippingRates>;
};

/** Input for RequestSellerShippingExtension mutation */
export type SellerShippingExtensionRequestInput = {
  /** The ID of an ask, which is a chainID */
  chainId?: InputMaybe<Scalars['String']['input']>;
  /** Notes regarding the request */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Payload containing response from RequestSellerShippingExtension mutation */
export type SellerShippingExtensionRequestResult = {
  /** A boolean value indicating if the seller shipping extension was approved */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** The reason for approval/rejection */
  reason?: Maybe<Scalars['String']['output']>;
  /** The date to which the ship by date was extended to */
  shipByDateExtendedTo?: Maybe<Scalars['ISODate']['output']>;
};

export type SellerStatistics = {
  /** Number of authentication failures */
  authenticationFailures?: Maybe<Scalars['Int']['output']>;
  /** Number of current asks a seller has listed */
  currentAsks?: Maybe<Scalars['Int']['output']>;
  /** Number of expired asks */
  expiredAsks?: Maybe<Scalars['Int']['output']>;
  /** Number of items currently en route to our Authentication Centers */
  itemsEnRoute?: Maybe<Scalars['Int']['output']>;
  /** Number of items expiring within a particular timeframe */
  itemsExpiring?: Maybe<Scalars['Int']['output']>;
  /** The total number of items the seller has failed to ship */
  itemsFailedToShip?: Maybe<Scalars['Int']['output']>;
  /** Number of items the seller needs to ship */
  itemsToShip?: Maybe<Scalars['Int']['output']>;
  /** The number of items whose spread is quite small */
  itemsWithMinimalSpread?: Maybe<Scalars['Int']['output']>;
  /** The amount pending for payout */
  pendingPayoutAmount?: Maybe<Scalars['Float']['output']>;
  /** The percentage of all items canceled */
  percentageOfAllItemsCanceled?: Maybe<Scalars['Float']['output']>;
  /** The percentage of current asks that are the lowest price of any ask for that item */
  percentageOfAsksThatAreLowestPrice?: Maybe<Scalars['Float']['output']>;
  /** The percentage of items in a particular state */
  percentageOfItems?: Maybe<Scalars['Float']['output']>;
  /** The percentage of items that have shipped within a particular timeframe */
  percentageOfItemsShipped?: Maybe<Scalars['Float']['output']>;
  /** The sum of all current asks */
  sumOfCurrentAsksAmounts?: Maybe<Scalars['Float']['output']>;
  /** Total number of sales */
  totalNumberOfSales?: Maybe<Scalars['Int']['output']>;
  /** Total amount the seller has sold */
  totalSalesAmount?: Maybe<Scalars['Float']['output']>;
};

export type SellerStatisticsItemsExpiringArgs = {
  filter?: InputMaybe<ItemsExpiringFilter>;
};

export type SellerStatisticsPercentageOfItemsArgs = {
  filter?: InputMaybe<PercentageOfItemsFilter>;
};

export type SellerStatisticsPercentageOfItemsShippedArgs = {
  filter?: InputMaybe<PercentageOfItemsShippedFilter>;
};

/** Tax-related information about a seller */
export type SellerTaxes = {
  /** Whether value added tax is required */
  requiresVAT?: Maybe<Scalars['Boolean']['output']>;
};

/** Seller tiers */
export type SellerTiers = {
  /** Tier by vertical */
  byVertical?: Maybe<TiersByVertical>;
};

export type SellingGuidance = {
  /** Price Needed to be the lowest Ask in your local market */
  earnMore?: Maybe<Scalars['BigInt']['output']>;
  /** Price needed to be the lowest Ask to more buyers */
  sellFaster?: Maybe<Scalars['BigInt']['output']>;
};

export type Shipment = {
  /** Action of the combined shipment */
  action?: Maybe<Scalars['String']['output']>;
  /** Whether the combined shipment is active (only applies to combined shipments) */
  active?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Only relevant to bulk shipments, averageCostPerItem represents the cost of each
   * item in a bulk shipment; otherwise, it's equal to the shipment's totalCost
   */
  averageCostPerItem?: Maybe<Scalars['Float']['output']>;
  /** Whether the shipment is a bulk shipment */
  bulk?: Maybe<Scalars['Boolean']['output']>;
  /** Carrier code for shipment provider */
  carrierCode?: Maybe<Scalars['String']['output']>;
  /** ChainID of the shipment */
  chainId?: Maybe<Scalars['String']['output']>;
  /** Whether the combined shipment is closed (only applies to combined shipments) */
  closed?: Maybe<Scalars['Boolean']['output']>;
  /** Url to the shipment form */
  commercialInvoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the shipment is complete or not */
  complete?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the shipment was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Has the shipment been deleted? */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the shipment was delivered */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** Description of the shipment */
  description?: Maybe<Scalars['String']['output']>;
  /** Id of destination address */
  destinationAddressId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the authentication center receiving this item */
  destinationAuthCenter?: Maybe<Scalars['String']['output']>;
  /** Display ID of a shipment */
  displayId?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated. Use commercialInvoiceUrl instead
   * @deprecated Use commercialInvoiceUrl instead.
   */
  formUrl?: Maybe<Scalars['String']['output']>;
  /** Shipment ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Array of items (products) contained in a shipment */
  items?: Maybe<Array<Maybe<ShipmentItem>>>;
  /** Info of the shipment request */
  message?: Maybe<MessageItem>;
  /** Metadata (Additional info) associated with the shipment */
  metadata?: Maybe<ShipmentAdditionalMetadata>;
  /** Number of children for each combined shipment */
  numberOfChildren?: Maybe<Scalars['Int']['output']>;
  /** Id of origin address */
  originAddressId?: Maybe<Scalars['Int']['output']>;
  /** Overridden origin address */
  overrideAddressId?: Maybe<Scalars['Int']['output']>;
  /** Is shipment paperless? (no need for printing) */
  paperless?: Maybe<Scalars['Boolean']['output']>;
  /** Path for a given item's type, address, and price */
  path?: Maybe<Scalars['String']['output']>;
  /** Proof of delivery / statement of final status for the shipment */
  proofOfDeliveryUrl?: Maybe<Scalars['String']['output']>;
  /** Cost and carrier info for each shipment item */
  rates?: Maybe<Array<Maybe<RateItem>>>;
  /** Url of the shipment receipt */
  receiptUrl?: Maybe<Scalars['String']['output']>;
  /** URL directly to where label is stored */
  renderedLabelUrl?: Maybe<Scalars['String']['output']>;
  /** Date that shipment should be shipped by */
  shipByDate?: Maybe<Scalars['String']['output']>;
  /** Url of the shipping label */
  shippingLabelUrl?: Maybe<Scalars['String']['output']>;
  /** Uuid of the SKU item */
  skuUuid?: Maybe<Scalars['String']['output']>;
  /** The origin and the destination of the combined shipment */
  slug?: Maybe<Scalars['String']['output']>;
  /** Shipment status */
  status?: Maybe<Scalars['String']['output']>;
  /** Total cost of shipment */
  totalCost?: Maybe<Scalars['String']['output']>;
  /** Shipment tracking number */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** The URL of the carrier's tracking web page. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
  /** Date when the shipment was updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Uuid of the user who the shipment belongs to */
  userUuid?: Maybe<Scalars['String']['output']>;
  /** Uuid of the shipment */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ShipmentItemsArgs = {
  combination?: InputMaybe<ShipmentCombinationInput>;
};

export type ShipmentAdditionalMetadata = {
  /** International Commercial Terms (incoterm) - a universal representation to define the transaction between the exporter and the importer */
  incoterm?: Maybe<Scalars['String']['output']>;
  /** Reservation Code associated with a Yamato Shipment */
  reservationCode?: Maybe<Scalars['String']['output']>;
  /** Reservation Number associated with a Yamato Shipment */
  reservationNumber?: Maybe<Scalars['String']['output']>;
  /** Trading ID associated with a Yamato Shipment */
  tradingId?: Maybe<Scalars['String']['output']>;
  /** Vendor Reference ID */
  vendorReferenceId?: Maybe<Scalars['String']['output']>;
};

/** Shipment address */
export type ShipmentAddressInput = {
  /** Shipment country code */
  countryCodeAlpha2?: InputMaybe<Scalars['String']['input']>;
  /** Shipment extended address */
  extendedAddress?: InputMaybe<Scalars['String']['input']>;
  /** Shipment first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Shipment last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Shipment locality */
  locality?: InputMaybe<Scalars['String']['input']>;
  /** Market the shipment belongs to */
  market?: InputMaybe<Scalars['String']['input']>;
  /** Shipment middlename */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Postal code the address */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Shipment region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Shipment street address */
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  /** Telephone of the address */
  telephone?: InputMaybe<Scalars['String']['input']>;
};

/** Combination shipment arguments */
export type ShipmentCombinationInput = {
  filters?: InputMaybe<CombinationFilterInput>;
  order?: InputMaybe<CombinationOrderInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<CombinationSortInput>;
};

/** Order addresses data is related to the shipment customer personal details, this is not related to Customer type directly */
export type ShipmentCustomerDetails = {
  /** Customers email Order shipment addresses */
  email?: Maybe<Scalars['String']['output']>;
  /** Customers first name Order shipment addresses */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Customers last Name from Order shipment addresses */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Customers magentoId from grails db */
  magentoId?: Maybe<Scalars['Int']['output']>;
  /** Customers telephone Order shipment addresses */
  telephone?: Maybe<Scalars['String']['output']>;
};

export type ShipmentItem = {
  /** Shipment item chain ID */
  chainId: Scalars['String']['output'];
  /** Date when the shipment item was created at */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Has the shipment item been deleted */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the shipment item */
  id?: Maybe<Scalars['Int']['output']>;
  /** PortfolioItem for a ShipmentItem */
  portfolioItem?: Maybe<PortfolioItem>;
  /** Returns the specific variant (size) of a product, also known as SKU */
  productVariant?: Maybe<Variant>;
  /** ID of the shipment */
  shipmentId?: Maybe<Scalars['Int']['output']>;
  /** Uuid of the shipment */
  shipmentUuid?: Maybe<Scalars['String']['output']>;
  /** Uuid of the shipment item (product) */
  skuUuid: Scalars['String']['output'];
  /** Shipment tracking number */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** Date when shipment item was updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ShipmentItemInput = {
  /** portfolioItem chainId */
  chainId: Scalars['String']['input'];
  /** portfolioItem sku */
  sku: Scalars['String']['input'];
};

/** Shipment data for the IPO processing tool */
export type ShipmentLabel = {
  /** Customer details */
  customer?: Maybe<ShipmentCustomerDetails>;
  /** Shipment label order data */
  label?: Maybe<OrderLabel>;
};

/** Shipment input ordering */
export enum ShipmentOrderInput {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** Shipment Sort order */
export enum ShipmentSortInput {
  CREATEDAT = 'createdAt',
  ID = 'id',
}

export type ShipmentsConnection = {
  /** Array of shipment nodes on the graph */
  edges?: Maybe<Array<Maybe<ShipmentsEdge>>>;
  /** Info about the page results (pagination) */
  pageInfo?: Maybe<ShipmentsPageInfo>;
};

export type ShipmentsEdge = {
  /** Represents a single shipment node on the graph */
  node?: Maybe<Shipment>;
};

export type ShipmentsPageInfo = {
  /** A cursor marking the end of the current page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Has next paginated page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a previous page exists */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** Page size of shipment results */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Page order of shipment results */
  order?: Maybe<Scalars['String']['output']>;
  /** Page number of shipment results */
  page?: Maybe<Scalars['Int']['output']>;
  /** Page sort of shipment results */
  sort?: Maybe<Scalars['String']['output']>;
  /** A cursor marking start of the current page */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of items available */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Shipping information about a product */
export type Shipping = {
  /** Additional days above the baseline to give sellers to ship to us */
  additionalDaysToShip?: Maybe<Scalars['Int']['output']>;
  /** The lowest amount of days it can be delivered to us */
  deliveryDaysLowerBound?: Maybe<Scalars['Int']['output']>;
  /** The highest amount of days it can be delivered to use in */
  deliveryDaysUpperBound?: Maybe<Scalars['Int']['output']>;
  /** Flag to indicate if it has additional days to ship to us */
  hasAdditionalDaysToShip?: Maybe<Scalars['Boolean']['output']>;
  /** Total days to ship to us */
  totalDaysToShip?: Maybe<Scalars['Int']['output']>;
  /** Shipping code */
  usHtsCode?: Maybe<Scalars['String']['output']>;
  /** Shipping description */
  usHtsDescription?: Maybe<Scalars['String']['output']>;
};

/** The saved shipping address on file */
export type ShippingAddress = {
  /** The dynamic address originally saved by the user */
  address?: Maybe<DynamicAddress>;
  /** A JWT encoding the address data */
  addressToken?: Maybe<Scalars['String']['output']>;
  /** The normalized address using the raw input saved by the user */
  formatted?: Maybe<FormattedShippingAddress>;
};

/** Countries that StockX ships to and from */
export enum ShippingCountryCode {
  US = 'US',
}

/** Commute details for shipping */
export type ShippingDetailsInput = {
  /** The address of the seller origin */
  sellerOrigin?: InputMaybe<ShipmentAddressInput>;
  /** The address from where the product will be shipped */
  shipFrom?: InputMaybe<ShipmentAddressInput>;
};

/** The total cost and cost per item of a yet to be created shipment */
export type ShippingRateScale = {
  /** cost per item shipped */
  costPerItem?: Maybe<Scalars['Float']['output']>;
  /** Number of items */
  numberOfItems?: Maybe<Scalars['Int']['output']>;
  /** total cost of shipping */
  totalCost?: Maybe<Scalars['Float']['output']>;
};

/** Shipping rates */
export type ShippingRates = {
  /** Rate to country */
  country?: Maybe<Scalars['String']['output']>;
  /** Scale per country */
  scalePerCountry?: Maybe<Array<ShippingRateScale>>;
};

/** Shipping rates */
export type ShippingRatesScalePerCountryArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyCode>;
  productType?: InputMaybe<Scalars['String']['input']>;
};

/** Shipping speed booster */
export type ShippingSpeed = {
  /** Current success rate */
  currentSuccessRate?: Maybe<Scalars['Float']['output']>;
  /** Days left in earning period */
  daysLeftInEarningPeriod?: Maybe<Scalars['Int']['output']>;
  /** Number of orders not shipped within booster timeframe */
  failedOrders?: Maybe<Scalars['Int']['output']>;
  /** Is user on track to meet ship speed success rate */
  isOnTrack?: Maybe<Scalars['Boolean']['output']>;
  /** Seller fee adjustment rate if booster is active */
  rateAdjustment?: Maybe<Scalars['Float']['output']>;
  /** Number of orders shipped within booster timeframe */
  successfulOrders?: Maybe<Scalars['Int']['output']>;
  /** Timeframe to ship for which a shipment can be considered a success for ShipSpeed booster */
  targetHoursToShip?: Maybe<Scalars['Int']['output']>;
  /** Target success rate */
  targetSuccessRate?: Maybe<Scalars['Float']['output']>;
  /** Total number of orders */
  totalOrders?: Maybe<Scalars['Int']['output']>;
};

/** Contains signed HTTP PUT and GET urls for direct image uploading to S3 and future retrieval. */
export type SignedImageUrLs = {
  /** A signed url that can be used to retrieve the image. */
  signedGetURL?: Maybe<Scalars['String']['output']>;
  /** A signed url that can be used to upload the image directly to. */
  signedPutURL?: Maybe<Scalars['String']['output']>;
};

/** Sizing information for a specific variant */
export type SizeChart = {
  /** The base size */
  baseSize?: Maybe<Scalars['String']['output']>;
  /** The base size type */
  baseType?: Maybe<Scalars['String']['output']>;
  /** The different display options */
  displayOptions?: Maybe<Array<Maybe<SizeDisplayOption>>>;
};

/** Size types available on a product */
export type SizeConversion = {
  /** The display name */
  name?: Maybe<Scalars['String']['output']>;
  /** The associated size type */
  type?: Maybe<Scalars['String']['output']>;
};

/** Size display option for a specific variant */
export type SizeDisplayOption = {
  /** The display size */
  size?: Maybe<Scalars['String']['output']>;
  /** The associated size type */
  type?: Maybe<Scalars['String']['output']>;
};

/** Information about a specific sku of a product */
export type Sku = {
  /** Is this sku hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Id of this sku */
  id: Scalars['String']['output'];
  /** Uuid of this product */
  productUuid?: Maybe<Scalars['String']['output']>;
  /** Size of this sku */
  size: Scalars['String']['output'];
  /** Ordering of sizes (XS=0, S=1, M=2, ...) */
  sizeSortOrder?: Maybe<Scalars['Int']['output']>;
  /** UUID for the variant of this product */
  sku?: Maybe<Scalars['String']['output']>;
  /** Type of the object */
  type?: Maybe<Scalars['String']['output']>;
  /** Universal Product Codes for this variant */
  upcs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Slug filter definition */
export type SlugFilterInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

export type SmsLinkingCode = {
  /** SMS Linking Code */
  code?: Maybe<Scalars['String']['output']>;
  /** Date and time when the code was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** Date and time when the code expires */
  expiresAt?: Maybe<Scalars['ISODate']['output']>;
  /** User ID that the code links to */
  user?: Maybe<User>;
};

export type SmsProfile = {
  /** Customer's consent to SMS notifications */
  consentTypes?: Maybe<ConsentType>;
  /** Customer's country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Customer's phone number */
  phone?: Maybe<Scalars['String']['output']>;
};

export type SmsProfileInput = {
  /** Customer's consent to SMS notifications */
  consentTypes?: InputMaybe<ConsentTypeInput>;
  /** Customer's country code */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Customer's phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Send Marketing Consent SMS Message */
  sendMarketingConsentMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartMerchantInitiatedTransactionSessionInput = {
  /** Action to differentiate between bid and buy_now */
  action?: InputMaybe<ChargeAction>;
  /** amount */
  amount?: InputMaybe<AmountInput>;
  /** countryCode */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Add payment instrument to support non vaulted payment methods */
  instrument?: InputMaybe<PaymentInstrumentInput>;
  /** Payment Account Id */
  paymentAccountId?: InputMaybe<Scalars['String']['input']>;
  /** pricing */
  pricing?: InputMaybe<PricingInput>;
  /** Product Variants */
  productVariants?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** 3DS info */
  threeDSMetadata?: InputMaybe<ThreeDsClientInfoInput>;
};

/** Start Two Step Checkout Input */
export type StartTwoStepCheckoutInput = {
  /** amount */
  amount?: InputMaybe<AmountInput>;
  /** callbackURL */
  callbackURL?: InputMaybe<Scalars['String']['input']>;
  /** country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** deviceData */
  deviceData?: InputMaybe<Scalars['String']['input']>;
  /** instrument */
  instrument?: InputMaybe<PaymentInstrumentInput>;
  /** localized size type */
  localizedSizeType?: InputMaybe<Scalars['String']['input']>;
  /** pricing */
  pricing?: InputMaybe<PricingInput>;
  /** Product Variants */
  productVariants?: InputMaybe<Array<Scalars['String']['input']>>;
  /** unique identifier for payment */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** Start vaulting session Input */
export type StartVaultingSessionInput = {
  /** countryCode */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** currencyCode */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** The name of the payment instrument */
  instrumentKey?: InputMaybe<Scalars['String']['input']>;
  /** The name of the underlying payment service provider */
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

/** Started Two Step Checkout */
export type StartedTwoStepCheckout = {
  /** action */
  action?: Maybe<CheckoutAction>;
  /** callbackURL */
  callbackURL?: Maybe<Scalars['String']['output']>;
  /** PSPs unique identifier for payment */
  providerPaymentId?: Maybe<Scalars['String']['output']>;
  /** subunit adjusted amount */
  subunitAdjustedAmount?: Maybe<Amount>;
  /** unique identifier for payment */
  transactionId?: Maybe<Scalars['String']['output']>;
};

/** String equality filter */
export type StringEqualsFilterInput = {
  /** Only items which match the given equality filter will be returned */
  eq?: InputMaybe<Scalars['String']['input']>;
};

/** A feature flag with a string value */
export type StringFeatureFlag = FeatureFlag & {
  /** A key that identifies this feature flag */
  key?: Maybe<Scalars['String']['output']>;
  /** The string value of this feature flag */
  stringValue?: Maybe<Scalars['String']['output']>;
};

/** String "in" filter */
export type StringInListFilterInput = {
  /** List of strings to filter on */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionNotificationPayloadInput = {
  /** Key of the subscription */
  notificationKey?: InputMaybe<Scalars['String']['input']>;
  /** UUID that identifies the customer */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Successful order rate booster */
export type SuccessRate = {
  /** Current success rate */
  currentSuccessRate?: Maybe<Scalars['Float']['output']>;
  /** Days left in earning period */
  daysLeftInEarningPeriod?: Maybe<Scalars['Int']['output']>;
  /** Number of failed orrders */
  failedOrders?: Maybe<Scalars['Int']['output']>;
  /** Is user on track to meet success rate */
  isOnTrack?: Maybe<Scalars['Boolean']['output']>;
  /** Seller fee adjustment rate if booster is active */
  rateAdjustment?: Maybe<Scalars['Float']['output']>;
  /** Number of successful orders */
  successfulOrders?: Maybe<Scalars['Int']['output']>;
  /** Target success rate */
  targetSuccessRate?: Maybe<Scalars['Float']['output']>;
  /** Total number of orders */
  totalOrders?: Maybe<Scalars['Int']['output']>;
};

/** Successful order rate penalty */
export type SuccessRatePenalty = {
  /** Current success rate */
  currentSuccessRate?: Maybe<Scalars['Float']['output']>;
  /** Days left in earning period */
  daysLeftInEarningPeriod?: Maybe<Scalars['Int']['output']>;
  /** Number of failed orrders */
  failedOrders?: Maybe<Scalars['Int']['output']>;
  /** Is user on track to meet success rate */
  isOnTrack?: Maybe<Scalars['Boolean']['output']>;
  /** Penalty applied to this booster */
  penalty?: Maybe<FlakePenalty>;
  /** Seller fee adjustment rate if booster is active */
  rateAdjustment?: Maybe<Scalars['Float']['output']>;
  /** Number of successful orders */
  successfulOrders?: Maybe<Scalars['Int']['output']>;
  /** Target success rate */
  targetSuccessRate?: Maybe<Scalars['Float']['output']>;
  /** Total number of orders */
  totalOrders?: Maybe<Scalars['Int']['output']>;
};

/** Taxman locality provided for taxman query */
export type TaxAddressInput = {
  /** Locality City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Locality Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Locality Line Two */
  extendedAddress?: InputMaybe<Scalars['String']['input']>;
  /** Locality Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** Locality Postal Code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Locality Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Locality Line One */
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Information used by Avalara */
export type TaxInformation = {
  /** Additional description for Avalara */
  additionalDescription?: Maybe<Scalars['String']['output']>;
  /** Avalara code */
  code?: Maybe<Scalars['String']['output']>;
  /** Avalara description */
  description?: Maybe<Scalars['String']['output']>;
  /** Avalara id */
  id?: Maybe<Scalars['String']['output']>;
};

/** Tax based data */
export type Taxes = {
  /** EU identification number for 'value-added tax' purposes. */
  euVAT?: Maybe<Euvat>;
};

/** Tax and duty processing */
export type TaxmanResult = {
  /** Taxman transaction identifier */
  transactionUUID?: Maybe<Scalars['String']['output']>;
  /** Flag for tax committed status */
  wasTaxCommitted?: Maybe<Scalars['Boolean']['output']>;
  /** Flag for tax refunded status */
  wasTaxRefunded?: Maybe<Scalars['Boolean']['output']>;
};

/** Response when trying to approve a temporary seller fee */
export type TemporarySellerFeeApprovalResponse = {
  /** Message result from trying to approve a temporary seller fee */
  message?: Maybe<Scalars['String']['output']>;
};

/** 3Domain Security */
export type ThreeDs = {
  /** Provider token used for a nonce */
  providerToken?: Maybe<Scalars['String']['output']>;
  /** Whether the user is in a country where 3DS2 is required */
  required?: Maybe<Scalars['Boolean']['output']>;
};

/** 3Domain Security */
export type ThreeDsRequiredArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};

/** Supported 3DS auth status for Money Session */
export enum ThreeDsAuthStatus {
  AUTHENTICATED = 'AUTHENTICATED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  INPROGRESS = 'INPROGRESS',
}

export type ThreeDsAuthentication = {
  /** result of threeDS Authentication Status from PSP */
  threeDSAuthStatus?: Maybe<ThreeDsAuthStatus>;
};

export type ThreeDsEligibilityInput = {
  /** Billing Address */
  billingAddress?: InputMaybe<AddressInput>;
  /** Device data of FE client */
  deviceData?: InputMaybe<Scalars['String']['input']>;
  /** money session id */
  moneySessionId?: InputMaybe<Scalars['String']['input']>;
  /** payment provider name - supported PSP names */
  provider?: InputMaybe<PaymentServiceProvider>;
  /** 3DS eligibility meta data */
  threeDSMetadata?: InputMaybe<ThreeDsClientInfoInput>;
  /** Provider tokens */
  tokens?: InputMaybe<Array<InputMaybe<ProviderTokensInput>>>;
};

export type ThreeDsEligibilityResult = {
  /** 3DS eligibility response */
  threeDSMetadata?: Maybe<ThreeDsAction>;
};

/** Details to perform 3DS  */
export type ThreeDsAction = {
  /** Details to perform 3DS action */
  action?: Maybe<Scalars['String']['output']>;
  /** 3DS performance eligibility check */
  isThreeDSEligible?: Maybe<Scalars['Boolean']['output']>;
};

/** Maping ClientBrowserInfoInput to ThreeDsClientInfoInput */
export type ThreeDsClientInfoInput = {
  /** information about client screen */
  browserInfo?: InputMaybe<ClientBrowserInfoInput>;
  /** URL of page where 3DS component is loaded */
  originUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect in case of 3DS redirect flow */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** sdk version of PSP used by mobile app */
  sdkVersion?: InputMaybe<Scalars['String']['input']>;
  /** Shopper's IP address */
  shopperIP?: InputMaybe<Scalars['String']['input']>;
};

export type ThreeDsSessionAuthorization = {
  /** result of threeDS Authorization Status from PSP */
  threeDsIsAuthorized?: Maybe<Scalars['Boolean']['output']>;
};

/** All the information for a single item in the ticker section of the site */
export type Ticker = {
  /** Url of the brand image */
  brandImageUrl?: Maybe<Scalars['String']['output']>;
  /** Value of change */
  changeValue?: Maybe<Scalars['Float']['output']>;
  /** Last sale price */
  lastSale?: Maybe<Scalars['Float']['output']>;
  /** Symbol of the product */
  symbol?: Maybe<Scalars['String']['output']>;
  /** Key for this product for the url path */
  urlKey?: Maybe<Scalars['String']['output']>;
  /** Uuid of the product */
  uuid?: Maybe<Scalars['String']['output']>;
};

/** The seller's rate per vertical */
export type TiersByVertical = {
  /** Shipping tier for collectibles */
  collectibles?: Maybe<Scalars['Int']['output']>;
  /** Shipping tier for handbags */
  handbags?: Maybe<Scalars['Int']['output']>;
  /** Shipping tier for sneakers */
  sneakers?: Maybe<Scalars['Int']['output']>;
  /** Shipping tier for streetwear */
  streetwear?: Maybe<Scalars['Int']['output']>;
  /** Shipping tier for watches */
  watches?: Maybe<Scalars['Int']['output']>;
};

/** Tile */
export type Tile = {
  /** The tile's unique ID. */
  id?: Maybe<Scalars['String']['output']>;
  /** The tile's image. */
  image?: Maybe<ImageInformation>;
  /** The tile's link. */
  link?: Maybe<LinkInformation>;
  /** The tracking event that should be logged in our clickstream events. */
  trackingEvent?: Maybe<Scalars['String']['output']>;
};

/** Tile Collection */
export type TileCollection = {
  /** The tiles in the collection */
  tiles?: Maybe<Array<Maybe<Tile>>>;
  /** The title of the collection */
  title?: Maybe<Scalars['String']['output']>;
};

/** Certain fields are constrained by time */
export enum TimeConstraint {
  TWENTY_FOUR_HOURS = 'TWENTY_FOUR_HOURS',
}

/** Tracking number filter definition */
export type TrackingNumberFilterInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** Trading context (buy, buying, sell, selling) */
export type TradeContextInput = {
  is?: InputMaybe<Scalars['String']['input']>;
};

/** Describes the context for the trade policy block reason */
export enum TradePolicyContext {
  /** Shows blocking reason for buyer */
  BUYING = 'BUYING',
  /** Shows blocking reason for seller */
  SELLING = 'SELLING',
}

/** An indicator of what information is stored in a trait */
export enum TraitType {
  /** Band of the watch */
  BAND = 'BAND',
  /** Base model of the product */
  BASE_MODEL = 'BASE_MODEL',
  /** Variety of the base model */
  BASE_MODEL_VARIETY = 'BASE_MODEL_VARIETY',
  /** Material of the case of the product */
  CASE_MATERIAL = 'CASE_MATERIAL',
  /** Size of the case of the product */
  CASE_SIZE = 'CASE_SIZE',
  CIRCA = 'CIRCA',
  /** Color of the product */
  COLOR = 'COLOR',
  /** Color way of the product */
  COLORWAY = 'COLORWAY',
  /** Generic color of a product */
  COLOR_GENERIC = 'COLOR_GENERIC',
  /** Dial of the product */
  DIAL = 'DIAL',
  /** Dimensions of the product */
  DIMENSIONS = 'DIMENSIONS',
  /** Product featured */
  FEATURED = 'FEATURED',
  /** Gender of the product */
  GENDER = 'GENDER',
  /** Length of the handle drop */
  HANDLE_DROP = 'HANDLE_DROP',
  /** Does the product contain hardware */
  HARDWARE = 'HARDWARE',
  /** Product height */
  HEIGHT = 'HEIGHT',
  /** Interior product color */
  INTERIOR_COLOR = 'INTERIOR_COLOR',
  /** What material the product is made of */
  MATERIAL = 'MATERIAL',
  /** Movement of the product */
  MOVEMENT = 'MOVEMENT',
  /** Description of the pattern on the product */
  PATTERN = 'PATTERN',
  /** Variant of the pattern of the product */
  PATTERN_VARIANT = 'PATTERN_VARIANT',
  /** Product reference number */
  REFERENCE_NUMBER = 'REFERENCE_NUMBER',
  /** Release date of the product. Note that it can be a YYYY-MM-DD date ('2018-09-20') or just a YYYY year ('2018') */
  RELEASE_DATE = 'RELEASE_DATE',
  /** Retail price of the product */
  RETAIL_PRICE = 'RETAIL_PRICE',
  /** Product score */
  SCORE = 'SCORE',
  /** Season of release */
  SEASON = 'SEASON',
  /** Number of the product in a set */
  SET_NUMBER = 'SET_NUMBER',
  /** Size of the product */
  SIZE = 'SIZE',
  /** Dimensions of the strap drop */
  STRAP_DROP = 'STRAP_DROP',
  /** Product style */
  STYLE = 'STYLE',
  /** Product tags */
  TAGS = 'TAGS',
  /** Width of the product */
  WIDTH = 'WIDTH',
  /** Year the product was released */
  YEAR = 'YEAR',
}

/** Information about the traits of a product */
export type Traits = {
  /** Flag to indicate if the trait can be filtered on */
  filterable?: Maybe<Scalars['Boolean']['output']>;
  /** The format to display the value as. */
  format?: Maybe<Scalars['String']['output']>;
  /** Is this product highlighted */
  highlight?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the trait */
  name: Scalars['String']['output'];
  /**
   * Type of the trait, essentially an enum version of name
   * @deprecated 'TraitTypes' are user generated so an enum is unmaintainable. Use 'name' instead.
   */
  type?: Maybe<TraitType>;
  /** Value of the trait */
  value?: Maybe<Scalars['String']['output']>;
  /** Indicates if the trait is visible or not */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Is this a bid or an ask */
export enum TransactionType {
  /** Ask */
  ASK = 'ASK',
  /** Bid */
  BID = 'BID',
}

export type UndeliverableLocation = {
  /** Country Code from where we are blocking deliveries from */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Origin country from where the shipment product was made */
  countryOfManufacture?: Maybe<Scalars['String']['output']>;
  /** Primary key for undeliverable location table */
  id?: Maybe<Scalars['Int']['output']>;
  /** Flag to soft delete an undeliverable location or not */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Zip/Postal code of where we could block shipments */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Vertical of Product in the shipment */
  productCategory?: Maybe<Vertical>;
  /** Region code (i.e. State or Province) of where we could block shipments */
  regionCode?: Maybe<Scalars['String']['output']>;
  /** More detailed categorization of product (i.e. Nike, Adidas, Yeezy, Air Jordan, etc) */
  secondaryCategory?: Maybe<Scalars['String']['output']>;
};

/** Data for unfollowProducts mutation */
export type UnfollowProductsDataInput = {
  /** Portfolio Item chainId */
  chainId?: InputMaybe<Scalars['String']['input']>;
  /** Portfolio Item notes */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Input for unfollowProducts mutation */
export type UnfollowProductsInput = {
  /** List of params */
  items?: InputMaybe<Array<InputMaybe<UnfollowProductsDataInput>>>;
};

/** Portfolio item response */
export type UnfollowResponse = {
  /** PortfolioItem response object */
  unfollowedItem?: Maybe<Variant>;
};

/** The object batch listing that contains the listing details */
export type UpdateBatchListing = {
  /** Single item batch result associated with update the listing */
  listing?: Maybe<UpdateListingBatchItemDetails>;
};

/** Actions that correspond to the Portfolio item actions in Grails. */
export enum UpdateLabelAction {
  ASK_PRINT_LABEL = 'ASK_PRINT_LABEL',
  ASK_REVERT_FOR_SHIPPING_LABEL = 'ASK_REVERT_FOR_SHIPPING_LABEL',
}

/** List action options */
export enum UpdateListAction {
  ADD = 'ADD',
  DELETE = 'DELETE',
}

/** List action status options */
export enum UpdateListActionResult {
  /** The update failed for all items. */
  FAILURE = 'FAILURE',
  /** The update did not complete successfully for all items. */
  PARTIAL = 'PARTIAL',
  /** The update was successfully processed and all items were updated. */
  SUCCESS = 'SUCCESS',
}

export type UpdateListChangesInput = {
  /** The desired name for the list. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The desired state for whether or not the list has notifications enabled. */
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  /** The desired state for whether or not the list should be able to be viewed by others. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateListInput = {
  /** The desired changes for the list.. */
  changes?: InputMaybe<UpdateListChangesInput>;
  /** The unique id of the list to update. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** List item status options */
export enum UpdateListItemResult {
  /** The update failed for the item. */
  ERROR = 'ERROR',
  /** The update did not complete successfully. */
  PARTIAL = 'PARTIAL',
  /** The update was successfully processed and the item was updated. */
  UPDATED = 'UPDATED',
}

/** Input for updating items from a list */
export type UpdateListItemsInput = {
  /** Action type */
  action?: InputMaybe<UpdateListAction>;
  /** List items data to be updated */
  items?: InputMaybe<Array<InputMaybe<ListItemsInput>>>;
};

/** The response for all items added in a list */
export type UpdateListItemsResult = {
  /** Items response object */
  items?: Maybe<Array<Maybe<ListItemsResult>>>;
  /** The status of the action */
  status?: Maybe<UpdateListActionResult>;
};

export type UpdateListResult = {
  /** The list that was updated. */
  list?: Maybe<List>;
};

/** Base on current knowledge, each listing is equivalent to an ask, so we use ask to describe below to have a better understanding */
export type UpdateListingBatchInput = {
  /** Flag used to indicate that the listing should be active or not */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ask price that will be listed on StockX.com */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** The currency that the given amount refers to */
  currency?: InputMaybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expiresAt?: InputMaybe<Scalars['ISODate']['input']>;
  /** The id of a listing, customer get this when create the listing */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Item returned for getUpdateListingBatchItems API */
export type UpdateListingBatchItem = {
  /** Error thrown when validating the provided input */
  error?: Maybe<Scalars['String']['output']>;
  /** The id of a given task */
  id?: Maybe<Scalars['ID']['output']>;
  /** The object containing the batch listing */
  result?: Maybe<UpdateBatchListing>;
  /** The status of a given batch */
  status?: Maybe<UpdateListingBatchTaskStatus>;
};

/** The object for UpdateListingBatchItem that contains the listing */
export type UpdateListingBatchItemDetails = {
  /** The ask price that will be listed on StockX.com */
  amount?: Maybe<Scalars['String']['output']>;
  /** The id of the ask within listing */
  ask?: Maybe<Ask>;
  /** The currency that the given amount refers to */
  currency?: Maybe<CurrencyCode>;
  /** The date on which this ask should expire */
  expires?: Maybe<Scalars['ISODate']['output']>;
  /** The id of the listing */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Payload containing the result of the getUpdateListingBatchItems query */
export type UpdateListingBatchItemsPayload = {
  /** An array of items associated with the batch request */
  items?: Maybe<Array<Maybe<UpdateListingBatchItem>>>;
};

/** Payload containing the result of the updateListingBatch mutation and getUpdateListingBatch query */
export type UpdateListingBatchPayload = {
  /** When the batch completed processing */
  completedAt?: Maybe<Scalars['ISODate']['output']>;
  /** When the batch was created */
  createdAt?: Maybe<Scalars['ISODate']['output']>;
  /** The id of a given batch */
  id?: Maybe<Scalars['ID']['output']>;
  /** The status of the given gatch */
  status?: Maybe<UpdateListingBatchStatus>;
  /** When the batch was last updated */
  updatedAt?: Maybe<Scalars['ISODate']['output']>;
};

/** The status that a batch */
export enum UpdateListingBatchStatus {
  /** All items are processed, no matter single item successful or failed */
  COMPLETED = 'COMPLETED',
  /** Item has been created */
  CREATED = 'CREATED',
  /** Batch has failed during creation */
  CREATION_FAILED = 'CREATION_FAILED',
  /** Something failed during processing */
  FAILED = 'FAILED',
  /** Item tasks are still processing */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Item has been placed on the queue */
  QUEUED = 'QUEUED',
}

/** The status that a batch or one of its corresponding tasks can be in */
export enum UpdateListingBatchTaskStatus {
  /** Processing was completed */
  COMPLETED = 'COMPLETED',
  /** Something failed during processing */
  FAILED = 'FAILED',
  /** Item is consumed and is currently in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Item has been placed on the queue */
  QUEUED = 'QUEUED',
}

/** The payload containing the updated message */
export type UpdateReadStatusPayload = {
  /** A list of one or more messages that failed to be updated */
  failed?: Maybe<Array<Maybe<InboxMessageFailed>>>;
  /** A list of one or more messages that were successfully updated */
  success?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Payload containing the result of the updateShipmentLabelViewedStateForAsks mutation */
export type UpdateShipmentLabelPayload = {
  /** The result of the mutation */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for updateShipmentLabelViewedStateForAsks mutation */
export type UpdateShipmentLabelViewedInput = {
  /** Asks to change the state */
  items?: InputMaybe<Array<InputMaybe<UpdateShipmentLabelViewedItemInput>>>;
};

/** Ask data for updateShipmentLabelViewedStateForAsks mutation */
export type UpdateShipmentLabelViewedItemInput = {
  /** Action that needs to be performed under the portfolio item. */
  action?: InputMaybe<UpdateLabelAction>;
  /** Portfolio Item chain id */
  chainId?: InputMaybe<Scalars['String']['input']>;
};

/** UpdatedAt filter definition */
export type UpdatedAtFilterInput = {
  gte?: InputMaybe<Scalars['ISODate']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type User = {
  /** Account information for the user */
  account?: Maybe<Account>;
  /** A sorted list for auditing purposes with historical changes to the user's addresses */
  addressAudit?: Maybe<Array<Maybe<AddressAuditHistoryEntry>>>;
  /** List of user authentication (identity) providers */
  allAuthProviders?: Maybe<Array<Maybe<AuthProvider>>>;
  /**
   * Gets a group of products base on user, vertical and selection type
   * @deprecated Use 'Query.allProducts' instead.
   */
  allProducts?: Maybe<ProductsConnection>;
  /** Product variant Shipment Labels */
  allShipmentLabels?: Maybe<Array<Maybe<ShipmentLabel>>>;
  /** array of undeliverable locations */
  allUndeliverableLocations?: Maybe<Array<Maybe<UndeliverableLocation>>>;
  /** A product the user is selling or has sold */
  ask?: Maybe<Ask>;
  /** A product the user has sold */
  askByOrderNumber?: Maybe<Ask>;
  /** Multiple products that the user is selling or has sold */
  asks?: Maybe<AsksConnection>;
  /** A product the user is Bidding on */
  bid?: Maybe<Bid>;
  /** A product the user is selling or has sold */
  bids?: Maybe<BidsConnection>;
  /** A user's tier profile details for buyer role */
  buyerTierProfile?: Maybe<BuyerTierProfile>;
  /** The products the user is bidding on or has purchased */
  buying?: Maybe<BuyingConnection>;
  /** Compliance based data */
  compliance?: Maybe<Compliance>;
  /** Returns a single shipment based on tracking number, displayId, or uuid */
  delay?: Maybe<Delay>;
  /** Digital Ownership data by the user */
  digitalOwnership?: Maybe<OwnershipData>;
  /** All of a users digitally owned products */
  digitalOwnershipPortfolio?: Maybe<DigitalOwnershipPortfolioConnection>;
  /** A list of discount codes */
  discountCodes?: Maybe<DiscountCodesConnection>;
  /** User's email */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * Get experiment variants for the authenticated user and given deviceId from Leanplum.
   * @deprecated Use query-level LaunchDarkly experimentVariants or abTestVariants query
   */
  experimentVariants?: Maybe<Array<Maybe<ExperimentVariant>>>;
  /**
   * Get feature flags for the authenticated user and given deviceId from Leanplum.
   * @deprecated Use query-level LaunchDarkly featureflags query
   */
  featureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  /** User firstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** User fullName */
  fullName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use global homeLayout query. */
  homeScreenLayout?: Maybe<Array<Maybe<HomeLayoutComponent>>>;
  inbox?: Maybe<InboxMessagesConnection>;
  /** User language */
  language?: Maybe<Scalars['String']['output']>;
  /** User lastName */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Multiple products that are listed by user */
  listedProducts?: Maybe<ListedProductsConnection>;
  /** Fetch all listings for the given user */
  listings?: Maybe<ListingsConnection>;
  /** MFA configuration for the user */
  mfa?: Maybe<Mfa>;
  /** Order details (the connection between a bid and ask) */
  order?: Maybe<Order>;
  /** All of the orders that belong to the user */
  orders?: Maybe<Array<Maybe<Order>>>;
  /** Payment Accounts For the user */
  paymentAccounts?: Maybe<Array<Maybe<UserPaymentAccount>>>;
  /** A sorted list for auditing purposes with historical changes to the user's personal information */
  personalInformationAudit?: Maybe<
    Array<Maybe<PersonalInformationAuditHistoryEntry>>
  >;
  seller?: Maybe<Seller>;
  /** A list of seller promotions */
  sellerPromotions?: Maybe<Array<Maybe<SellerPromotion>>>;
  /** Queries a single shipment by shipmentID */
  shipment?: Maybe<Shipment>;
  /** Returns an array of shipments scoped to the actors jwt */
  shipments?: Maybe<ShipmentsConnection>;
  /** Tax based data */
  taxes?: Maybe<Taxes>;
  /** User's UUID */
  uuid?: Maybe<Scalars['ID']['output']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserAllProductsArgs = {
  requestedPage?: InputMaybe<AllProductPageInput>;
  type: ProductSelectionType;
  vertical?: InputMaybe<Vertical>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserAllShipmentLabelsArgs = {
  productUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserAllUndeliverableLocationsArgs = {
  countryBuyer?: InputMaybe<Scalars['String']['input']>;
  countryOfManufacture?: InputMaybe<Scalars['String']['input']>;
  postalCodeBuyer?: InputMaybe<Scalars['String']['input']>;
  productCategory?: InputMaybe<Vertical>;
  regionBuyer?: InputMaybe<Scalars['String']['input']>;
  secondaryCategory?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserAskArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
  id: Scalars['String']['input'];
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserAskByOrderNumberArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserAsksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<CurrencyCode>;
  filters?: InputMaybe<AsksFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<AscDescOrderInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AsksSortInput>;
  state?: InputMaybe<AsksGeneralState>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserBidArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserBidsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<CurrencyCode>;
  filters?: InputMaybe<BidsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<AscDescOrderInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BidsSortInput>;
  state?: InputMaybe<BidsGeneralState>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserBuyerTierProfileArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserBuyingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<CurrencyCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<AscDescOrderInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BuyingSortInput>;
  state?: InputMaybe<BuyingGeneralState>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserDelayArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserDigitalOwnershipArgs = {
  variantId?: InputMaybe<Scalars['String']['input']>;
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserDiscountCodesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserExperimentVariantsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserFeatureFlagsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserHomeScreenLayoutArgs = {
  vertical?: InputMaybe<Vertical>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserInboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InboxSortInput>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserListedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListedProductsFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ListedProductsSortOptions>;
  sortOrder?: InputMaybe<AscDescOrderInput>;
  state?: InputMaybe<AsksGeneralState>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserListingsArgs = {
  filters?: InputMaybe<ListingFiltersInput>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<AscDescOrderInput>;
  sortField?: InputMaybe<ListingsSortField>;
  state?: InputMaybe<AsksGeneralState>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserOrderArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserShipmentArgs = {
  shipmentId: Scalars['String']['input'];
};

/**
 * The User is the fundamental representation of the StockX graph. All questions
 * are put in terms of a user, and all answers are about users. There are two
 * viable representations of users: myself and another, where the former is
 * represented with Viewer and the latter with Introspector.
 */
export type UserShipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ShipmentOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ShipmentSortInput>;
};

/** Contains the saved addresses on file */
export type UserAddresses = {
  /** The shipping addresses saved on file */
  shipping?: Maybe<Array<Maybe<ShippingAddress>>>;
};

export type UserDeleteInput = {
  /** The user's email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating if the user lives in California or the EU */
  euOrCaResident?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The user's customer UUID */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Collection composed of user generated contents */
export type UserGeneratedContentCollection = {
  /** the instagram posts */
  entries?: Maybe<Array<Maybe<UserGeneratedContentEntry>>>;
  /** Collection subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Collection title */
  title?: Maybe<Scalars['String']['output']>;
  /** The track event that should be logged when the collection is loaded */
  trackingEvent?: Maybe<Scalars['String']['output']>;
};

/** The instagram post for displaying on homepage */
export type UserGeneratedContentEntry = {
  /** The user account who owns the photo. */
  creator?: Maybe<Scalars['String']['output']>;
  /** The user account profile photo who owns the photo */
  creatorProfilePhoto?: Maybe<ImageInformation>;
  /** The date the instagram post was published. */
  date?: Maybe<Scalars['ISODate']['output']>;
  /** The id to retrive content's products. */
  id?: Maybe<Scalars['String']['output']>;
  /** The image to display for the content. */
  image?: Maybe<ImageInformation>;
  /** Product ids that are mentioned in the instagram post. */
  products?: Maybe<Array<Maybe<Product>>>;
  /** The caption that content stack requires. */
  title?: Maybe<Scalars['String']['output']>;
  /** The tracking event to use for analytics purposes. */
  trackingEvent?: Maybe<Scalars['String']['output']>;
};

/** Mapping between user to its payment provider account */
export type UserPaymentAccount = {
  /** Payments ID for the provider account */
  id?: Maybe<Scalars['ID']['output']>;
  /** If this is the preferred payment account for the user */
  isPreferred?: Maybe<Scalars['Boolean']['output']>;
  /** Payment Provider ID For This Account Braintree Adyen JPMC */
  paymentProviderAccountId?: Maybe<Scalars['String']['output']>;
  /** Payment Provider For This Account Braintree Adyen JPMC */
  provider?: Maybe<PaymentProvider>;
  /** User this card belongs to */
  user?: Maybe<User>;
};

/** A single prize for a user */
export type UserPrize = {
  /** Campaign name when the prize was awarded */
  campaign?: Maybe<Scalars['String']['output']>;
  /** Description of the campaign when the prize was awarded */
  campaignDesc?: Maybe<Scalars['String']['output']>;
  /** The category the prize is a part of */
  category?: Maybe<Scalars['String']['output']>;
  /** The discount code */
  code?: Maybe<Scalars['String']['output']>;
  /** Body text when the prize is revealed */
  confirmationDesc?: Maybe<Scalars['String']['output']>;
  /** Disclaimer that comes with the prize */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Header when the prize is revealed */
  headerPostReveal?: Maybe<Scalars['String']['output']>;
  /** Header before the prize is revealed */
  headerPreReveal?: Maybe<Scalars['String']['output']>;
  /** The url that contains the image for the prize */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The description of the prize */
  name?: Maybe<Scalars['String']['output']>;
  /** Name of the prize type */
  prizeType?: Maybe<Scalars['String']['output']>;
  /** The shoe name if it exists, otherwise null */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the prize name */
  title?: Maybe<Scalars['String']['output']>;
  /** Gets the discount code uid if available */
  uid?: Maybe<Scalars['String']['output']>;
  /** Current state of the prize */
  validation?: Maybe<Scalars['String']['output']>;
  /** Prize discount prefix if awarded, money value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Possible Prize Update states */
export enum UserPrizeStateInput {
  /** User failed validation and does not receive prize */
  FAILED = 'FAILED',
  /** User receives the prize */
  SUCCESS = 'SUCCESS',
}

/** The user information captured at the time of the order */
export type UserSnapshot = {
  /** The address snapshot used for billing */
  billingAddress?: Maybe<OrderAddressSnapshot>;
  /** The email of the user at the time of the order */
  email?: Maybe<Scalars['String']['output']>;
  /** Additional information for the user */
  extendedUserInfo?: Maybe<User>;
  /** The address snapshot used for shipping */
  shippingAddress?: Maybe<OrderAddressSnapshot>;
};

/** UsesRemainingResponse is the structure that will return the number of uses remaining for a given discount code */
export type UsesResponse = {
  /** Flag to indicate if the adjustment is secure */
  secure?: Maybe<Scalars['Boolean']['output']>;
  /** The total number of uses for an adjustment */
  uses?: Maybe<Scalars['Int']['output']>;
  /** Number of remaining uses */
  usesRemaining?: Maybe<Scalars['Int']['output']>;
};

/** input for billing address validation */
export type ValidateBillingAddressInput = {
  /** Billing Address */
  billing?: InputMaybe<AddressInput>;
};

/** A variation of a product. Example: a size 7 yeezy vs a yeezy */
export type Variant = {
  /** Badges associated with this product */
  badges?: Maybe<Array<Maybe<Badge>>>;
  deliveryOptions?: Maybe<DeliveryOptions>;
  /** The state of a favorite item */
  favorite?: Maybe<Scalars['Boolean']['output']>;
  /** Product is followed */
  followed?: Maybe<Scalars['Boolean']['output']>;
  /** Grouping information for the variant. */
  group?: Maybe<VariantGroup>;
  /** Gtins */
  gtins?: Maybe<Array<Maybe<Gtin>>>;
  /** Is variant hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Variant ID */
  id: Scalars['String']['output'];
  /** MagentoId */
  magentoId?: Maybe<Scalars['Int']['output']>;
  /** Market data for the given variant. */
  market?: Maybe<Market>;
  /** Packaging information for the variant */
  packaging?: Maybe<VariantPackaging>;
  /** All the Pricing Guidance Available for a Product Variant */
  pricingGuidance?: Maybe<PricingGuidance>;
  /** Parent product of variant */
  product?: Maybe<Product>;
  /** Product UUID */
  productUuid?: Maybe<Scalars['String']['output']>;
  /** The reciprocal digital or physical variant. */
  reciprocal?: Maybe<Variant>;
  /** Sales chart data for the variant */
  salesChart?: Maybe<SalesChart>;
  /** Sizing information for the variant */
  sizeChart?: Maybe<SizeChart>;
  /** Sku ID */
  sku?: Maybe<Scalars['String']['output']>;
  /** Sort order */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** Total quantity of digital asset */
  totalEditions?: Maybe<Scalars['Int']['output']>;
  /** Traits of a variant (i.e. size) */
  traits?: Maybe<VariantTraits>;
  /** UPC Codes */
  upcs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A variation of a product. Example: a size 7 yeezy vs a yeezy */
export type VariantBadgesArgs = {
  market?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** A variation of a product. Example: a size 7 yeezy vs a yeezy */
export type VariantDeliveryOptionsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<CurrencyCode>;
  market?: InputMaybe<Scalars['String']['input']>;
};

/** A variation of a product. Example: a size 7 yeezy vs a yeezy */
export type VariantMarketArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
};

/** A variation of a product. Example: a size 7 yeezy vs a yeezy */
export type VariantPricingGuidanceArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<CurrencyCode>;
  market?: InputMaybe<Scalars['String']['input']>;
};

/** A variation of a product. Example: a size 7 yeezy vs a yeezy */
export type VariantSalesChartArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  intervals?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** Grouping information for a variant. */
export type VariantGroup = {
  /** The unique identifier for the group. */
  id?: Maybe<Scalars['String']['output']>;
  /** The name of the group. */
  name?: Maybe<Scalars['String']['output']>;
  /** The short code used to represent the group. */
  shortCode?: Maybe<Scalars['String']['output']>;
};

/** Packaging dimension and weight information about a variant. E.G. The size and weight of the shoebox+shoe that a sneaker comes in. */
export type VariantPackaging = {
  /** The depth or length of the package */
  depth?: Maybe<Scalars['Float']['output']>;
  /** The units used to measure the dimensions */
  dimensionUnits?: Maybe<DimensionUnit>;
  /** The height of the package */
  height?: Maybe<Scalars['Float']['output']>;
  /** How much the package weighs */
  weight?: Maybe<Scalars['Float']['output']>;
  /** The units used to measure the weight */
  weightUnits?: Maybe<WeightUnit>;
  /** The width of the package */
  width?: Maybe<Scalars['Float']['output']>;
};

/** Trait for a variant */
export type VariantTraits = {
  /** The available quantity of this variant */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Size of the variant */
  size?: Maybe<Scalars['String']['output']>;
  /** Descriptor used for size */
  sizeDescriptor?: Maybe<Scalars['String']['output']>;
};

/** The variant values under a product are one of these types */
export enum VariantType {
  BOX_AND_PAPERS = 'BOX_AND_PAPERS',
  GRADED = 'GRADED',
  SINGLE_SKU = 'SINGLE_SKU',
  SIZE = 'SIZE',
}

export type VaultingSession = {
  /** brands supported by the psp */
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** unique id for the session */
  id?: Maybe<Scalars['ID']['output']>;
  /** bool to inform the frontend whether 3ds check is required */
  isThreeDsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** a unique identifier to initialise the PSP SDK at frontend */
  nonce?: Maybe<Scalars['String']['output']>;
  /** payment service provider */
  provider?: Maybe<PaymentServiceProvider>;
  /**
   * update session with tokens
   *
   * We plan to support multiple token service providers,
   *
   * which have different parameters to be sent to the server to complete the vaulting process.
   */
  updateTokens?: Maybe<VaultingSession>;
};

export type VaultingSessionUpdateTokensArgs = {
  tokens?: InputMaybe<Array<InputMaybe<ProviderTokensInput>>>;
};

/** Verticals offered by StockX */
export enum Vertical {
  COLLECTIBLES = 'COLLECTIBLES',
  HANDBAGS = 'HANDBAGS',
  SNEAKERS = 'SNEAKERS',
  STREETWEAR = 'STREETWEAR',
  WATCHES = 'WATCHES',
}

export type VerticalsFilter = {
  /** Vertivals of the products. If specified will return asks of a specific verticals. */
  in?: InputMaybe<Array<Vertical>>;
};

/** Enum for units used to measure weight */
export enum WeightUnit {
  /** Ounces */
  OUNCES = 'OUNCES',
  /** Unknown Weight Units */
  UNKNOWN = 'UNKNOWN',
}

/** Input for deleting a message or messages */
export type DeleteInboxMessageInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filter for itemsExpiring */
export type ItemsExpiringFilter = {
  within?: InputMaybe<TimeConstraint>;
};

/** Input for marking a message or messages as read */
export type MarkReadInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filter for percentageOfItemsFailedToShip */
export type PercentageOfItemsFailedToShipFilter = {
  within?: InputMaybe<TimeConstraint>;
};

/** Filter for percentageOfItems */
export type PercentageOfItemsFilter = {
  in?: InputMaybe<AsksGeneralState>;
};

/** Filter for percentageOfItemsShipped */
export type PercentageOfItemsShippedFilter = {
  within?: InputMaybe<TimeConstraint>;
};

/** Details around the publishing of an item */
export type PublishDetails = {
  /** What environment is the item published in */
  environment?: Maybe<Scalars['String']['output']>;
  /** Locale of the publish */
  locale?: Maybe<Scalars['String']['output']>;
  /** What time the publish happened */
  time?: Maybe<Scalars['String']['output']>;
  /** Who published the item */
  user?: Maybe<Scalars['String']['output']>;
};
